/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Groupthought.
 *
 * In order to use this file you will need to change
 * theme.js to theme.dev.js in /layout/theme.liquid
 *
 */
!(function (e, t, i, s, r, n, o, a, l, c, h) {
  "use strict";
  function d(e) {
    var t = Object.create(null);
    return (
      e &&
        Object.keys(e).forEach(function (i) {
          if ("default" !== i) {
            var s = Object.getOwnPropertyDescriptor(e, i);
            Object.defineProperty(
              t,
              i,
              s.get
                ? s
                : {
                    enumerable: !0,
                    get: function () {
                      return e[i];
                    },
                  }
            );
          }
        }),
      (t.default = e),
      Object.freeze(t)
    );
  }
  var u = d(r);
  function p(e) {
    const t = e.querySelectorAll("[data-modal]"),
      i = document.querySelector("[data-modal-container]");
    t.forEach((e) => {
      i.querySelector(`[id="${e.id}"]`) || i.appendChild(e);
    });
  }
  function m(e) {
    e.querySelectorAll(".float__wrapper").forEach((e) => {
      const t = e.querySelector("label"),
        i = e.querySelector("input, textarea");
      t &&
        i.addEventListener("keyup", (e) => {
          "" !== e.target.value
            ? t.classList.add("label--float")
            : t.classList.remove("label--float");
        }),
        i && i.value && i.value.length && t.classList.add("label--float");
    });
  }
  function f(e) {
    e.querySelectorAll(".errors").forEach((e) => {
      e.setAttribute("tabindex", "0"),
        e.setAttribute("aria-live", "assertive"),
        e.setAttribute("role", "alert");
    });
  }
  function g(e) {
    e.querySelectorAll("img").forEach((e) => {
      e.complete && e.parentNode.classList.remove("loading-shimmer");
    });
  }
  function y() {
    const e = {};
    return (
      (e.windowHeight = window.innerHeight),
      (e.announcementHeight = w("[data-announcement-bar]")),
      (e.toolbarHeight = w("[data-toolbar-height]")),
      (e.footerHeight = w('[data-section-type*="footer"]')),
      (e.menuHeight = w("[data-header-height]")),
      (e.headerHeight = e.menuHeight + e.announcementHeight),
      (e.logoHeight = (function () {
        const e = w("[data-footer-logo]");
        return e > 0 ? e + 20 : 0;
      })()),
      (e.stickyHeader = document.querySelector('[data-header-sticky="sticky"]')
        ? e.menuHeight
        : 0),
      (e.backfillHeight = w("[data-header-backfill]")),
      e
    );
  }
  function v() {
    document.addEventListener("theme:resize", b),
      (function () {
        const {
          windowHeight: e,
          announcementHeight: t,
          toolbarHeight: i,
          headerHeight: s,
          logoHeight: r,
          menuHeight: n,
          footerHeight: o,
          stickyHeader: a,
          backfillHeight: l,
        } = y();
        document.documentElement.style.setProperty(
          "--scrollbar-width",
          `${S()}px`
        ),
          document.documentElement.style.setProperty("--footer-logo", `${r}px`),
          document.documentElement.style.setProperty("--full-screen", `${e}px`),
          document.documentElement.style.setProperty(
            "--three-quarters",
            0.75 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--two-thirds",
            0.66 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--one-half",
            0.5 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--one-third",
            0.33 * e + "px"
          ),
          document.documentElement.style.setProperty(
            "--one-fifth",
            0.2 * e + "px"
          ),
          document.documentElement.style.setProperty("--menu-height", `${n}px`),
          document.documentElement.style.setProperty(
            "--announcement-height",
            `${t}px`
          ),
          document.documentElement.style.setProperty(
            "--toolbar-height",
            `${i}px`
          ),
          document.documentElement.style.setProperty(
            "--header-height",
            `${s}px`
          ),
          document.documentElement.style.setProperty(
            "--footer-height",
            `${o}px`
          ),
          document.documentElement.style.setProperty(
            "--content-full",
            e - s - r / 2 + "px"
          ),
          document.documentElement.style.setProperty(
            "--menu-height-sticky",
            `${a}px`
          );
        let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", c);
      })();
  }
  function b() {
    const {
      windowHeight: e,
      announcementHeight: t,
      toolbarHeight: i,
      headerHeight: s,
      logoHeight: r,
      menuHeight: n,
      footerHeight: o,
      stickyHeader: a,
      backfillHeight: l,
    } = y();
    document.documentElement.style.setProperty("--scrollbar-width", `${S()}px`),
      document.documentElement.style.setProperty("--full-screen", `${e}px`),
      document.documentElement.style.setProperty("--menu-height", `${n}px`),
      document.documentElement.style.setProperty(
        "--announcement-height",
        `${t}px`
      ),
      document.documentElement.style.setProperty("--toolbar-height", `${i}px`),
      document.documentElement.style.setProperty("--header-height", `${s}px`),
      document.documentElement.style.setProperty("--footer-height", `${o}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        e - s - r / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--menu-height-sticky",
        `${a}px`
      );
    let c = Math.abs(l - n) > 1 ? `${n}px` : "auto";
    document.documentElement.style.setProperty("--menu-backfill-height", c);
  }
  function w(e) {
    const t = document.querySelector(e);
    return t ? t.clientHeight : 0;
  }
  function S() {
    const e = document.createElement("div");
    (e.style.visibility = "hidden"),
      (e.style.overflow = "scroll"),
      (e.style.msOverflowStyle = "scrollbar"),
      document.body.appendChild(e);
    const t = document.createElement("div");
    e.appendChild(t);
    const i = e.offsetWidth - t.offsetWidth;
    return e.parentNode.removeChild(e), i;
  }
  function E(e, t) {
    let i = 64,
      s = 0;
    t.forEach((e) => {
      if (e.offsetHeight > s) {
        const t =
          parseInt(window.getComputedStyle(e).marginTop) +
          parseInt(window.getComputedStyle(e).marginBottom);
        t > i && (i = t), (s = e.offsetHeight);
      }
    });
    const r = e.querySelectorAll("[data-overflow-background]");
    [e, ...r].forEach((e) => {
      e.style.setProperty(
        "min-height",
        `calc(${s + i}px + var(--menu-height))`
      );
    });
  }
  function L(e) {
    let t = document.querySelector("[data-footer-logo]")
      ? document.querySelector("[data-footer-logo]").clientHeight + 20
      : 0;
    const i = document.querySelector(
        "#MainContent .shopify-section:last-child [data-section-id]"
      ),
      s = i ? i.getAttribute("data-section-id") : null;
    if (
      (((null !== s && e.getAttribute("data-section-id") !== s) || !i) &&
        (t = 0),
      window.innerWidth < window.theme.sizes.medium)
    ) {
      return void e.querySelectorAll("[data-overflow-frame]").forEach((e) => {
        const t = e.querySelectorAll("[data-overflow-content]");
        E(e, t);
      });
    }
    const r = document.createElement("div");
    e.prepend(r),
      (r.style.display = "none"),
      (r.style.width = getComputedStyle(e).getPropertyValue("--outer"));
    const n = 2 * parseInt(getComputedStyle(r).getPropertyValue("width"));
    e.firstChild.remove();
    let o = 0;
    const a = e.querySelectorAll("[data-overflow-frame]");
    e.querySelectorAll("[data-overflow-content]").forEach((e) => {
      e.offsetHeight > o && (o = e.offsetHeight);
    });
    [...a, ...e.querySelectorAll("[data-overflow-background]")].forEach((e) => {
      e.style.setProperty("min-height", `${o + n}px`);
    }),
      e.style.setProperty("min-height", `${o + n + 2 + t}px`);
  }
  function k(e) {
    const i = e.querySelectorAll(".js-overflow-container");
    if (i) {
      i.forEach((e) => {
        const t = e.querySelectorAll(".js-overflow-content");
        E(e, t),
          document.addEventListener("theme:resize", () => {
            E(e, t);
          });
      });
      const s = e.querySelectorAll("[data-slideshow-wrapper]");
      s.length &&
        s.forEach((e) => {
          const i = t.data(e);
          void 0 !== i && i.reloadCells();
        });
    }
    const s = e.querySelectorAll("[data-overflow-wrapper]");
    s &&
      s.forEach((e) => {
        L(e),
          document.addEventListener("theme:resize", () => {
            L(e);
          });
      });
  }
  function T(e, t = 500, i = !1) {
    var s, r, n, o, a;
    function l() {
      var c = Date.now() - o;
      c < t && c >= 0
        ? (s = setTimeout(l, t - c))
        : ((s = null), i || ((a = e.apply(n, r)), (n = r = null)));
    }
    null == t && (t = 100);
    var c = function () {
      (n = this), (r = arguments), (o = Date.now());
      var c = i && !s;
      return (
        s || (s = setTimeout(l, t)),
        c && ((a = e.apply(n, r)), (n = r = null)),
        a
      );
    };
    return (
      (c.clear = function () {
        s && (clearTimeout(s), (s = null));
      }),
      (c.flush = function () {
        s && ((a = e.apply(n, r)), (n = r = null), clearTimeout(s), (s = null));
      }),
      c
    );
  }
  !(function () {
    const e = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, e)
        );
    } catch (e) {}
    globalThis.process = { env: e };
  })(),
    (window.requestIdleCallback =
      window.requestIdleCallback ||
      function (e) {
        var t = Date.now();
        return setTimeout(function () {
          e({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - t));
            },
          });
        }, 1);
      }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (e) {
        clearTimeout(e);
      });
  let x,
    _ = window.innerWidth,
    A = window.innerHeight;
  function q() {
    document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      _ !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", { bubbles: !0 })
        ),
        (_ = window.innerWidth)),
      A !== window.innerHeight &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:height", { bubbles: !0 })
        ),
        (A = window.innerHeight));
  }
  let C = window.pageYOffset,
    P = null,
    $ = null,
    M = null,
    I = null,
    D = 0;
  function O() {
    const e = window.pageYOffset;
    e > C
      ? (($ = !0), (P = !1))
      : e < C
      ? (($ = !1), (P = !0))
      : ((P = null), ($ = null)),
      (C = e),
      document.dispatchEvent(
        new CustomEvent("theme:scroll", {
          detail: { up: P, down: $, position: e },
          bubbles: !1,
        })
      ),
      P &&
        !M &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:up", {
            detail: { position: e },
            bubbles: !1,
          })
        ),
      $ &&
        !I &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:down", {
            detail: { position: e },
            bubbles: !1,
          })
        ),
      (I = $),
      (M = P);
  }
  function H(e) {
    setTimeout(() => {
      D && clearTimeout(D),
        i.disablePageScroll(e.detail, {
          allowTouchMove: (e) => "TEXTAREA" === e.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function F(e) {
    const t = e.detail;
    t ? (D = setTimeout(B, t)) : B();
  }
  function B() {
    i.clearQueueScrollLocks(),
      i.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const W = "time",
    N = "[data-days]",
    R = "[data-hours]",
    j = "[data-minutes]",
    z = "[data-seconds]",
    V = ".shopify-section",
    U = "data-expiration-behavior",
    J = "show-message",
    G = "hidden",
    Q = "hide-section",
    Y = "show-message";
  class X extends HTMLElement {
    constructor() {
      super(),
        (this.shopifySection = this.closest(V)),
        (this.expirationBehavior = this.getAttribute(U)),
        (this.time = this.querySelector(W)),
        (this.days = this.querySelector(N)),
        (this.hours = this.querySelector(R)),
        (this.minutes = this.querySelector(j)),
        (this.seconds = this.querySelector(z)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete = this.expirationBehavior === Q),
        (this.shouldShowMessage = this.expirationBehavior === Y),
        (this.update = this.update.bind(this));
    }
    connectedCallback() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.interval = setInterval(this.update, 1e3));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(e) {
      const t = this.formatDigits(parseInt(e / this.daysInMs, 10));
      e -= t * this.daysInMs;
      const i = this.formatDigits(parseInt(e / this.hoursInMs, 10));
      e -= i * this.hoursInMs;
      const s = this.formatDigits(parseInt(e / this.minutesInMs, 10));
      e -= s * this.minutesInMs;
      return {
        days: t,
        hours: i,
        minutes: s,
        seconds: this.formatDigits(parseInt(e / this.secondsInMs, 10)),
      };
    }
    formatDigits(e) {
      return e < 10 && (e = "0" + e), e;
    }
    render(e) {
      (this.days.textContent = e.days),
        (this.hours.textContent = e.hours),
        (this.minutes.textContent = e.minutes),
        (this.seconds.textContent = e.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete && this.shopifySection.classList.add(G),
        this.shouldShowMessage && this.classList.add(J);
    }
    update() {
      const e = new Date().getTime(),
        t = this.endDate - e;
      t <= 0 && (this.stopTimer(), this.onComplete());
      const i = this.convertTime(t);
      this.render(i);
    }
  }
  window.addEventListener("resize", () => {
    x && window.cancelAnimationFrame(x),
      (x = window.requestAnimationFrame(T(q, 50)));
  }),
    (function () {
      let e;
      window.addEventListener(
        "scroll",
        function () {
          e && window.cancelAnimationFrame(e),
            (e = window.requestAnimationFrame(O));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", H),
        window.addEventListener("theme:scroll:unlock", F);
    })(),
    g(document),
    document.addEventListener(
      "load",
      (e) => {
        !(function (e) {
          "IMG" == e.tagName &&
            e.parentNode.classList.contains("loading-shimmer") &&
            e.parentNode.classList.remove("loading-shimmer");
        })(e.target);
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      v(),
        m(document),
        f(document),
        p(document),
        window.theme.settings.animate_scroll && e.refresh();
    }),
    window.addEventListener("load", () => {
      k(document), g(document);
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const i = t.target;
      m(i),
        f(i),
        p(i),
        k(i),
        window.theme.settings.animate_scroll && e.refresh();
    }),
    document.addEventListener("shopify:section:reorder", () => {
      document.dispatchEvent(
        new CustomEvent("theme:header:check", { bubbles: !1 })
      );
    }),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", X);
  const K = (e, t = !1, i = "block") => {
    e && (t ? e.style.removeProperty("display") : (e.style.display = i));
  };
  function Z(e) {
    (this.status = e.status || null),
      (this.headers = e.headers || null),
      (this.json = e.json || null),
      (this.body = e.body || null);
  }
  Z.prototype = Error.prototype;
  const ee = "data-scrollbar-slider",
    te = "[data-scrollbar-arrow-prev]",
    ie = "[data-scrollbar-arrow-next]",
    se = "is-hidden",
    re = 200;
  class ne {
    constructor(e) {
      (this.scrollbar = e),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(ie)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(te)),
        this.init(),
        this.resize(),
        this.scrollbar.hasAttribute(ee) && this.scrollToVisibleElement();
    }
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(),
        this.events());
    }
    resize() {
      document.addEventListener("theme:resize", () => {
        window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow();
      });
    }
    events() {
      this.arrowNext.addEventListener("click", (e) => {
        e.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (e) => {
          e.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const e =
        this.scrollbar.getBoundingClientRect().width / 2 +
        this.scrollbar.scrollLeft;
      this.move(e), this.arrowPrev.classList.remove(se), this.toggleNextArrow();
    }
    goToPrev() {
      const e =
        this.scrollbar.scrollLeft -
        this.scrollbar.getBoundingClientRect().width / 2;
      this.move(e), this.arrowNext.classList.remove(se), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        window.isRTL
          ? this.arrowNext.classList.toggle(se, 0 === this.scrollbar.scrollLeft)
          : this.arrowNext.classList.toggle(
              se,
              Math.round(
                this.scrollbar.scrollLeft +
                  this.scrollbar.getBoundingClientRect().width +
                  1
              ) >= this.scrollbar.scrollWidth
            );
      }, re);
    }
    togglePrevArrow() {
      setTimeout(() => {
        window.isRTL
          ? this.arrowPrev.classList.toggle(
              se,
              Math.abs(this.scrollbar.scrollLeft) +
                this.scrollbar.getBoundingClientRect().width +
                1 >=
                this.scrollbar.scrollWidth
            )
          : this.arrowPrev.classList.toggle(se, this.scrollbar.scrollLeft <= 0);
      }, re);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (e) => {
        e.addEventListener("click", (t) => {
          ("a" === t.target.tagName.toLowerCase() ||
            (t.currentTarget &&
              "a" === t.currentTarget.tagName.toLowerCase()) ||
            (t.currentTarget && t.currentTarget.querySelector("a"))) &&
            t.preventDefault(),
            this.move(e.offsetLeft - e.clientWidth);
        });
      });
    }
    move(e) {
      this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
    }
  }
  const oe = "[data-sibling-inner]";
  class ae {
    constructor(e) {
      (this.siblings = e.querySelectorAll(oe)), this.init();
    }
    init() {
      this.siblings.forEach((e) => {
        new ne(e);
      });
    }
  }
  const le = {
      onLoad() {
        new ae(this.container);
      },
    },
    ce = { expires: 7, path: "/", domain: window.location.hostname };
  class he {
    constructor(e = {}) {
      this.options = { ...ce, ...e };
    }
    write(e) {
      document.cookie = `${this.options.name}=${e}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
    }
    read() {
      let e = [];
      const t = document.cookie
        .split("; ")
        .find((e) => e.startsWith(this.options.name));
      if (-1 !== document.cookie.indexOf("; ") && t) {
        const t = document.cookie
          .split("; ")
          .find((e) => e.startsWith(this.options.name))
          .split("=")[1];
        null !== t && (e = t.split(","));
      }
      return e;
    }
    destroy() {
      document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
    }
    remove(e) {
      const t = this.read(),
        i = t.indexOf(e);
      -1 !== i && (t.splice(i, 1), this.write(t));
    }
  }
  const de = 4,
    ue = 10,
    pe = "[data-recently-viewed-products]",
    me = "data-limit",
    fe = "[data-recent-link-tab]",
    ge = "[data-recent-wrapper]",
    ye = "[data-recently-viewed-tab]",
    ve = "[data-tabs-holder-scroll]",
    be = "[data-api-content]",
    we = "data-minimum",
    Se = "data-item-id",
    Ee = "hide",
    Le = "section-without-title--skip",
    ke = { expires: 90, name: "shopify_recently_viewed" },
    Te = [],
    xe = [];
  class _e {
    constructor(e) {
      (this.container = e.container),
        (this.cookie = new he(ke)),
        (this.wrapper = this.container.querySelector(pe)),
        null !== this.wrapper &&
          ((this.howManyToShow =
            parseInt(this.container.querySelector(ge).getAttribute(me)) || de),
          (this.minimum = parseInt(
            this.container.querySelector(ge).getAttribute(we)
          )),
          (this.recentViewedTab = this.container.querySelector(ye)),
          (this.recentViewedLink = this.container.querySelector(fe)),
          (this.tabsHolderScroll = this.container.querySelector(ve)),
          this.renderProducts());
    }
    renderProducts() {
      const e = this.cookie.read(),
        t = [];
      let i = 0;
      if (e.length > 0) {
        for (let s = 0; s < e.length; s++) {
          const r = e[s];
          if (xe.includes(r)) continue;
          const n = `${window.theme.routes.root_url}products/${r}?section_id=api-product-grid-item`;
          if ((t.push(n), i++, i === this.howManyToShow || i === e.length - 1))
            break;
        }
        if (t.length > 0 && t.length >= this.minimum) {
          this.container.classList.remove(Ee),
            this.recentViewedLink &&
              this.recentViewedLink.previousElementSibling &&
              (this.tabsHolderScroll.classList.remove(Ee),
              this.container.classList.add(Le));
          const e = t.map((e) =>
              fetch(e, { mode: "no-cors" }).then(this.handleErrors)
            ),
            i = [];
          Promise.allSettled(e)
            .then((e) =>
              Promise.all(
                e.map(async (e) => {
                  "fulfilled" === e.status && i.push(await e.value.text());
                })
              )
            )
            .then(() => {
              i.forEach((e) => {
                const t = document.createElement("div"),
                  i = document.createElement("div");
                t.innerHTML = e;
                "" === t.querySelector(`[${Se}]`).getAttribute(Se) ||
                  (i.classList.add("product-grid-slide"),
                  i.setAttribute("data-carousel-slide", null),
                  i.setAttribute("data-item", null),
                  (i.innerHTML = t.querySelector(be).innerHTML),
                  this.wrapper.appendChild(i));
              }),
                new ae(this.container);
            })
            .then(() => {
              K(this.wrapper, !0),
                this.container.dispatchEvent(
                  new CustomEvent("theme:recent-products:added", {
                    bubbles: !0,
                  })
                );
            });
        } else if (this.recentViewedTab) {
          const e =
            Array.prototype.filter.call(
              this.recentViewedTab.parentNode.children,
              (e) => e !== this.recentViewedTab
            ).length > 1;
          this.recentViewedLink &&
            this.recentViewedLink.previousElementSibling &&
            (this.tabsHolderScroll.classList.add(Ee),
            this.container.classList.remove(Le)),
            e || this.container.classList.add(Ee);
        } else this.container.classList.add(Ee);
      }
    }
    handleErrors(e) {
      return e.ok
        ? e
        : e.text().then(function (t) {
            throw new Z({ status: e.statusText, headers: e.headers, text: t });
          });
    }
  }
  class Ae {
    constructor(e) {
      (this.handle = e),
        (this.cookie = new he(ke)),
        void 0 !== this.handle && (xe.push(this.handle), this.updateCookie());
    }
    updateCookie() {
      let e = this.cookie.read();
      const t = e.indexOf(this.handle);
      -1 === t
        ? (e.unshift(this.handle), (e = e.splice(0, ue)))
        : (e.splice(t, 1), e.unshift(this.handle)),
        this.cookie.write(e);
    }
  }
  const qe = {
    onLoad() {
      Te[this.id] = new _e(this);
    },
  };
  function Ce() {
    const e = "(any-pointer: coarse)",
      t = `(max-width: ${window.theme.sizes.medium}px)`,
      i = `(min-width: ${window.theme.sizes.medium + 1}px) and (max-width: ${
        window.theme.sizes.large
      }px)`,
      s = `(min-width: ${window.theme.sizes.large + 1}px)`;
    (Ce.isTouch = () => {
      const t = window.matchMedia(e).matches;
      return document.documentElement.classList.toggle("supports-touch", t), t;
    }),
      (Ce.isMobile = () => window.matchMedia(t).matches),
      (Ce.isTablet = () => window.matchMedia(i).matches),
      (Ce.isDesktop = () => window.matchMedia(s).matches);
    const r = [
      [e, Ce.isTouch],
      [t, Ce.isMobile],
      [i, Ce.isTablet],
      [s, Ce.isDesktop],
    ];
    Ce.onChange = (e) => {
      r.forEach((t) => {
        window.matchMedia(t[0]).addEventListener("change", () => {
          t[1]() && e && e();
        });
      });
    };
  }
  function Pe() {
    this.entries = [];
  }
  function $e(e, t) {
    Me(e);
    var i = (function (e, t) {
      Me(e),
        (function (e) {
          if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
          if (0 === e.length) throw new Error(e + " is empty.");
          if (!e[0].hasOwnProperty("name"))
            throw new Error(e[0] + "does not contain name key.");
          if ("string" != typeof e[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                e[0].name +
                ". Value should be string."
            );
        })(t);
      var i = [];
      return (
        t.forEach(function (t) {
          for (var s = 0; s < e.options.length; s++) {
            if (
              (e.options[s].name || e.options[s]).toLowerCase() ===
              t.name.toLowerCase()
            ) {
              i[s] = t.value;
              break;
            }
          }
        }),
        i
      );
    })(e, t);
    return (function (e, t) {
      Me(e),
        (function (e) {
          if (Array.isArray(e) && "object" == typeof e[0])
            throw new Error(e + "is not a valid array of options.");
        })(t);
      var i = e.variants.filter(function (e) {
        return t.every(function (t, i) {
          return e.options[i] === t;
        });
      });
      return i[0] || null;
    })(e, i);
  }
  function Me(e) {
    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
    if (0 === Object.keys(e).length && e.constructor === Object)
      throw new Error(e + " is empty.");
  }
  Ce(),
    (Pe.prototype.add = function (e, t, i) {
      this.entries.push({ element: e, event: t, fn: i }),
        e.addEventListener(t, i);
    }),
    (Pe.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (e) {
        return e.element.removeEventListener(e.event, e.fn), !1;
      });
    });
  var Ie = '[name="id"]',
    De = '[name="selling_plan"]',
    Oe = '[name^="options"]',
    He = '[name="quantity"]',
    Fe = '[name^="properties"]';
  class Be {
    constructor(e, t, i, s) {
      (this.element = e),
        (this.form = "FORM" == t.tagName ? t : t.querySelector("form")),
        (this.product = this._validateProductObject(i)),
        (this.variantElement = this.form.querySelector(Ie)),
        (s = s || {}),
        (this.clickedElement = null),
        (this._listeners = new Pe()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, s)
        ),
        (this.optionInputs = this._initInputs(Oe, s.onOptionChange)),
        (this.planInputs = this._initInputs(De, s.onPlanChange)),
        (this.quantityInputs = this._initInputs(He, s.onQuantityChange)),
        (this.propertyInputs = this._initInputs(Fe, s.onPropertyChange));
    }
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (e) {
        return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
      });
    }
    variant() {
      const e = this.options();
      return e.length ? $e(this.product, e) : this.product.variants[0];
    }
    plan(e) {
      let t = { allocation: null, group: null, detail: null };
      const i = new FormData(this.form).get("selling_plan");
      if (
        e &&
        e.selling_plan_allocations &&
        e.selling_plan_allocations.length > 0
      ) {
        const t = [
            ...new Set(
              e.selling_plan_allocations.map((e) => e.selling_plan_group_id)
            ),
          ],
          i = this.element.querySelectorAll("[data-subscription-group]");
        if (!i.length) return;
        i.forEach((e) => (e.style.display = "none")),
          t.forEach((e) => {
            this.element.querySelector(
              `[data-selling-plan-group="${e}"]`
            ).style.display = "block";
          });
      }
      return (
        i &&
          e &&
          (t.allocation = e.selling_plan_allocations.find(function (e) {
            return e.selling_plan_id.toString() === i.toString();
          })),
        t.allocation &&
          (t.group = this.product.selling_plan_groups.find(function (e) {
            return (
              e.id.toString() === t.allocation.selling_plan_group_id.toString()
            );
          })),
        t.group &&
          (t.detail = t.group.selling_plans.find(function (e) {
            return e.id.toString() === i.toString();
          })),
        t && t.allocation && t.detail && t.allocation ? t : null
      );
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (e) {
        return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      const e = this.variant();
      return {
        options: this.options(),
        variant: e,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(e),
      };
    }
    _setIdInputValue(e) {
      e && e.id
        ? (this.variantElement.value = e.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(e, t) {
      (t.dataset = this.getFormState()), e.onFormSubmit && e.onFormSubmit(t);
    }
    _onOptionChange(e) {
      this._setIdInputValue(e.dataset.variant);
    }
    _onFormEvent(e) {
      return void 0 === e
        ? Function.prototype
        : function (t) {
            (t.dataset = this.getFormState()),
              this._setIdInputValue(t.dataset.variant),
              e(t);
          }.bind(this);
    }
    _initInputs(e, t) {
      return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
        function (e) {
          return this._listeners.add(e, "change", this._onFormEvent(t)), e;
        }.bind(this)
      );
    }
    _serializeInputValues(e, t) {
      return e.reduce(function (e, i) {
        return (
          (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
            e.push(t({ name: i.name, value: i.value })),
          e
        );
      }, []);
    }
    _validateProductObject(e) {
      if ("object" != typeof e) throw new TypeError(e + " is not an object.");
      if (void 0 === e.variants[0].options)
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return e;
    }
  }
  const We = {};
  function Ne(e = {}) {
    if ((e.type || (e.type = "json"), e.url))
      return We[e.url]
        ? We[e.url]
        : (function (e, t) {
            const i = new Promise((i, s) => {
              "text" === t
                ? fetch(e)
                    .then((e) => e.text())
                    .then((e) => {
                      i(e);
                    })
                    .catch((e) => {
                      s(e);
                    })
                : (function (e, t, i) {
                    let s = document.getElementsByTagName("head")[0],
                      r = !1,
                      n = document.createElement("script");
                    (n.src = e),
                      (n.onload = n.onreadystatechange =
                        function () {
                          r ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? i()
                            : ((r = !0), t());
                        }),
                      s.appendChild(n);
                  })(
                    e,
                    function () {
                      i();
                    },
                    function () {
                      s();
                    }
                  );
            });
            return (We[e] = i), i;
          })(e.url, e.type);
    if (e.json) {
      if (We[e.json]) return Promise.resolve(We[e.json]);
      {
        const t = window
          .fetch(e.json)
          .then((e) => e.json())
          .then((t) => ((We[e.json] = t), t))
          .catch((t) => {
            We[e.json] = null;
          });
        return (We[e.json] = t), t;
      }
    }
    if (e.name) {
      const t = "".concat(e.name, e.version);
      return We[t]
        ? We[t]
        : (function (e) {
            const t = "".concat(e.name, e.version),
              i = new Promise((t, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: e.name,
                      version: e.version,
                      onLoad: (e) => {
                        !(function (e, t, i) {
                          i ? t(i) : e();
                        })(t, i, e);
                      },
                    },
                  ]);
                } catch (e) {
                  i(e);
                }
              });
            return (We[t] = i), i;
          })(e);
    }
    return Promise.reject();
  }
  const Re = "[data-swapper-wrapper]",
    je = "[data-swapper-target]",
    ze = "data-swapper-hover";
  let Ve = {};
  class Ue {
    constructor(e) {
      (this.container = e),
        (this.target = this.container.querySelector(je)),
        (this.hovers = this.container.querySelectorAll(`[${ze}]`)),
        this.target &&
          this.hovers.length &&
          ((this.deafaultContent = this.target.innerHTML), this.init());
    }
    init() {
      this.hovers.forEach((e) => {
        e.addEventListener(
          "mouseenter",
          function () {
            const t = e.getAttribute(ze);
            this.target.innerHTML = `${t}`;
          }.bind(this)
        );
      }),
        this.hovers.forEach((e) => {
          e.addEventListener(
            "mouseleave",
            function () {
              this.target.innerHTML = this.deafaultContent;
            }.bind(this)
          );
        }),
        this.hovers.forEach((e) => {
          e.addEventListener(
            "click",
            function () {
              const t = e.getAttribute(ze);
              this.deafaultContent = `${t}`;
            }.bind(this)
          );
        });
    }
  }
  function Je(e) {
    Ve[e.id] = [];
    e.querySelectorAll(Re).forEach((t) => {
      Ve[e.id].push(new Ue(t));
    });
  }
  const Ge = {
      onLoad() {
        Je(this.container);
      },
    },
    Qe = { color: "ash" },
    Ye = "data-swatch",
    Xe = "[data-grid-item]",
    Ke = "data-grid-image-default",
    Ze = "data-grid-image-target",
    et = "data-swatch-image",
    tt = "data-swatch-image-id",
    it = "data-swatch-variant",
    st = "[data-grid-swatches]",
    rt = "[data-swatch-template]",
    nt = "data-swatch-handle",
    ot = "data-swatch-label",
    at = "is-fade";
  class lt {
    constructor(e = {}) {
      (this.settings = { ...Qe, ...e }), (this.match = this.init());
    }
    getColor() {
      return this.match;
    }
    init() {
      return Ne({ json: window.theme.assets.swatches })
        .then((e) => this.matchColors(e, this.settings.color))
        .catch((e) => {
          console.log("failed to load swatch colors script"), console.log(e);
        });
    }
    matchColors(e, t) {
      let i = "#E5E5E5",
        s = null;
      const r = window.theme.assets.base || "/",
        n = t.toLowerCase().replace(/\s/g, ""),
        o = e.colors;
      if (o) {
        const e = (e) =>
            Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n,
          t = o.findIndex(e);
        if (t > -1) {
          const e = Object.values(o[t])[0],
            n = e.toLowerCase();
          n.includes(".jpg") ||
          n.includes(".jpeg") ||
          n.includes(".png") ||
          n.includes(".svg")
            ? ((s = `${r}${encodeURIComponent(e)}`), (i = "#888888"))
            : (i = e);
        }
      }
      return { color: this.settings.color, path: s, hex: i };
    }
  }
  class ct extends HTMLElement {
    constructor() {
      super(),
        (this.element = this.querySelector(`[${Ye}]`)),
        (this.colorString = this.element.getAttribute(Ye)),
        (this.image = this.element.getAttribute(et)),
        (this.imageId = this.element.getAttribute(tt)),
        (this.variant = this.element.getAttribute(it)),
        (this.outer = this.element.closest(Xe)),
        (this.media = null),
        (this.imageSlide = null),
        (this.imageDefault = null),
        (this.stopSlideAnimation = !1);
      new lt({ color: this.colorString }).getColor().then((e) => {
        (this.colorMatch = e), this.init();
      });
    }
    init() {
      this.setStyles(),
        this.variant &&
          this.outer &&
          this.outer.addEventListener("theme:quickview:media", (e) => {
            e && e.detail && e.detail.media && (this.media = e.detail.media);
          });
    }
    setStyles() {
      this.colorMatch.hex &&
        this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
        this.colorMatch.path &&
          (this.element.style.setProperty(
            "background-image",
            `url(${this.colorMatch.path})`
          ),
          this.element.style.setProperty("background-size", "cover"));
    }
    replaceImage() {
      if (this.imageReplace && this.imageSlide && this.imageId) {
        if (
          this.imageSlide.hasAttribute(Ze) &&
          this.imageSlide.getAttribute(Ze) !== this.imageId
        ) {
          this.imageSlide.classList.add(at);
          const e =
            1e3 *
            parseFloat(
              window
                .getComputedStyle(this.imageSlide)
                .getPropertyValue("animation-duration")
            );
          setTimeout(() => {
            this.imageSlide.classList.remove(at);
          }, e);
        }
        this.imageSlide.setAttribute(Ze, this.imageId),
          this.imageSlide.style.setProperty("background-color", "#fff"),
          this.imageSlide.hasAttribute(Ke) ||
            this.imageSlide.setAttribute(
              Ke,
              window.getComputedStyle(this.imageSlide).backgroundImage
            ),
          this.imageSlide.style.setProperty(
            "background-image",
            this.imageReplace
          );
      }
    }
  }
  class ht {
    constructor(e) {
      (this.template = document.querySelector(rt).innerHTML),
        (this.wrap = e),
        (this.handle = e.getAttribute(nt));
      const t = e.getAttribute(ot).trim().toLowerCase();
      (function (e) {
        const t = `${window.theme.routes.root_url}products/${e}.js`;
        return window
          .fetch(t)
          .then((e) => e.json())
          .catch((e) => {
            console.error(e);
          });
      })(this.handle).then((e) => {
        (this.product = e),
          (this.colorOption = e.options.find(function (e) {
            return e.name.toLowerCase() === t || null;
          })),
          this.colorOption &&
            ((this.swatches = this.colorOption.values), this.init());
      });
    }
    init() {
      (this.wrap.innerHTML = ""),
        this.swatches.forEach((e, t) => {
          let i = this.product.variants.find((t) => t.options.includes(e));
          const s = i.featured_media ? i.featured_media.preview_image.src : "",
            r = i.featured_media ? i.featured_media.id : "",
            n = Math.floor(9999 * Math.random());
          this.wrap.innerHTML += u.render(this.template, {
            color: e,
            uniq: `${this.product.id}-${i.id}-${n}`,
            variant: i.id,
            product_id: this.product.id,
            image_id: r,
            image: s,
            index: t,
          });
        }),
        new ne(this.wrap);
    }
  }
  function dt(e) {
    e.querySelectorAll(st).forEach((e) => {
      new ht(e);
    });
  }
  const ut = {
      onLoad() {
        dt(this.container), Je(this.container);
      },
    },
    pt = "[data-custom-scrollbar-items]",
    mt = "[data-custom-scrollbar]",
    ft = "[data-custom-scrollbar-track]",
    gt = "hide",
    yt = {};
  class vt {
    constructor(e, t = null) {
      (this.holderItems = e.querySelector(pt)),
        (this.scrollbar = e.querySelector(mt)),
        (this.scrollbarTrack = e.querySelector(ft)),
        (this.trackWidth = 0),
        (this.scrollWidth = 0),
        this.scrollbar &&
          this.holderItems &&
          ((this.children = t || this.holderItems.children),
          this.events(),
          this.calculateTrackWidth());
    }
    events() {
      this.holderItems.addEventListener(
        "scroll",
        this.calculatePosition.bind(this)
      ),
        this.holderItems.addEventListener(
          "theme:carousel:scroll",
          this.calculatePosition.bind(this)
        ),
        document.addEventListener(
          "theme:resize:width",
          this.calculateTrackWidth.bind(this)
        ),
        document.addEventListener(
          "theme:resize:width",
          this.calculatePosition.bind(this)
        );
    }
    calculateTrackWidth() {
      const e = document.createElement("div");
      this.holderItems.prepend(e),
        (e.style.display = "none"),
        (e.style.width = getComputedStyle(this.holderItems).getPropertyValue(
          "--outer"
        ));
      const t = parseInt(getComputedStyle(e).getPropertyValue("width"));
      this.holderItems.firstChild.remove(),
        (this.scrollbarWidth =
          0 === this.scrollbar.clientWidth
            ? this.scrollbar.parentNode.getBoundingClientRect().width
            : this.scrollbar.clientWidth),
        setTimeout(() => {
          const e = this.children[0].clientWidth,
            i = Number(
              getComputedStyle(this.children[0]).marginRight.replace("px", "")
            ),
            s = Number(
              getComputedStyle(this.children[0]).marginLeft.replace("px", "")
            );
          (this.scrollWidth = this.children.length * (e + i + s) + t - i),
            (this.trackWidth =
              ((this.scrollbarWidth + t) / this.scrollWidth) * 100),
            (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
            this.scrollbar.style.setProperty(
              "--track-width",
              `${this.trackWidth}%`
            );
          const r = Math.ceil(this.trackWidth) >= 100;
          this.scrollbar.classList.toggle(gt, r);
        }, 100);
    }
    calculatePosition() {
      let e =
        this.holderItems.scrollLeft /
        (this.holderItems.scrollWidth - this.holderItems.clientWidth);
      (e *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
        (e = e < 0 ? 0 : e),
        (e = isNaN(e) ? 0 : e),
        this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`),
        document.dispatchEvent(
          new CustomEvent("theme:scrollbar:scroll", {
            bubbles: !0,
            detail: { holder: this.holderItems },
          })
        );
    }
  }
  const bt = {
      onLoad() {
        yt[this.id] = new vt(this.container);
      },
    },
    wt = "[data-carousel]",
    St = "data-carousel-progress",
    Et = "[data-carousel-slide]",
    Lt = "[data-grid-slide]",
    kt = "product-grid-item-variant:not([hidden]) [data-grid-slide]",
    Tt = "[data-wrapper]",
    xt = "[data-carousel-track]",
    _t = "data-options",
    At = "data-custom-scrollbar-items",
    qt = ".flickity-button.previous",
    Ct = ".flickity-button.next",
    Pt = "data-recently-viewed-products",
    $t = "data-related-products",
    Mt = "[data-section-id]",
    It = "flickity-force-arrows-top",
    Dt = "not-moved-arrows",
    Ot = "hide",
    Ht = "flickity-enabled",
    Ft = "hidden-arrows",
    Bt = "flickity-static",
    Wt = 112;
  class Nt extends HTMLElement {
    constructor() {
      super(), (this.container = this);
    }
    connectedCallback() {
      (this.carousel = this.container.querySelector(wt)),
        (this.carouselTrack = this.container.querySelector(xt)),
        (this.wrapper = this.container.closest(Tt)),
        (this.section = this.container.closest(Mt)),
        (this.slidesVisible = null),
        (this.carouselInstance = null),
        (this.carouselPrev = null),
        (this.carouselNext = null),
        (this.customOptions = {}),
        (this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier()),
        this.carousel && this.carousel.hasAttribute(Pt)
          ? this.section.addEventListener("theme:recent-products:added", () => {
              this.init();
            })
          : this.carousel && this.carousel.hasAttribute($t)
          ? this.section.addEventListener(
              "theme:related-products:added",
              () => {
                this.init();
              }
            )
          : this.init();
    }
    init() {
      this.carousel &&
        ((this.slidesTotal = this.carousel.querySelectorAll(Et).length),
        this.getGridLayout(),
        this.trackVisibleSlides(),
        this.carousel.hasAttribute(_t) &&
          (this.customOptions = JSON.parse(
            decodeURIComponent(this.carousel.getAttribute(_t))
          )),
        this.initCarousel(),
        this.calculatedArrowsTopPosition(),
        this.toggleWrapperModifier(),
        document.addEventListener(
          "theme:resize:width",
          this.toggleWrapperModifierEvent
        ),
        this.carousel.hasAttribute(St) && this.progressBarCalculate(),
        this.carousel.hasAttribute(At) && new vt(this.container));
    }
    initCarousel() {
      (this.options = {
        accessibility: !0,
        contain: !0,
        freeScroll: !0,
        prevNextButtons: !0,
        wrapArround: !1,
        groupCells: !1,
        autoPlay: !1,
        pageDots: !1,
        cellAlign: window.isRTL ? "right" : "left",
        rightToLeft: window.isRTL,
        dragThreshold: 10,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 67.5, y2: 42.5, x3: 25 },
        on: {
          resize: () => {
            this.toggleArrows(),
              this.calculatedArrowsTopPosition(),
              setTimeout(() => {
                this.visibleSlides();
              }, 100);
          },
        },
        ...this.customOptions,
      }),
        (this.carouselInstance = new s(this.carousel, this.options)),
        (this.carouselPrev = this.carousel.querySelector(qt)),
        (this.carouselNext = this.carousel.querySelector(Ct)),
        this.container.addEventListener("theme:tab:change", () => {
          this.carouselInstance.resize(),
            (this.carouselPrev = this.carousel.querySelector(qt)),
            (this.carouselNext = this.carousel.querySelector(Ct));
        }),
        this.carouselInstance.on("dragStart", () => {
          (this.carouselInstance.slider.style.pointerEvents = "none"),
            Ce.isMobile || this.containDrag();
        }),
        this.carouselInstance.on("dragEnd", () => {
          (this.carouselInstance.slider.style.pointerEvents = "auto"),
            Ce.isMobile || this.containDrag();
        }),
        this.carouselInstance.on("change", (e) => this.lockArrows(e)),
        setTimeout(() => {
          this.visibleSlides();
        }, 100),
        Shopify.designMode &&
          setTimeout(() => {
            this.carouselInstance.options.watchCSS &&
            !this.carousel.classList.contains(Ht)
              ? (this.carouselInstance.destroy(),
                (this.carouselInstance = new s(this.carousel, this.options)),
                this.carouselInstance.resize(),
                (this.carouselPrev = this.carousel.querySelector(qt)),
                (this.carouselNext = this.carousel.querySelector(Ct)))
              : this.carouselInstance.resize();
          }, 10),
        this.carousel.classList.toggle(
          Bt,
          this.smallItems === this.carousel.querySelectorAll(Et).length
        ),
        dt(this.container),
        new ae(this.container);
    }
    calculatedArrowsTopPosition() {
      const e = this.container.querySelector(Lt),
        t = this.container.querySelector(kt);
      if (t) {
        const e = t.offsetHeight / 2;
        this.carousel.style.setProperty("--buttons-top", `${e}px`);
      } else if (e) {
        const t = e.offsetHeight / 2;
        this.carousel.style.setProperty("--buttons-top", `${t}px`);
      }
    }
    toggleWrapperModifier() {
      if (!this.wrapper) return;
      const e = Number(
          getComputedStyle(document.documentElement)
            .getPropertyValue("--scrollbar-width")
            .replace("px", "")
        ),
        t = this.wrapper.clientWidth;
      (this.wrapperWidthWithGutter = t + Wt + e),
        window.innerWidth >= this.wrapperWidthWithGutter &&
          (this.wrapper.classList.remove(It), this.section.classList.add(Dt)),
        window.innerWidth < this.wrapperWidthWithGutter &&
          (this.wrapper.classList.add(It), this.section.classList.remove(Dt));
    }
    progressBarCalculate() {
      null !== this.carouselInstance &&
        this.carouselTrack &&
        this.carouselInstance.on("scroll", (e) => {
          (e = 100 * Math.max(0, Math.min(1, e)) + "%"),
            (this.carouselTrack.style.width = e);
        });
    }
    getGridLayout() {
      (this.largeItems =
        Number(
          getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")
        ) || 3),
        (this.mediumItems =
          Number(
            getComputedStyle(this.carousel).getPropertyValue(
              "--grid-medium-items"
            )
          ) || this.largeItems),
        (this.smallItems =
          Number(
            getComputedStyle(this.carousel).getPropertyValue(
              "--grid-small-items"
            )
          ) ||
          this.mediumItems ||
          this.largeItems);
    }
    visibleSlides() {
      if (!this.carousel) return;
      this.getGridLayout();
      const e = this.carousel.clientWidth || this.carouselInstance.size.width,
        t =
          null !== this.carouselInstance &&
          this.carouselInstance.selectedElement
            ? this.carouselInstance.selectedElement.clientWidth
            : this.carousel.querySelector(Et).clientWidth,
        i =
          null !== this.carouselInstance && this.carouselInstance.slides
            ? this.carouselInstance.slides.length
            : this.carousel.querySelectorAll(Et).length,
        s = Math.floor(e / t);
      this.section.classList.remove(Ft),
        this.carouselPrev &&
          this.carouselNext &&
          (this.carouselPrev.classList.remove(Ot),
          this.carouselNext.classList.remove(Ot)),
        window.innerWidth > window.theme.sizes.large &&
          !this.options.groupCells &&
          s <= this.largeItems &&
          i <= this.largeItems &&
          this.carouselPrev &&
          this.carouselNext &&
          this.hideArrows(),
        window.innerWidth >= window.theme.sizes.medium &&
          window.innerWidth <= window.theme.sizes.large &&
          !this.options.groupCells &&
          s <= this.mediumItems &&
          i <= this.mediumItems &&
          this.carouselPrev &&
          this.carouselNext &&
          this.hideArrows(),
        window.innerWidth < window.theme.sizes.medium &&
          !this.options.groupCells &&
          s <= this.smallItems &&
          i <= this.smallItems &&
          this.carouselPrev &&
          this.carouselNext &&
          this.hideArrows();
    }
    trackVisibleSlides() {
      const e = window.matchMedia(
          `(max-width: ${window.theme.sizes.medium - 1}px)`
        ),
        t = window.matchMedia(
          `(min-width: ${window.theme.sizes.medium}px) and (max-width: ${
            window.theme.sizes.large - 1
          }px)`
        ),
        i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
      e.addEventListener("change", (e) => {
        !e.matches || (this.slidesVisible = this.smallItems);
      }),
        !e.matches || (this.slidesVisible = this.smallItems),
        t.addEventListener("change", (e) => {
          !e.matches || (this.slidesVisible = this.mediumItems);
        }),
        !t.matches || (this.slidesVisible = this.mediumItems),
        i.addEventListener("change", (e) => {
          !e.matches || (this.slidesVisible = this.largeItems);
        }),
        !i.matches || (this.slidesVisible = this.largeItems);
    }
    containDrag() {
      const e = this.slidesTotal - this.slidesVisible;
      this.carouselInstance.selectedIndex >= e &&
        (this.carouselInstance.select(e),
        this.lockArrows(this.carouselInstance.selectedIndex));
    }
    lockArrows(e) {
      if (this.options.wrapAround || this.options.groupCells) return;
      const t = parseInt(e),
        i = this.slidesTotal - this.slidesVisible;
      this.carouselNext.disabled = t >= i;
    }
    showArrows() {
      this.carouselPrev.classList.remove(Ot),
        this.carouselNext.classList.remove(Ot),
        this.section.classList.remove(Ft);
    }
    hideArrows() {
      this.carouselPrev.classList.add(Ot),
        this.carouselNext.classList.add(Ot),
        this.section.classList.add(Ft);
    }
    toggleArrows() {
      this.carouselPrev &&
        this.carouselNext &&
        (this.carouselPrev.disabled && this.carouselNext.disabled
          ? this.hideArrows()
          : this.showArrows());
    }
  }
  customElements.get("flickity-carousel") ||
    customElements.define("flickity-carousel", Nt);
  const Rt = "[data-address-wrapper]",
    jt = "[data-new-address-form]",
    zt = "[new-address-form-inner]",
    Vt = ".address-new-toggle",
    Ut = ".address-edit-toggle",
    Jt = ".address-delete",
    Gt = "hide",
    Qt = "data-form-id",
    Yt = "data-confirm-message",
    Xt = "Are you sure you wish to delete this address?",
    Kt = "#EditAddress",
    Zt = "AddressCountryNew",
    ei = "AddressProvinceNew",
    ti = "AddressProvinceContainerNew",
    ii = ".address-country-option",
    si = "AddressCountry",
    ri = "AddressProvince",
    ni = "AddressProvinceContainer";
  class oi {
    constructor(e) {
      (this.section = e),
        (this.addressNewForm = this.section.querySelector(jt)),
        this.init();
    }
    init() {
      if (this.addressNewForm) {
        const e = this.section,
          t = this.addressNewForm.querySelector(zt);
        this.customerAddresses();
        const i = e.querySelectorAll(Vt);
        i.length &&
          i.forEach((e) => {
            e.addEventListener("click", function () {
              t.classList.toggle(Gt);
            });
          });
        const s = e.querySelectorAll(Ut);
        s.length &&
          s.forEach((t) => {
            t.addEventListener("click", function () {
              const t = this.getAttribute(Qt);
              e.querySelector(`${Kt}_${t}`).classList.toggle(Gt);
            });
          });
        const r = e.querySelectorAll(Jt);
        r.length &&
          r.forEach((e) => {
            e.addEventListener("click", function () {
              const e = this.getAttribute(Qt),
                t = this.getAttribute(Yt);
              confirm(t || Xt) &&
                Shopify.postLink(
                  window.theme.routes.account_addresses_url + "/" + e,
                  { parameters: { _method: "delete" } }
                );
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(Zt, ei, { hideElement: ti });
      this.section.querySelectorAll(ii).forEach((e) => {
        const t = e.getAttribute(Qt),
          i = `${si}_${t}`,
          s = `${ri}_${t}`,
          r = `${ni}_${t}`;
        new Shopify.CountryProvinceSelector(i, s, { hideElement: r });
      });
    }
  }
  const ai = document.querySelector(Rt);
  ai && new oi(ai),
    document.querySelector("#RecoverPassword") &&
      (function () {
        var e = {
          recoverPasswordForm: "#RecoverPassword",
          hideRecoverPasswordLink: "#HideRecoverPasswordLink",
        };
        function t(e) {
          e.preventDefault(), s();
        }
        function i() {
          "#recover" === window.location.hash && s();
        }
        function s() {
          var e = document.querySelector("#CustomerEmail").value;
          (document.querySelector("#RecoverEmail").value = e),
            document
              .querySelector("#RecoverPasswordForm")
              .classList.toggle("display-none"),
            document
              .querySelector("#CustomerLoginForm")
              .classList.toggle("display-none");
        }
        function r() {
          document.querySelector(".reset-password-success") &&
            document
              .querySelector("#ResetSuccess")
              .classList.remove("display-none");
        }
        i(),
          r(),
          document
            .querySelector(e.recoverPasswordForm)
            .addEventListener("click", t),
          document
            .querySelector(e.hideRecoverPasswordLink)
            .addEventListener("click", t);
      })(),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const li = window.Shopify.theme.sections.registered,
    ci = window.Shopify.theme.sections.instances,
    hi = "data-section-id",
    di = "data-section-type";
  class ui {
    constructor(e = null, t = []) {
      (this.type = e),
        (this.components = (function (e) {
          if ((void 0 !== e && "object" != typeof e) || null === e)
            throw new TypeError(
              "Theme Sections: The components object provided is not a valid"
            );
          return e;
        })(t)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        t.forEach((e) => {
          for (const [t, i] of Object.entries(e)) {
            const e = this.callStack[t];
            Array.isArray(e) && "function" == typeof i
              ? e.push(i)
              : (console.warn(
                  `Unregisted function: '${t}' in component: '${this.type}'`
                ),
                console.warn(i));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class pi {
    constructor(e, t) {
      (this.container = (function (e) {
        if (!(e instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === e.getAttribute(hi))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              hi +
              " attribute."
          );
        return e;
      })(e)),
        (this.id = e.getAttribute(hi)),
        (this.type = t.type),
        (this.callStack = t.getStack());
      try {
        this.onLoad();
      } catch (e) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.error(e);
      }
    }
    callFunctions(e, t = null) {
      this.callStack[e].forEach((e) => {
        const i = { id: this.id, type: this.type, container: this.container };
        t ? e.call(i, t) : e.call(i);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(e) {
      this.callFunctions("onSelect", e);
    }
    onDeselect(e) {
      this.callFunctions("onDeselect", e);
    }
    onBlockSelect(e) {
      this.callFunctions("onBlockSelect", e);
    }
    onBlockDeselect(e) {
      this.callFunctions("onBlockDeselect", e);
    }
    onReorder(e) {
      this.callFunctions("onReorder", e);
    }
  }
  function mi(e, t) {
    if ("string" != typeof e)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== li[e])
      throw new Error(
        'Theme Sections: A section of type "' +
          e +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(t) || (t = [t]);
    const i = new ui(e, t);
    return (li[e] = i), li;
  }
  function fi(e, t) {
    (e = vi(e)),
      void 0 === t && (t = document.querySelectorAll("[" + di + "]")),
      (t = bi(t)),
      e.forEach(function (e) {
        const i = li[e];
        void 0 !== i &&
          (t = t.filter(function (t) {
            return (
              !(gi(t).length > 0) &&
              null !== t.getAttribute(di) &&
              (t.getAttribute(di) !== e || (ci.push(new pi(t, i)), !1))
            );
          }));
      });
  }
  function gi(e) {
    var t = [];
    if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
    if (e instanceof Element || i instanceof Element)
      bi(e).forEach(function (e) {
        t = t.concat(
          ci.filter(function (t) {
            return t.container === e;
          })
        );
      });
    else if ("string" == typeof e || "string" == typeof i) {
      vi(e).forEach(function (e) {
        t = t.concat(
          ci.filter(function (t) {
            return t.type === e;
          })
        );
      });
    }
    return t;
  }
  function yi(e) {
    for (var t, i = 0; i < ci.length; i++)
      if (ci[i].id === e) {
        t = ci[i];
        break;
      }
    return t;
  }
  function vi(e) {
    return (
      "*" === e
        ? (e = Object.keys(li))
        : "string" == typeof e
        ? (e = [e])
        : e.constructor === pi
        ? (e = [e.prototype.type])
        : Array.isArray(e) &&
          e[0].constructor === pi &&
          (e = e.map(function (e) {
            return e.type;
          })),
      (e = e.map(function (e) {
        return e.toLowerCase();
      }))
    );
  }
  function bi(e) {
    return (
      NodeList.prototype.isPrototypeOf(e) && e.length > 0
        ? (e = Array.prototype.slice.call(e))
        : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
        ? (e = [])
        : !Array.isArray(e) && e instanceof Element && (e = [e]),
      e
    );
  }
  function wi(e, t) {
    (t = t || {}),
      e.focus(),
      void 0 !== t.className && e.classList.add(t.className),
      e.addEventListener("blur", function i(s) {
        s.target.removeEventListener(s.type, i),
          void 0 !== t.className && e.classList.remove(t.className);
      });
  }
  function Si(e) {
    e = e || {};
    var t = window.location.hash,
      i = document.getElementById(t.slice(1));
    if (i && e.ignore && i.matches(e.ignore)) return !1;
    t && i && wi(i, e);
  }
  function Ei(e) {
    return (
      (e = e || {}),
      Array.prototype.slice
        .call(document.querySelectorAll('a[href^="#"]'))
        .filter(function (t) {
          if ("#" === t.hash || "" === t.hash) return !1;
          if (e.ignore && t.matches(e.ignore)) return !1;
          if (((i = t.hash.substr(1)), null === document.getElementById(i)))
            return !1;
          var i,
            s = document.querySelector(t.hash);
          return (
            !!s &&
            (t.addEventListener("click", function () {
              wi(s, e);
            }),
            !0)
          );
        })
    );
  }
  function Li(e) {
    return Array.prototype.slice
      .call(
        e.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]"
        )
      )
      .filter(function (e) {
        return Boolean(
          e.offsetWidth || e.offsetHeight || e.getClientRects().length
        );
      });
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (e) {
      var t = e.detail.sectionId,
        i = e.target.querySelector("[" + hi + '="' + t + '"]');
      null !== i && fi(i.getAttribute(di), i);
    }),
    document.addEventListener("shopify:section:reorder", function (e) {
      var t = e.detail.sectionId,
        i = e.target.querySelector("[" + hi + '="' + t + '"]');
      "object" == typeof gi(i)[0] &&
        gi(i).forEach(function (e) {
          e.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (e) {
      var t = e.detail.sectionId,
        i = e.target.querySelector("[" + hi + '="' + t + '"]');
      "object" == typeof gi(i)[0] &&
        gi(i).forEach(function (e) {
          var t = ci
            .map(function (e) {
              return e.id;
            })
            .indexOf(e.id);
          ci.splice(t, 1), e.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (e) {
      var t = yi(e.detail.sectionId);
      "object" == typeof t && t.onSelect(e);
    }),
    document.addEventListener("shopify:section:deselect", function (e) {
      var t = yi(e.detail.sectionId);
      "object" == typeof t && t.onDeselect(e);
    }),
    document.addEventListener("shopify:block:select", function (e) {
      var t = yi(e.detail.sectionId);
      "object" == typeof t && t.onBlockSelect(e);
    }),
    document.addEventListener("shopify:block:deselect", function (e) {
      var t = yi(e.detail.sectionId);
      "object" == typeof t && t.onBlockDeselect(e);
    }));
  var ki = {};
  function Ti(e, t) {
    t = t || {};
    var i = Li(e),
      s = t.elementToFocus || e,
      r = i[0],
      n = i[i.length - 1];
    xi(),
      (ki.focusin = function (t) {
        e !== t.target &&
          !e.contains(t.target) &&
          r &&
          r === t.target &&
          r.focus(),
          (t.target !== e && t.target !== n && t.target !== r) ||
            document.addEventListener("keydown", ki.keydown);
      }),
      (ki.focusout = function () {
        document.removeEventListener("keydown", ki.keydown);
      }),
      (ki.keydown = function (t) {
        "Tab" === t.code &&
          (t.target !== n || t.shiftKey || (t.preventDefault(), r.focus()),
          (t.target !== e && t.target !== r) ||
            !t.shiftKey ||
            (t.preventDefault(), n.focus()));
      }),
      document.addEventListener("focusout", ki.focusout),
      document.addEventListener("focusin", ki.focusin),
      wi(s, t);
  }
  function xi() {
    document.removeEventListener("focusin", ki.focusin),
      document.removeEventListener("focusout", ki.focusout),
      document.removeEventListener("keydown", ki.keydown);
  }
  var _i = Object.freeze({
    __proto__: null,
    forceFocus: wi,
    focusHash: Si,
    bindInPageLinks: Ei,
    focusable: Li,
    trapFocus: Ti,
    removeTrapFocus: xi,
    accessibleLinks: function (e, t) {
      if ("string" != typeof e) throw new TypeError(e + " is not a String.");
      if (0 !== (e = document.querySelectorAll(e)).length) {
        (t = t || {}).messages = t.messages || {};
        var i = {
            newWindow: t.messages.newWindow || "Opens in a new window.",
            external: t.messages.external || "Opens external website.",
            newWindowExternal:
              t.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          s = t.prefix || "a11y",
          r = {
            newWindow: s + "-new-window-message",
            external: s + "-external-message",
            newWindowExternal: s + "-new-window-external-message",
          };
        e.forEach(function (e) {
          var t = e.getAttribute("target"),
            i = e.getAttribute("rel"),
            s = (function (e) {
              return e.hostname !== window.location.hostname;
            })(e),
            n = "_blank" === t,
            o = null === i || -1 === i.indexOf("noopener");
          if (n && o) {
            var a = null === i ? "noopener" : i + " noopener";
            e.setAttribute("rel", a);
          }
          s && n
            ? e.setAttribute("aria-describedby", r.newWindowExternal)
            : s
            ? e.setAttribute("aria-describedby", r.external)
            : n && e.setAttribute("aria-describedby", r.newWindow);
        }),
          (function (e) {
            var t = document.createElement("ul"),
              i = Object.keys(e).reduce(function (t, i) {
                return t + "<li id=" + r[i] + ">" + e[i] + "</li>";
              }, "");
            t.setAttribute("hidden", !0),
              (t.innerHTML = i),
              document.body.appendChild(t);
          })(i);
      }
    },
  });
  const Ai =
    'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
  function qi(e) {
    const t = `data-popup-${e}`;
    n.init({
      openTrigger: t,
      disableScroll: !0,
      onShow: (e, t, i) => {
        i.preventDefault();
        const s = e.querySelector(Ai);
        Ti(e, { elementToFocus: s });
      },
      onClose: (e, t, i) => {
        i.preventDefault(), xi(), t.focus();
      },
    });
  }
  const Ci = "[data-toggle-password-modal]",
    Pi = ".storefront-password-form .errors",
    $i = {};
  class Mi {
    constructor(e) {
      (this.container = e.container),
        (this.trigger = this.container.querySelector(Ci)),
        (this.errors = this.container.querySelector(Pi)),
        this.init();
    }
    init() {
      qi("password"), this.errors && this.trigger.click();
    }
  }
  mi("password", {
    onLoad() {
      $i[this.id] = new Mi(this);
    },
  }),
    (function () {
      var e = "#QrCode",
        t = ".giftcard__code";
      const i = document.querySelector(e);
      if (i) {
        function r() {
          const e = i.getAttribute("data-identifier");
          new QRCode(i, { text: e, width: 120, height: 120 });
        }
        window.addEventListener("load", r);
      }
      const s = document.querySelector(t);
      if (s) {
        function n() {
          var e = document.querySelector("#GiftCardDigits"),
            t = "";
          if (document.body.createTextRange)
            (t = document.body.createTextRange()).moveToElementText(e),
              t.select();
          else if (window.getSelection) {
            var i = window.getSelection();
            (t = document.createRange()).selectNodeContents(e),
              i.removeAllRanges(),
              i.addRange(t);
          }
        }
        s.addEventListener("click", n());
      }
    })();
  const Ii = "[data-parallax-wrapper]",
    Di = "[data-parallax-img]";
  let Oi = {};
  const Hi = {
    onLoad() {
      Oi[this.id] = [];
      this.container.querySelectorAll(Ii).forEach((e) => {
        const t = e.querySelector(Di);
        Oi[this.id].push(new o(t, { center: !0, round: !0, frame: e }));
      });
    },
    onUnload: function () {
      Oi[this.id].forEach((e) => {
        "function" == typeof e.destroy && e.destroy();
      });
    },
  };
  mi("article", Hi);
  const Fi = "[data-ticker-frame]",
    Bi = "[data-ticker-scale]",
    Wi = "[data-ticker-text]",
    Ni = "data-clone",
    Ri = "aria-hidden",
    ji = "ticker--animated",
    zi = "ticker--unloaded",
    Vi = "ticker__comparitor",
    Ui = {};
  class Ji {
    constructor(e, t = !1) {
      (this.frame = e),
        (this.stopClone = t),
        (this.scale = this.frame.querySelector(Bi)),
        (this.text = this.frame.querySelector(Wi)),
        (this.space = 100),
        (this.timeIndex = 1.63),
        this.init();
    }
    init() {
      this.addComparitor(),
        (this.resizeEvent = T(() => this.checkWidth(), 300)),
        this.listen();
    }
    addComparitor() {
      (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(Vi),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(zi);
    }
    unload() {
      document.removeEventListener("theme:resize", this.resizeEvent);
    }
    listen() {
      document.addEventListener("theme:resize", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      const e =
        2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
      if (
        (Array.from(this.text.parentNode.children).forEach((e) => {
          e.classList.add(ji);
        }),
        this.frame.clientWidth - e < this.comparitor.clientWidth ||
          this.stopClone)
      ) {
        if (
          1 === this.scale.childElementCount &&
          ((this.clone = this.text.cloneNode(!0)),
          this.clone.setAttribute(Ri, !0),
          this.clone.setAttribute(Ni, ""),
          this.scale.appendChild(this.clone),
          this.stopClone)
        )
          for (let e = 0; e < 10; e++) {
            const e = this.text.cloneNode(!0);
            e.setAttribute(Ri, !0),
              e.setAttribute(Ni, ""),
              this.scale.appendChild(e);
          }
        const e = (this.text.clientWidth / this.space) * this.timeIndex;
        this.scale.style.setProperty("--animation-time", `${e}s`);
      } else {
        let e = this.scale.querySelector(`[${Ni}]`);
        e && this.scale.removeChild(e), this.text.classList.remove(ji);
      }
    }
  }
  const Gi = {
      onLoad() {
        Ui[this.id] = [];
        this.container.querySelectorAll(Fi).forEach((e) => {
          Ui[this.id].push(new Ji(e));
        });
      },
      onUnload() {
        Ui[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Qi = "[data-ticker-frame]",
    Yi = "data-slide",
    Xi = "[data-ticker-scale]",
    Ki = "[data-ticker-text]",
    Zi = "ticker--animated",
    es = {};
  class ts {
    constructor(e) {
      (this.container = e.container), this.init();
    }
    init() {
      this.initTickers(!0);
    }
    initTickers(e = !1) {
      const t = this.container.querySelector(Qi);
      t && new Ji(t, e);
    }
    toggleTicker(e, t) {
      const i = this.container.querySelector(Xi),
        s = this.container.querySelector(`[${Yi}="${e.detail.blockId}"]`);
      if (s && i) {
        if (t) {
          const e = Number(
              getComputedStyle(s).getPropertyValue("--gutter").replace("px", "")
            ),
            t = -(s.offsetLeft - e);
          i.setAttribute("data-stop", ""),
            i.querySelectorAll(Ki).forEach((e) => {
              e.classList.remove(Zi),
                (e.style.transform = `translate3d(${t}px, 0, 0)`);
            });
        }
        t ||
          (i.querySelectorAll(Ki).forEach((e) => {
            e.classList.add(Zi), e.removeAttribute("style");
          }),
          i.removeAttribute("data-stop"));
      }
    }
    onBlockSelect(e) {
      this.toggleTicker(e, !0);
    }
    onBlockDeselect(e) {
      this.toggleTicker(e, !1);
    }
  }
  mi("logos", {
    onLoad() {
      (es[this.id] = []), es[this.id].push(new ts(this));
    },
    onBlockSelect(e) {
      es[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
      });
    },
    onBlockDeselect(e) {
      es[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
      });
    },
  }),
    mi("blog", Hi);
  var is = "[data-drawer]",
    ss = "[data-drawer-scrolls]",
    rs = "[data-predictive-search-input]",
    ns = "[data-drawer-underlay]",
    os = "[data-stagger-animation]",
    as = "data-drawer-toggle",
    ls = ":scope > * > [data-animates]",
    cs = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    hs = "drawer--visible",
    ds = "display-none",
    us = {};
  class ps {
    constructor(e) {
      (this.drawer = e),
        (this.drawerScrolls = this.drawer.querySelector(ss)),
        (this.underlay = this.drawer.querySelector(ns)),
        (this.key = this.drawer.dataset.drawer);
      const t = `[${as}='${this.key}']`;
      (this.buttons = document.querySelectorAll(t)),
        (this.staggers = this.drawer.querySelectorAll(os)),
        this.connectToggle(),
        this.connectDrawer(),
        this.closers(),
        this.staggerChildAnimations();
    }
    unload() {}
    connectToggle() {
      this.buttons.forEach((e) => {
        e.addEventListener(
          "click",
          function (e) {
            e.preventDefault(),
              this.drawer.dispatchEvent(
                new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
              );
          }.bind(this)
        );
      });
    }
    connectDrawer() {
      this.drawer.addEventListener(
        "theme:drawer:toggle",
        function () {
          this.drawer.classList.contains(hs)
            ? this.drawer.dispatchEvent(
                new CustomEvent("theme:drawer:close", { bubbles: !1 })
              )
            : this.drawer.dispatchEvent(
                new CustomEvent("theme:drawer:open", { bubbles: !1 })
              );
        }.bind(this)
      ),
        this.drawer.addEventListener(
          "theme:drawer:close",
          this.hideDrawer.bind(this)
        ),
        this.drawer.addEventListener(
          "theme:drawer:open",
          this.showDrawer.bind(this)
        );
    }
    staggerChildAnimations() {
      this.staggers.forEach((e) => {
        e.querySelectorAll(ls).forEach((e, t) => {
          e.style.transitionDelay = 50 * t + 10 + "ms";
        });
      });
    }
    closers() {
      this.drawer.addEventListener(
        "keyup",
        function (e) {
          "Escape" === e.code && (this.hideDrawer(), this.buttons[0].focus());
        }.bind(this)
      ),
        this.underlay.addEventListener(
          "click",
          function () {
            this.hideDrawer();
          }.bind(this)
        );
    }
    focusFirst() {
      const e = this.drawer.querySelector(rs);
      if (e) e.focus();
      else {
        const e = this.drawer.querySelector(cs);
        Ti(this.drawer, { elementToFocus: e });
      }
    }
    showDrawer() {
      this.drawer.classList.remove(ds),
        setTimeout(() => {
          this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
            this.drawer.classList.add(hs),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", {
                bubbles: !0,
                detail: this.drawerScrolls,
              })
            ),
            this.drawer.addEventListener(
              "transitionend",
              this.focusFirst.bind(this),
              { once: !0 }
            ),
            this.drawer.addEventListener(
              "transitioncancel",
              this.focusFirst.bind(this),
              { once: !0 }
            );
        }, 1);
    }
    hideDrawer() {
      (window.theme.state.cartOpen = !1),
        this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
        this.drawer.classList.remove(hs),
        this.drawerScrolls.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:sliderule:close", { bubbles: !1 })
        ),
        xi(),
        setTimeout(() => {
          this.drawer.classList.contains(hs) || this.drawer.classList.add(ds);
        }, 800);
    }
  }
  const ms = {
      onLoad() {
        us[this.id] = [];
        this.container.querySelectorAll(is).forEach((e) => {
          us[this.id].push(new ps(e));
        });
      },
      onUnload: function () {
        us[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    fs = "[data-announcement-bar]",
    gs = "data-header-transparent",
    ys = "[data-header-wrapper] header",
    vs = "js__header__stuck",
    bs = "js__header__stuck--animated",
    ws = "js__header__stuck--trigger-animation",
    Ss = "js__header__stuck__backdrop";
  let Es = {};
  class Ls {
    constructor(e) {
      (this.wrapper = e),
        (this.type = this.wrapper.dataset.headerSticky),
        (this.transparent = this.wrapper.dataset.headerTransparent),
        (this.sticks = "sticky" === this.type),
        (this.animated = "directional" === this.type),
        (this.currentlyStuck = !1),
        (this.cls = this.wrapper.classList);
      const t = document.querySelector(fs),
        i = t ? t.clientHeight : 0,
        s = document.querySelector(ys).clientHeight;
      (this.blur = s + i),
        (this.stickDown = s + i),
        (this.stickUp = i),
        "false" !== this.wrapper.getAttribute(gs) && (this.blur = i),
        this.sticks && ((this.stickDown = i), this.scrollDownInit()),
        this.listen();
    }
    unload() {
      document.removeEventListener("theme:scroll", this.listen),
        document.removeEventListener(
          "theme:scroll:up",
          this.scrollUpDirectional
        ),
        document.removeEventListener(
          "theme:scroll:down",
          this.scrollDownDirectional
        );
    }
    listen() {
      (this.sticks || this.animated) &&
        document.addEventListener("theme:scroll", (e) => {
          e.detail.down
            ? (!this.currentlyStuck &&
                e.detail.position > this.stickDown &&
                this.stickSimple(),
              !this.currentlyBlurred &&
                e.detail.position > this.blur &&
                this.addBlur())
            : (e.detail.position <= this.stickUp && this.unstickSimple(),
              e.detail.position <= this.blur && this.removeBlur());
        }),
        this.animated &&
          (document.addEventListener(
            "theme:scroll:up",
            this.scrollUpDirectional.bind(this)
          ),
          document.addEventListener(
            "theme:scroll:down",
            this.scrollDownDirectional.bind(this)
          ));
    }
    stickSimple() {
      this.animated && this.cls.add(bs),
        this.cls.add(vs),
        this.wrapper.setAttribute(gs, !1),
        (this.currentlyStuck = !0);
    }
    unstickSimple() {
      this.cls.remove(vs),
        this.wrapper.setAttribute(gs, this.transparent),
        this.animated && this.cls.remove(bs),
        (this.currentlyStuck = !1);
    }
    scrollDownInit() {
      window.scrollY > this.stickDown && this.stickSimple(),
        window.scrollY > this.blur && this.addBlur();
    }
    stickDirectional() {
      this.cls.add(ws);
    }
    unstickDirectional() {
      this.cls.remove(ws);
    }
    scrollDownDirectional() {
      this.unstickDirectional();
    }
    scrollUpDirectional() {
      window.scrollY <= this.stickDown
        ? this.unstickDirectional()
        : this.stickDirectional();
    }
    addBlur() {
      this.cls.add(Ss), (this.currentlyBlurred = !0);
    }
    removeBlur() {
      this.cls.remove(Ss), (this.currentlyBlurred = !1);
    }
  }
  const ks = {
      onLoad() {
        Es = new Ls(this.container);
      },
      onUnload: function () {
        "function" == typeof Es.unload && Es.unload();
      },
    },
    Ts = "data-hover-disclosure-toggle",
    xs = "[data-hover-disclosure]",
    _s = "[data-top-link]",
    As = "[data-header-wrapper]",
    qs = "[data-stagger]",
    Cs = "[data-stagger-first]",
    Ps = "[data-stagger-second]",
    $s = "[data-grid-item], [data-header-image]",
    Ms = "is-visible",
    Is = "meganav--visible",
    Ds = "grandparent";
  let Os = {},
    Hs = {};
  class Fs {
    constructor(e) {
      (this.disclosure = e),
        (this.wrapper = e.closest(As)),
        (this.key = this.disclosure.id);
      const t = `[${Ts}='${this.key}']`;
      (this.trigger = document.querySelector(t)),
        (this.link = this.trigger.querySelector(_s)),
        (this.grandparent = this.trigger.classList.contains(Ds)),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.connectHoverToggle(),
        this.handleTablets(),
        this.staggerChildAnimations();
    }
    onBlockSelect(e) {
      this.disclosure.contains(e.target) && this.showDisclosure();
    }
    onBlockDeselect(e) {
      this.disclosure.contains(e.target) && this.hideDisclosure();
    }
    showDisclosure() {
      this.grandparent
        ? this.wrapper.classList.add(Is)
        : this.wrapper.classList.remove(Is),
        this.trigger.setAttribute("aria-expanded", !0),
        this.trigger.classList.add(Ms),
        this.disclosure.classList.add(Ms);
    }
    hideDisclosure() {
      this.disclosure.classList.remove(Ms),
        this.trigger.classList.remove(Ms),
        this.trigger.setAttribute("aria-expanded", !1),
        this.wrapper.classList.remove(Is);
    }
    staggerChildAnimations() {
      this.disclosure.querySelectorAll(qs).forEach((e, t) => {
        e.style.transitionDelay = 50 * t + 10 + "ms";
      });
      this.disclosure.querySelectorAll(Cs).forEach((e, t) => {
        const i = 150 * t;
        (e.style.transitionDelay = `${i}ms`),
          e.parentElement.querySelectorAll(Ps).forEach((e, t) => {
            const s = 20 * (t + 1);
            e.style.transitionDelay = `${i + s}ms`;
          });
      });
      this.disclosure.querySelectorAll($s).forEach((e, t) => {
        e.style.transitionDelay = 80 * (t + 1) + "ms";
      });
    }
    handleTablets() {
      this.trigger.addEventListener(
        "touchstart",
        function (e) {
          this.disclosure.classList.contains(Ms) ||
            (e.preventDefault(), this.showDisclosure());
        }.bind(this),
        { passive: !0 }
      );
    }
    connectHoverToggle() {
      this.trigger.addEventListener(
        "pointerenter",
        this.showDisclosure.bind(this)
      ),
        this.link.addEventListener("focus", this.showDisclosure.bind(this)),
        this.trigger.addEventListener(
          "pointerleave",
          this.hideDisclosure.bind(this)
        ),
        this.trigger.addEventListener(
          "focusout",
          function (e) {
            this.trigger.contains(e.relatedTarget) || this.hideDisclosure();
          }.bind(this)
        ),
        this.disclosure.addEventListener(
          "keyup",
          function (e) {
            "Escape" === e.code && this.hideDisclosure();
          }.bind(this)
        );
    }
  }
  const Bs = {
      onLoad() {
        (Os[this.id] = []),
          (Hs = this.container.querySelectorAll(xs)),
          Hs.forEach((e) => {
            Os[this.id].push(new Fs(e));
          });
      },
      onBlockSelect(e) {
        Os[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        Os[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
      onUnload: function () {
        Os[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Ws = "[data-main-menu-text-item]",
    Ns = "[data-text-items-wrapper]",
    Rs = ".navtext",
    js = "data-menu-active",
    zs = "[data-header-wrapper]",
    Vs = "data-underline-current",
    Us =
      ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
  let Js = {},
    Gs = null;
  class Qs {
    constructor(e) {
      (this.wrapper = e),
        (this.itemList = this.wrapper.querySelectorAll(Ws)),
        (this.sectionOuter = document.querySelector(zs)),
        (this.underlineCurrent = "true" === this.sectionOuter.getAttribute(Vs)),
        (this.defaultItem = null),
        this.underlineCurrent &&
          (this.defaultItem = this.wrapper.querySelector(Us)),
        this.setDefault(),
        document.fonts.ready.then(() => {
          this.init();
        });
    }
    init() {
      if (this.itemList.length) {
        if (
          (this.listen(),
          this.listenResize(),
          (this.textBottom = null),
          this.setHeight(),
          Gs)
        ) {
          if (this.defaultItem) {
            const e = this.defaultItem.offsetLeft || 0;
            this.sectionOuter.style.setProperty("--bar-left", `${e}px`);
          }
          this.reset();
        } else {
          const e = this.sectionOuter.querySelector(Ws).offsetLeft;
          this.sectionOuter.style.setProperty("--bar-left", `${e}px`),
            this.sectionOuter.style.setProperty("--bar-width", "0px");
        }
        this.sectionOuter.style.setProperty("--bar-opacity", "1");
      }
    }
    unload() {
      document.removeEventListener("theme:resize", this.reset), (Gs = null);
    }
    listenResize() {
      document.addEventListener("theme:resize", this.reset.bind(this));
    }
    setDefault() {
      this.defaultItem &&
        (Gs = {
          left: this.defaultItem.offsetLeft || null,
          width: this.defaultItem.clientWidth || null,
        });
    }
    setHeight() {
      const e = this.wrapper.clientHeight,
        t = this.itemList[0].querySelector(Rs).clientHeight,
        i = Math.floor(e / 2 - t / 2) - 4;
      this.textBottom !== i &&
        (this.sectionOuter.style.setProperty("--bar-text", `${t}px`),
        this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`),
        (this.textBottom = i));
    }
    listen() {
      this.itemList.forEach((e) => {
        e.addEventListener("pointerenter", (e) => {
          const t = e.target.querySelector(Rs);
          this.startBar(t);
        });
      }),
        this.wrapper.addEventListener("pointerleave", this.clearBar.bind(this));
    }
    startBar(e) {
      this.setHeight();
      let t = "false" !== this.sectionOuter.getAttribute(js),
        i = e.offsetLeft,
        s = e.clientWidth;
      t
        ? this.render(s, i)
        : (this.sectionOuter.setAttribute(js, !0),
          this.render(0, i),
          setTimeout(() => {
            this.render(s, i);
          }, 10));
    }
    render(e, t) {
      this.sectionOuter.style.setProperty("--bar-left", `${t}px`),
        this.sectionOuter.style.setProperty("--bar-width", `${e}px`);
    }
    reset() {
      this.setDefault(),
        Gs && Gs.left && Gs.width
          ? (this.sectionOuter.style.setProperty("--bar-left", `${Gs.left}px`),
            this.sectionOuter.style.setProperty("--bar-width", `${Gs.width}px`))
          : this.sectionOuter.style.setProperty("--bar-width", "0px");
    }
    clearBar() {
      this.sectionOuter.setAttribute(js, !1),
        setTimeout(() => {
          "false" !== this.sectionOuter.getAttribute(js) || this.reset();
        }, 150);
    }
  }
  const Ys = {
      onLoad() {
        Js[this.id] = [];
        this.container.querySelectorAll(Ns).forEach((e) => {
          Js[this.id].push(new Qs(e));
        });
      },
      onUnload: function () {
        Js[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        }),
          delete Js[this.id];
      },
    },
    Xs = "data-header-cart-price",
    Ks = "data-header-cart-count",
    Zs = "data-header-cart-full";
  class er {
    constructor(e) {
      (this.section = e),
        (this.counts = this.section.querySelectorAll(`[${Ks}]`)),
        (this.prices = this.section.querySelectorAll(`[${Xs}]`)),
        (this.dots = this.section.querySelectorAll(`[${Zs}]`)),
        (this.cart = null),
        this.listen();
    }
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), this.update();
        }.bind(this)
      );
    }
    update() {
      this.cart &&
        (this.prices.forEach((e) => {
          e.setAttribute(Xs, this.cart.total_price);
          const t = a.formatMoney(this.cart.total_price, theme.moneyFormat);
          e.innerHTML = t;
        }),
        this.counts.forEach((e) => {
          e.setAttribute(Ks, this.cart.item_count),
            (e.innerHTML = `(${this.cart.item_count})`);
        }),
        this.dots.forEach((e) => {
          const t = this.cart.item_count > 0;
          e.setAttribute(Zs, t);
        }));
    }
  }
  const tr = {
      onLoad() {
        new er(this.container);
      },
    },
    ir = "[data-search-popdown-wrap]",
    sr = "data-popdown-toggle",
    rr = "[data-close-popdown]",
    nr = "[data-predictive-search-input]",
    or = "[data-search-underlay]",
    ar = "underlay--visible",
    lr = "is-visible";
  let cr = {};
  class hr {
    constructor(e) {
      (this.trigger = e),
        (this.key = this.trigger.getAttribute(sr)),
        (this.popdown = document.querySelector(`[id='${this.key}']`)),
        (this.input = this.popdown.querySelector(nr)),
        (this.close = this.popdown.querySelector(rr)),
        (this.wrapper = this.popdown.closest(ir)),
        (this.underlay = this.wrapper.querySelector(or)),
        this.initTriggerEvents(),
        this.initPopdownEvents();
    }
    initTriggerEvents() {
      this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.trigger.addEventListener(
          "click",
          function (e) {
            e.preventDefault(), this.showPopdown();
          }.bind(this)
        ),
        this.trigger.addEventListener(
          "keyup",
          function (e) {
            "Space" === e.code && this.showPopdown();
          }.bind(this)
        );
    }
    initPopdownEvents() {
      this.popdown.addEventListener(
        "keyup",
        function (e) {
          "Escape" === e.code && this.hidePopdown();
        }.bind(this)
      ),
        this.close.addEventListener(
          "click",
          function () {
            this.hidePopdown();
          }.bind(this)
        ),
        this.underlay.addEventListener(
          "click",
          function () {
            this.hidePopdown();
          }.bind(this)
        );
    }
    hidePopdown() {
      this.popdown.classList.remove(lr),
        this.underlay.classList.remove(ar),
        this.trigger.focus(),
        xi(),
        this.popdown.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    showPopdown() {
      this.popdown.classList.add(lr),
        this.underlay.classList.add(ar),
        Ti(this.popdown, { elementToFocus: this.input }),
        this.popdown.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        );
    }
  }
  const dr = {
      onLoad() {
        cr[this.id] = {};
        const e = this.container.querySelector(`[${sr}]`);
        e && (cr[this.id] = new hr(e));
      },
      onUnload: function () {
        "function" == typeof cr[this.id].unload && cr[this.id].unload();
      },
    },
    ur = "[data-product-add-popdown-wrapper]",
    pr = "[data-close-popdown]",
    mr = "[data-api-content]",
    fr = '[data-ajax-disable="false"]',
    gr = '[data-ajax-disable="true"]',
    yr = '[data-drawer-toggle="drawer-cart"]',
    vr = '[data-drawer="drawer-cart"]',
    br = "is-visible";
  let wr;
  class Sr {
    constructor() {
      (this.drawer = document.querySelector(ur)),
        (this.cartAjaxEnabled = document.querySelector(fr)),
        (this.cartAjaxDisabled = document.querySelector(gr)),
        document.addEventListener("theme:cart:popdown", (e) => {
          this.cartAjaxEnabled
            ? this.cartAjaxEnabled.dispatchEvent(
                new CustomEvent("theme:cart:reload", { bubbles: !0 })
              )
            : this.cartAjaxDisabled
            ? window.location.reload()
            : this.renderPopdown(e);
        });
    }
    renderPopdown(e) {
      const t = e.detail.variant,
        i = `${window.theme.routes.root_url}variants/${t.id}/?section_id=api-product-popdown`,
        s = this;
      l.get(i)
        .then(function (e) {
          const t = document.createElement("div");
          (t.innerHTML = e.data),
            (s.drawer.innerHTML = t.querySelector(mr).innerHTML),
            s.connectCartButton(),
            s.connectCloseButton();
        })
        .catch(function (e) {
          console.warn(e);
        });
    }
    connectCloseButton() {
      this.drawer.classList.add(br);
      this.drawer.querySelector(pr).addEventListener(
        "click",
        function (e) {
          e.preventDefault(), this.drawer.classList.remove(br);
        }.bind(this)
      ),
        this.popdownTimer();
    }
    connectCartButton() {
      const e = this.drawer.querySelector(yr),
        t = document.querySelector(vr);
      t &&
        e.addEventListener(
          "click",
          function (e) {
            e.preventDefault(),
              this.drawer.classList.remove(br),
              t.dispatchEvent(
                new CustomEvent("theme:drawer:open", { bubbles: !1 })
              );
          }.bind(this)
        );
    }
    popdownTimer() {
      clearTimeout(wr),
        (wr = setTimeout(() => {
          this.drawer.classList.remove(br);
        }, 5e3));
    }
  }
  const Er = {
      onLoad() {
        new Sr(this);
      },
    },
    Lr = "data-grid-item-variant";
  class kr extends HTMLElement {
    constructor() {
      super(),
        (this.container = this),
        (this.gridItemVariantLinks = this.container.querySelectorAll(
          `a[${Lr}]`
        ));
    }
    connectedCallback() {
      this.gridItemVariantLinks.length &&
        this.gridItemVariantLinks.forEach((e) => {
          e.hasAttribute(Lr) &&
            (this.swatchHoverEvent(e), this.swatchClickEvent(e));
        });
    }
    swatchHoverEvent(e) {
      e.addEventListener("mouseenter", () => {
        if (e.hasAttribute(Lr)) {
          const t = e.getAttribute(Lr);
          this.container
            .querySelectorAll(
              `product-grid-item-variant[${Lr}="${t}"] product-grid-item-image`
            )
            .forEach((e) => {
              e.setAttribute("loading", "eager");
            });
        }
      });
    }
    swatchClickEvent(e) {
      e.addEventListener("click", (t) => {
        if (
          (t.preventDefault(),
          this.container
            .querySelectorAll(`a[${Lr}]`)
            .forEach((e) => e.removeAttribute("aria-selected")),
          e.setAttribute("aria-selected", "true"),
          e.hasAttribute(Lr))
        ) {
          const t = e.getAttribute(Lr);
          this.container
            .querySelectorAll(`product-grid-item-variant[${Lr}]`)
            .forEach((e) => {
              e.getAttribute(Lr) === t
                ? e.removeAttribute("hidden")
                : e.setAttribute("hidden", "");
            });
        }
      });
    }
  }
  const Tr = "[data-grid-link]",
    xr = "data-grid-images",
    _r = "data-grid-image",
    Ar = "data-grid-image-target",
    qr = "data-grid-current-image",
    Cr = "data-grid-pagination",
    Pr = "data-grid-page",
    $r = "data-slide-for-filter-selected-variant",
    Mr = "data-slide-for-variant-media",
    Ir = "data-slideshow-style",
    Dr = "--width",
    Or = "is-active",
    Hr = "is-mobile",
    Fr = "product-grid-item__pagination";
  class Br extends HTMLElement {
    static get observedAttributes() {
      return ["hidden"];
    }
    constructor() {
      super(),
        (this.container = this),
        (this.mobileStopSlideshow = "true"),
        (this.timeout =
          1e3 * window.theme.settings.cycle_images_hover_delay || 1500),
        (this.interval = null),
        (this.pagingProgressPause = !1),
        (this.pagingProgressCounter = 0),
        (this.siblingsFetchCounter = 0),
        (this.siblingLoadImageIndex = null),
        (this.intersectionObserver = new IntersectionObserver(
          (e) => {
            e.forEach((e) => {
              e.isIntersecting && this.imageCount > 1 && this.preloadImage(1);
            });
          },
          { threshold: 0.1 }
        ));
    }
    preloadImage(e) {
      if (this.isMobile) return;
      const t = [...this.images][e];
      if (!t) throw new Error(`No child element at index ${e}`);
      t.setAttribute("loading", "eager");
    }
    preloadImages() {
      [...this.imagesHolder.children].forEach((e, t) => this.preloadImage(t));
    }
    connectedCallback() {
      this.toggleMobile(),
        document.addEventListener("theme:resize:width", () =>
          this.toggleMobile()
        ),
        this.isMobile ||
          (this.imageCount > 1 &&
            (this.createPaging(),
            this.container.addEventListener(
              "theme:swatch:change",
              this.swatchChangeEvent
            ),
            this.container.addEventListener("mouseenter", this.mouseEnterEvent),
            this.container.addEventListener(
              "mouseleave",
              this.mouseLeaveEvent
            )),
          this.intersectionObserver.observe(this.container));
    }
    disconnectedCallback() {
      this.container.removeEventListener(
        "theme:swatch:change",
        this.swatchChangeEvent
      ),
        this.container.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.container.removeEventListener("mouseleave", this.mouseLeaveEvent);
    }
    swatchChangeEvent(e) {
      const t = e.detail.id,
        i = this.container.querySelector(`[${Ar}="${t}"]`);
      if (i) {
        const t = i.getAttribute(_r);
        (this.pagingProgressCounter = 0),
          this.changeImage(t),
          e.detail.stopSlideAnimation && this.stopPaging();
      }
    }
    mouseEnterEvent() {
      switch ((this.preloadImages(), this.slideshowStyle)) {
        case "cycle_images":
          (this.pagingProgressPause = this.isMobile), this.progressPaging();
          break;
        case "second_immediately":
          this.changeImage(this.getNextIndex());
          break;
        case "disabled":
          break;
        default:
          throw new Error(`Unknown option ${this.slideshowStyle}`);
      }
    }
    mouseLeaveEvent() {
      (this.pagingProgressPause = !0),
        this.resetSlideshow(),
        this.progressPaging();
    }
    attributeChangedCallback(e, t, i) {
      "hidden" === e && null == t && null != i && this.showVariant();
    }
    toggleMobile() {
      this.container.classList.toggle(Hr, this.isMobile);
    }
    get isMobile() {
      return (
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < window.theme.sizes.medium
      );
    }
    resetSlideshow() {
      const e = this.container.querySelector(`[${$r}]`);
      if (e) {
        let t = Number(e.getAttribute(_r));
        this.changeImage(t);
      } else this.changeImage(0);
      this.pagingProgressPause = !0;
    }
    showVariant() {
      const e = this.container.querySelector(`[${Mr}]`);
      if (e) {
        let t = Number(e.getAttribute(_r));
        this.changeImage(t);
      } else this.changeImage(0);
      this.pagingProgressPause = !0;
    }
    getNextIndex() {
      let e = this.container.querySelector(`[${_r}][${qr}]`);
      if (e) {
        return (Number(e.getAttribute(_r)) + 1) % this.imageCount;
      }
      return 0;
    }
    changeImage(e) {
      const t = this.images[e % this.imageCount];
      t &&
        (this.activeImages.forEach((e) => e.removeAttribute(qr)),
        t.setAttribute(qr, "true"),
        "cycle_images" === this.slideshowStyle && this.changePaging(e));
    }
    changePaging(e = 0) {
      const t = this.container.querySelector(`[${Pr}].${Or}`),
        i = this.container.querySelector(`[${Pr}="${e}"]`);
      t && (t.style.setProperty(Dr, "100%"), t.classList.remove(Or)),
        i && (i.classList.add(Or), this.progressPaging());
    }
    progressPaging() {
      const e = this.container.querySelector(`[${Pr}].${Or}`);
      e &&
        !this.isMobile &&
        (this.stopPaging(),
        0 === this.pagingProgressCounter && e.style.setProperty(Dr, "0%"),
        (this.interval = setInterval(() => {
          this.pagingProgressCounter >= 100 && !this.pagingProgressPause
            ? (this.stopPaging(),
              (this.pagingProgressCounter = 0),
              this.changeImage(this.getNextIndex()))
            : this.pagingProgressPause ||
              (this.pagingProgressCounter++,
              e.style.setProperty(Dr, `${this.pagingProgressCounter}%`));
        }, this.timeout / 100)));
    }
    stopPaging() {
      this.interval && clearInterval(this.interval);
    }
    createPaging() {
      if (this.imagesHolder && "cycle_images" === this.slideshowStyle) {
        let e = "";
        for (let t = 0; t < this.imageCount; t++) {
          let i = "";
          0 === t && (i = `class="${Or}"`),
            (e += `<span ${i} ${Pr}="${t}">${t + 1}</span>`);
        }
        if ("" !== e) {
          let t = this.container.querySelector(`[${Cr}]`);
          t ||
            ((t = document.createElement("div")),
            (t.className = Fr),
            t.setAttribute(Cr, "")),
            (t.innerHTML = e),
            this.imagesHolder.parentElement.prepend(t);
        }
      }
    }
    removePaging() {
      const e = this.container.querySelector(`[${Cr}]`);
      e && e.remove();
    }
    get imagesHolder() {
      return this.container.querySelector(`[${xr}]`);
    }
    get images() {
      return this.imagesHolder.querySelectorAll(`[${_r}]`);
    }
    get activeImages() {
      return this.imagesHolder.querySelectorAll(`[${_r}][${qr}]`);
    }
    get links() {
      return this.container.querySelectorAll(Tr);
    }
    get slideshowStyle() {
      return this.container.getAttribute(Ir);
    }
    get imageCount() {
      return this.images.length;
    }
  }
  const Wr = "data-grid-current-image",
    Nr = "is-active";
  class Rr extends HTMLElement {
    static get observedAttributes() {
      return ["loading", Wr];
    }
    connectedCallback() {
      null === this.getAttribute(Wr) ? this.hide() : this.show();
    }
    attributeChangedCallback(e, t, i) {
      switch (e) {
        case "loading":
          (null !== i && "eager" !== i) || this.eagerLoad();
          break;
        case Wr:
          null === i ? this.hide() : this.show();
      }
    }
    show() {
      this.classList.add(Nr);
    }
    hide() {
      this.classList.remove(Nr);
    }
    eagerLoad() {
      const e = this.firstElementChild;
      switch (e.nodeName) {
        case "TEMPLATE":
          const t = e,
            i = t.content;
          i.querySelectorAll("img").forEach((e) => {
            e.setAttribute("loading", "eager"),
              e.setAttribute("fetchpriority", "high");
          }),
            t.replaceWith(i);
          break;
        case "IMG":
          e.setAttribute("loading", "eager"),
            e.setAttribute("fetchpriority", "high");
      }
    }
  }
  const jr = "[data-popout]",
    zr = "[data-popout-list]",
    Vr = "data-popout-list-scroll",
    Ur = "data-popout-toggle",
    Jr = "[data-popout-input]",
    Gr = "[data-popout-option]",
    Qr = "data-popout-prevent",
    Yr = "data-quantity-field",
    Xr = "data-value",
    Kr = "aria-expanded",
    Zr = "aria-current",
    en = "popout-list--visible",
    tn = "--current";
  class sn extends HTMLElement {
    constructor() {
      super(),
        (this.container = this.querySelector(jr)),
        (this.popoutList = this.container.querySelector(zr)),
        (this.popoutToggle = this.container.querySelector(`[${Ur}]`)),
        (this.outsidePopupToggle = document.querySelector(
          `[${Ur}="${this.popoutList.id}"]`
        )),
        (this.popoutInput = this.container.querySelector(Jr)),
        (this.popoutOptions = this.container.querySelectorAll(Gr)),
        (this.popoutPrevent = "true" === this.container.getAttribute(Qr)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popupListMaxWidth(),
        this.popoutInput &&
          this.popoutInput.hasAttribute(Yr) &&
          document.addEventListener(
            "theme:popout:update",
            this.updatePopout.bind(this)
          ),
        document.addEventListener("theme:resize", () => {
          this.popupListMaxWidth();
        });
    }
    unload() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((e) => {
          e.removeEventListener(
            "theme:popout:click",
            this.popupOptionsClick.bind(this)
          ),
            e.removeEventListener(
              "click",
              this._connectOptionsDispatch.bind(this)
            );
        }),
        this.popoutToggle.removeEventListener(
          "click",
          this.popupToggleClick.bind(this)
        ),
        this.popoutToggle.removeEventListener(
          "focusout",
          this.popupToggleFocusout.bind(this)
        ),
        this.popoutList.removeEventListener(
          "focusout",
          this.popupListFocusout.bind(this)
        ),
        this.container.removeEventListener(
          "keyup",
          this.containerKeyup.bind(this)
        ),
        this.outsidePopupToggle &&
          (this.outsidePopupToggle.removeEventListener(
            "click",
            this.popupToggleClick.bind(this)
          ),
          this.outsidePopupToggle.removeEventListener(
            "focusout",
            this.popupToggleFocusout.bind(this)
          ));
    }
    popupToggleClick(e) {
      const t = "true" === e.currentTarget.getAttribute(Kr);
      e.currentTarget.setAttribute(Kr, !t),
        this.popoutList.classList.toggle(en),
        this.popupListMaxWidth(),
        this.popoutList.hasAttribute(Vr) &&
          setTimeout(() => {
            this.popoutList.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            );
          }, 1);
    }
    popupToggleFocusout(e) {
      this.container.contains(e.relatedTarget) || this._hideList();
    }
    popupListFocusout(e) {
      const t = e.currentTarget.contains(e.relatedTarget);
      this.popoutList.classList.contains(en) && !t && this._hideList();
    }
    popupListMaxWidth() {
      this.popoutList.style.maxWidth = `${parseInt(
        document.body.clientWidth - this.popoutList.getBoundingClientRect().left
      )}px`;
    }
    popupOptionsClick(e) {
      if ("#" === e.target.closest(Gr).attributes.href.value) {
        e.preventDefault();
        let t = "";
        if (
          (e.currentTarget.getAttribute(Xr) &&
            (t = e.currentTarget.getAttribute(Xr)),
          (this.popoutInput.value = t),
          this.popoutPrevent)
        ) {
          this.popoutInput.dispatchEvent(new Event("change")),
            !e.detail.preventTrigger &&
              this.popoutInput.hasAttribute(Yr) &&
              this.popoutInput.dispatchEvent(new Event("input"));
          const i = this.popoutList.querySelector(`[class*="${tn}"]`);
          let s = tn;
          if (i && i.classList.length)
            for (const e of i.classList)
              if (e.includes(tn)) {
                s = e;
                break;
              }
          const r = this.popoutList.querySelector(`.${s}`);
          r &&
            (r.classList.remove(`${s}`),
            e.currentTarget.parentElement.classList.add(`${s}`));
          const n = this.popoutList.querySelector(`[${Zr}]`);
          n &&
            n.hasAttribute(`${Zr}`) &&
            (n.removeAttribute(`${Zr}`),
            e.currentTarget.setAttribute(`${Zr}`, "true")),
            "" !== t &&
              (this.replaceTextContent(this.popoutToggle, t),
              this.outsidePopupToggle &&
                this.replaceTextContent(this.outsidePopupToggle, t)),
            this.popupToggleFocusout(e),
            this.popupListFocusout(e);
        } else this._submitForm(t);
      }
    }
    replaceTextContent(e, t) {
      Array.from(e.childNodes).forEach((e) => {
        e.nodeType === Node.TEXT_NODE && (e.textContent = t);
      });
    }
    updatePopout(e) {
      const t = this.popoutList.querySelector(
        `[${Xr}="${this.popoutInput.value}"]`
      );
      t &&
        t.dispatchEvent(
          new CustomEvent("theme:popout:click", {
            cancelable: !0,
            bubbles: !0,
            detail: { preventTrigger: !0 },
          })
        );
    }
    containerKeyup(e) {
      "Escape" === e.code && (this._hideList(), this.popoutToggle.focus());
    }
    bodyClick(e) {
      const t = this.container.contains(e.target),
        i = this.popoutList.classList.contains(en);
      this.outsidePopupToggle, e.target, i && !t && this._hideList();
    }
    _connectToggle() {
      this.popoutToggle.addEventListener(
        "click",
        this.popupToggleClick.bind(this)
      ),
        this.outsidePopupToggle &&
          this.outsidePopupToggle.addEventListener(
            "click",
            this.popupToggleClick.bind(this)
          );
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((e) => {
          e.addEventListener(
            "theme:popout:click",
            this.popupOptionsClick.bind(this)
          ),
            e.addEventListener(
              "click",
              this._connectOptionsDispatch.bind(this)
            );
        });
    }
    _connectOptionsDispatch(e) {
      const t = new CustomEvent("theme:popout:click", {
        cancelable: !0,
        bubbles: !0,
        detail: { preventTrigger: !1 },
      });
      e.target.dispatchEvent(t) || e.preventDefault();
    }
    _onFocusOut() {
      this.popoutToggle.addEventListener(
        "focusout",
        this.popupToggleFocusout.bind(this)
      ),
        this.outsidePopupToggle &&
          this.outsidePopupToggle.addEventListener(
            "focusout",
            this.popupToggleFocusout.bind(this)
          ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusout.bind(this)
        ),
        this.container.addEventListener(
          "keyup",
          this.containerKeyup.bind(this)
        ),
        document.body.addEventListener("click", this.bodyClick.bind(this));
    }
    _submitForm(e) {
      const t = this.container.closest("form");
      t && t.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(en),
        this.popoutToggle.setAttribute(Kr, !1),
        this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(Kr, !1);
    }
  }
  const rn = (e, t = 500, i = !0) => {
      let s = window.getComputedStyle(e).display;
      if (i && "none" !== s) return;
      e.style.removeProperty("display"),
        "none" === s && (s = "block"),
        (e.style.display = s);
      let r = e.offsetHeight;
      (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.boxSizing = "border-box"),
        (e.style.transitionTimingFunction =
          "cubic-bezier(0.215, 0.61, 0.355, 1)"),
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.height = r + "px"),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            e.style.removeProperty("transition-timing-function");
        }, t);
    },
    nn = (e, t = 500) => {
      (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionTimingFunction =
          "cubic-bezier(0.215, 0.61, 0.355, 1)"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.boxSizing = "border-box"),
        (e.style.height = e.offsetHeight + "px"),
        e.offsetHeight,
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        window.setTimeout(() => {
          (e.style.display = "none"),
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            e.style.removeProperty("transition-timing-function");
        }, t);
    },
    on = "[data-accordion-group]",
    an = "data-accordion-trigger",
    ln = "[data-accordion-body]",
    cn = "data-accordion-body-mobile",
    hn = "data-range-holder",
    dn = "[data-section-id]",
    un = "accordion-is-open";
  let pn = {};
  class mn {
    constructor(e) {
      (this.body = e), (this.key = this.body.id);
      const t = `[${an}='${this.key}']`;
      (this.trigger = document.querySelector(t)),
        (this.toggleEvent = (e) => this.clickEvents(e)),
        (this.keyboardEvent = (e) => this.keyboardEvents(e)),
        (this.hideEvent = () => this.hideEvents()),
        (this.syncBodies = this.getSiblings()),
        this.body.hasAttribute(cn) ? this.mobileAccordions() : this.init();
    }
    mobileAccordions() {
      window.innerWidth < window.theme.sizes.medium
        ? (this.init(), this.setDefaultState())
        : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
        document.addEventListener("theme:resize", () => {
          window.innerWidth < window.theme.sizes.medium
            ? (this.init(), this.setDefaultState())
            : (this.resetMobileAccordions(),
              this.body.removeAttribute("style"));
        });
    }
    init() {
      this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.setDefaultState(),
        this.trigger.addEventListener("click", this.toggleEvent),
        this.body.addEventListener("keyup", this.keyboardEvent),
        this.body.addEventListener("theme:accordion:close", this.hideEvent);
    }
    hideEvents() {
      this.hideAccordion();
    }
    clickEvents(e) {
      e.preventDefault(), this.toggleState();
    }
    keyboardEvents(e) {
      "Escape" === e.code && (this.hideAccordion(), this.trigger.focus());
    }
    resetMobileAccordions() {
      this.trigger.removeEventListener("click", this.toggleEvent),
        this.body.removeEventListener("keyup", this.keyboardEvent),
        this.body.removeEventListener("theme:accordion:close", this.hideEvent);
    }
    setDefaultState() {
      this.trigger.classList.contains(un) ? K(this.body) : this.hideAccordion();
    }
    getSiblings() {
      const e = [...this.body.closest(dn).querySelectorAll(on)]
        .filter((e) => e.contains(this.body))
        .shift();
      if (e) {
        return [...e.querySelectorAll(ln)].filter(
          (e) => !e.contains(this.body)
        );
      }
      return [];
    }
    closeSiblings() {
      this.syncBodies.forEach((e) => {
        e.dispatchEvent(
          new CustomEvent("theme:accordion:close", { bubbles: !1 })
        );
      });
    }
    toggleState() {
      this.trigger.classList.contains(un)
        ? this.hideAccordion()
        : (this.showAccordion(),
          this.closeSiblings(),
          this.body.hasAttribute(hn) &&
            setTimeout(() => {
              document.dispatchEvent(
                new CustomEvent("theme:price-range:reset", { bubbles: !1 })
              );
            }, 400));
    }
    hideAccordion() {
      this.trigger.classList.remove(un), nn(this.body);
    }
    showAccordion() {
      this.trigger.classList.add(un),
        rn(this.body),
        setTimeout(() => {
          this.checkInViewportAndScrollTo();
        }, 600);
    }
    checkInViewportAndScrollTo() {
      const e = this.trigger.getBoundingClientRect(),
        t =
          (window.pageYOffset || document.documentElement.scrollTop) -
          (document.documentElement.clientTop || 0);
      (e.top >= 0 &&
        e.left >= 0 &&
        e.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        e.right <=
          (window.innerWidth || document.documentElement.clientWidth)) ||
        window.scrollTo({ top: t + e.top, left: 0, behavior: "smooth" });
    }
    onBlockSelect(e) {
      this.body.contains(e.target) && this.showAccordion();
    }
    onBlockDeselect(e) {
      this.body.contains(e.target) && this.hideAccordion();
    }
  }
  const fn = {
      onLoad() {
        pn[this.id] = [];
        this.container.querySelectorAll(ln).forEach((e) => {
          pn[this.id].push(new mn(e));
        });
      },
      onUnload: function () {
        pn[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
      onSelect: function () {
        "accordion-single" === this.type &&
          this.container.querySelector(`[${an}]`).click();
      },
      onDeselect: function () {
        "accordion-single" === this.type &&
          this.container.querySelector(`[${an}]`).click();
      },
      onBlockSelect(e) {
        pn[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        pn[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
        });
      },
    },
    gn = (e) => {
      e && (e.style.display = "none");
    },
    yn = 'input[type="search"]',
    vn = '[aria-selected="true"] a',
    bn = 'button[type="reset"]',
    wn = "is-hidden";
  class Sn extends HTMLElement {
    constructor() {
      super(),
        (this.input = this.querySelector(yn)),
        (this.resetButton = this.querySelector(bn)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            T((e) => {
              this.onChange(e);
            }, 300).bind(this)
          ));
    }
    toggleResetButton() {
      const e = this.resetButton.classList.contains(wn);
      this.input.value.length > 0 && e
        ? this.resetButton.classList.remove(wn)
        : 0 !== this.input.value.length ||
          e ||
          this.resetButton.classList.add(wn);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(vn);
    }
    onFormReset(e) {
      e.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          e.target.querySelector(yn).focus());
    }
  }
  customElements.define("header-search-form", Sn);
  const En = '[role="option"]',
    Ln = '[aria-selected="true"]',
    kn = "predictive-search",
    Tn = "[data-predictive-search-results]",
    xn = "[data-predictive-search-status]",
    _n = "[data-predictive-search-input]",
    An = "[data-predictive-search-live-region-count-value]",
    qn = "data-search-results-groups-wrapper",
    Cn = "[data-predictive-search-search-for-text]",
    Pn = "#shopify-section-predictive-search",
    $n = '[aria-selected="true"] a',
    Mn = '[aria-selected="true"] a, button[aria-selected="true"]',
    In = "[data-loading-indicator]";
  class Dn extends Sn {
    constructor() {
      super(),
        (this.wrapper = this),
        (this.a11y = _i),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(kn)),
        (this.cachedResults = {}),
        (this.input = this.wrapper.querySelector(_n)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(Tn)),
        (this.searchTerm = ""),
        (this.loader = this.wrapper.querySelector(In));
    }
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const e = this.getQuery();
      (this.searchTerm && e.startsWith(this.searchTerm)) ||
        this.querySelector(qn)?.remove(),
        this.updateSearchForTerm(this.searchTerm, e),
        (this.searchTerm = e),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(e) {
      (this.getQuery().length && !this.querySelector($n)) || e.preventDefault();
    }
    onFormReset(e) {
      super.onFormReset(e),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector($n);
    }
    onFocus() {
      const e = this.getQuery();
      e.length &&
        (this.searchTerm !== e
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(e) {
      switch (
        (this.getQuery().length || this.close(!0), e.preventDefault(), e.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(e) {
      ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
    }
    updateSearchForTerm(e, t) {
      const i = this.querySelector(Cn),
        s = i?.innerText;
      if (s) {
        if (s.match(e)?.length > 1) return;
        const r = s.replace(e, t);
        i.innerText = r;
      }
    }
    switchOption(e) {
      if (!this.getAttribute("open")) return;
      const t = "up" === e,
        i = this.querySelector(Ln),
        s = Array.from(this.querySelectorAll(En)).filter(
          (e) => null !== e.offsetParent
        );
      let r = 0;
      if (t && !i) return;
      let n = -1,
        o = 0;
      for (; -1 === n && o <= s.length; ) s[o] === i && (n = o), o++;
      if (
        ((this.statusElement.textContent = ""),
        !t && i
          ? (r = n === s.length - 1 ? 0 : n + 1)
          : t && (r = 0 === n ? s.length - 1 : n - 1),
        r === n)
      )
        return;
      const a = s[r];
      a.setAttribute("aria-selected", !0),
        i && i.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const e = this.querySelector(Mn);
      e && e.click();
    }
    getSearchResults(e) {
      const t = e.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[t]
          ? this.renderSearchResults(this.cachedResults[t])
          : (K(this.loader),
            fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                e
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then(this.handleErrors)
              .then((e) => e.text())
              .then((e) => {
                const i = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector(Pn).innerHTML;
                this.allPredictiveSearchInstances.forEach((e) => {
                  e.cachedResults[t] = i;
                }),
                  this.renderSearchResults(i);
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                gn(this.loader);
              }));
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(xn)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(e) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = e),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(e) {
      (this.predictiveSearchResults.innerHTML = e),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(An).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0);
    }
    close(e = !1) {
      this.closeResults(e), (this.isOpen = !1);
    }
    closeResults(e = !1) {
      e && ((this.input.value = ""), this.removeAttribute("results"));
      const t = this.querySelector(Ln);
      t && t.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        this.predictiveSearchResults?.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus();
    }
    handleErrors(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new Z({ status: e.statusText, headers: e.headers, json: t });
          });
    }
  }
  function On() {
    return (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) >= window.theme.sizes.small
    );
  }
  const Hn = 'input[type="search"]';
  class Fn extends Sn {
    constructor() {
      super(),
        (this.allSearchInputs = document.querySelectorAll(Hn)),
        this.setupEventListeners();
    }
    setupEventListeners() {
      let e = [];
      this.allSearchInputs.forEach((t) => e.push(t.form)),
        this.input.addEventListener("focus", this.onInputFocus.bind(this)),
        e.length < 2 ||
          (e.forEach((e) =>
            e.addEventListener("reset", this.onFormReset.bind(this))
          ),
          this.allSearchInputs.forEach((e) =>
            e.addEventListener("input", this.onInput.bind(this))
          ));
    }
    onFormReset(e) {
      super.onFormReset(e),
        super.shouldResetForm() && this.keepInSync("", this.input);
    }
    onInput(e) {
      const t = e.target;
      this.keepInSync(t.value, t);
    }
    onInputFocus() {
      On() || this.scrollIntoView({ behavior: "smooth" });
    }
    keepInSync(e, t) {
      this.allSearchInputs.forEach((i) => {
        i !== t && (i.value = e);
      });
    }
  }
  const Bn = {
      drawer: "data-drawer-scrolls",
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *",
    },
    Wn = "is-visible",
    Nn = "is-hiding",
    Rn = "is-hidden";
  let jn = {};
  class zn {
    constructor(e) {
      (this.sliderule = e),
        (this.wrapper = e.closest(Bn.wrapper)),
        (this.key = this.sliderule.id);
      const t = `[${Bn.slideruleOpen}='${this.key}']`,
        i = `[${Bn.slideruleClose}='${this.key}']`;
      (this.trigger = document.querySelector(t)),
        (this.drawer = document.querySelector(`[${Bn.drawer}]`)),
        (this.exit = document.querySelectorAll(i)),
        (this.pane = document.querySelector(`[${Bn.sliderulePane}]`)),
        (this.children = this.sliderule.querySelectorAll(Bn.children)),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.clickEvents(),
        this.staggerChildAnimations(),
        document.addEventListener(
          "theme:sliderule:close",
          this.closeSliderule.bind(this)
        );
    }
    clickEvents() {
      this.trigger.addEventListener(
        "click",
        function () {
          this.showSliderule();
        }.bind(this)
      ),
        this.exit.forEach((e) => {
          e.addEventListener(
            "click",
            function () {
              this.hideSliderule();
            }.bind(this)
          );
        });
    }
    keyboardEvents() {
      this.trigger.addEventListener(
        "keyup",
        function (e) {
          "Space" === e.code && this.showSliderule();
        }.bind(this)
      ),
        this.sliderule.addEventListener(
          "keyup",
          function (e) {
            "Escape" === e.code &&
              (this.hideSliderule(), this.buttons[0].focus());
          }.bind(this)
        );
    }
    staggerChildAnimations(e = !1) {
      (e
        ? Array.prototype.slice.call(this.children).slice().reverse()
        : this.children
      ).forEach((e, t) => {
        e.style.transitionDelay = 50 * t + 10 + "ms";
      });
    }
    hideSliderule(e = !1) {
      const t = window.getComputedStyle(this.pane),
        i = 1e3 * parseFloat(t.getPropertyValue("transition-duration")),
        s = e ? this.pane.querySelectorAll(`.${Wn}`) : this.children;
      this.pane.style.setProperty("--sliderule-height", "auto"),
        this.staggerChildAnimations(!0),
        this.pane.classList.add(Nn),
        this.sliderule.classList.add(Nn),
        this.sliderule.classList.remove(Wn),
        s.forEach((e) => {
          e.classList.remove(Wn);
        });
      const r = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
      this.pane.setAttribute(Bn.sliderulePane, r);
      const n = e
          ? `[${Bn.dataAnimates}].${Rn}`
          : `[${Bn.dataAnimates}="${r}"].${Rn}`,
        o = this.pane.querySelectorAll(n);
      o.length &&
        o.forEach((e) => {
          e.classList.remove(Rn);
        }),
        setTimeout(() => {
          this.pane.classList.remove(Nn),
            this.sliderule.classList.remove(Nn),
            this.staggerChildAnimations();
        }, i);
    }
    showSliderule() {
      this.pane.style.setProperty("--sliderule-height", "auto"),
        this.sliderule.classList.add(Wn),
        this.children.forEach((e) => {
          e.classList.add(Wn);
        });
      const e = parseInt(this.pane.dataset.sliderulePane, 10),
        t = e + 1;
      this.pane.setAttribute(Bn.sliderulePane, t);
      const i = this.pane.querySelectorAll(`[${Bn.dataAnimates}="${e}"]`);
      if (i.length) {
        const e =
          1e3 *
          parseFloat(
            window
              .getComputedStyle(i[0])
              .getPropertyValue("transition-duration")
          );
        setTimeout(() => {
          i.forEach((e) => {
            e.classList.add(Rn);
          });
        }, e);
      }
      const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
      this.pane.style.setProperty("--sliderule-height", `${s}px`);
      const r = this.drawer.scrollTop,
        n = this.pane.offsetTop;
      n < r &&
        this.pane.offsetHeight >= this.drawer.offsetHeight &&
        this.drawer.scrollTo({ top: n, left: 0, behavior: "smooth" });
    }
    closeSliderule() {
      this.pane &&
        this.pane.hasAttribute(Bn.sliderulePane) &&
        parseInt(this.pane.getAttribute(Bn.sliderulePane)) > 0 &&
        (this.hideSliderule(!0),
        parseInt(this.pane.getAttribute(Bn.sliderulePane)) > 0 &&
          this.pane.setAttribute(Bn.sliderulePane, 0));
    }
  }
  const Vn = {
      onLoad() {
        jn[this.id] = [];
        this.container.querySelectorAll(Bn.slideruleWrappper).forEach((e) => {
          jn[this.id].push(new zn(e));
        });
      },
    },
    Un = "[data-takes-space]",
    Jn = "[data-header-desktop]",
    Gn = "js__header__clone",
    Qn = "js__show__mobile",
    Yn = "[data-header-backfill]",
    Xn = "data-header-transparent",
    Kn = "header-override-border",
    Zn = ".main-content > .shopify-section:first-child [data-overlay-header]",
    eo =
      ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
    to = '.navlink[href="#"]',
    io = "has-overlay";
  let so = {};
  class ro {
    constructor(e) {
      (this.wrapper = e),
        (this.style = this.wrapper.dataset.style),
        (this.desktop = this.wrapper.querySelector(Jn)),
        (this.transparent = "false" !== this.wrapper.getAttribute(Xn)),
        (this.overlayedImages = document.querySelectorAll(Zn)),
        (this.deadLinks = document.querySelectorAll(to)),
        this.killDeadLinks(),
        "drawer" !== this.style &&
          this.desktop &&
          ((this.minWidth = this.getMinWidth()), this.listenWidth()),
        this.checkForImage(),
        window.dispatchEvent(new Event("resize")),
        document.addEventListener(
          "theme:header:check",
          this.checkForImage.bind(this)
        );
    }
    unload() {
      document.removeEventListener("theme:resize", this.checkWidth);
    }
    checkForImage() {
      this.overlayedImages = document.querySelectorAll(Zn);
      let e = document.querySelectorAll(eo).length;
      this.overlayedImages.length && !e && this.transparent
        ? ((document.querySelector(Yn).style.display = "none"),
          this.listenOverlay())
        : this.wrapper.setAttribute(Xn, !1),
        !this.overlayedImages.length ||
          e ||
          this.transparent ||
          (this.wrapper.classList.add(Kn), this.subtractHeaderHeight());
    }
    listenOverlay() {
      document.addEventListener("theme:resize", this.checkWidth.bind(this)),
        this.subtractAnnouncementHeight();
    }
    listenWidth() {
      document.addEventListener("theme:resize", this.checkWidth.bind(this)),
        this.checkWidth();
    }
    killDeadLinks() {
      this.deadLinks.forEach((e) => {
        e.onclick = (e) => {
          e.preventDefault();
        };
      });
    }
    subtractAnnouncementHeight() {
      const { windowHeight: e, announcementHeight: t } = y();
      this.overlayedImages.forEach((i) => {
        i.style.setProperty("--full-screen", e - t + "px"), i.classList.add(io);
      });
    }
    subtractHeaderHeight() {
      const { windowHeight: e, headerHeight: t } = y();
      this.overlayedImages.forEach((i) => {
        i.style.setProperty("--full-screen", e - t + "px");
      });
    }
    checkWidth() {
      document.body.clientWidth < this.minWidth
        ? this.wrapper.classList.add(Qn)
        : this.wrapper.classList.remove(Qn);
    }
    getMinWidth() {
      const e = this.wrapper.cloneNode(!0);
      e.classList.add(Gn), document.body.appendChild(e);
      const t = e.querySelectorAll(Un);
      let i = 0;
      return (
        (i =
          3 === t.length
            ? (function (e) {
                let t = [];
                e.forEach((e) => {
                  t.push(e.clientWidth);
                }),
                  t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]);
                return t.reduce((e, t) => e + t);
              })(t)
            : (function (e) {
                let t = 0;
                return (
                  e.forEach((e) => {
                    t += e.clientWidth;
                  }),
                  t
                );
              })(t)),
        document.body.removeChild(e),
        i + 20 * t.length
      );
    }
  }
  mi("header", [
    {
      onLoad() {
        so = new ro(this.container);
      },
      onUnload: function () {
        "function" == typeof so.unload && so.unload();
      },
    },
    ms,
    Vn,
    ks,
    Bs,
    Ys,
    tr,
    dr,
    Er,
    ut,
    fn,
    Gi,
  ]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", sn),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", Dn),
    customElements.get("main-search") ||
      customElements.define("main-search", Fn);
  const no = "[data-newsletter-form]",
    oo = "has-success",
    ao = "has-error",
    lo = {};
  class co {
    constructor(e) {
      (this.sessionStorage = window.sessionStorage),
        (this.newsletter = e),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(e) {
      this.stopSubmit &&
        (e.preventDefault(),
        e.stopImmediatePropagation(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage = "/challenge" === window.location.pathname;
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }
    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const e = document.getElementById(this.formID);
        -1 !== window.location.search.indexOf("?customer_posted=true")
          ? (e.classList.remove(ao), e.classList.add(oo))
          : -1 !== window.location.search.indexOf("accepts_marketing") &&
            (e.classList.remove(oo), e.classList.add(ao)),
          this.removeStorage(),
          this.scrollToForm(e);
      }
    }
    scrollToForm(e) {
      const t = e.getBoundingClientRect();
      (t.top >= 0 &&
        t.left >= 0 &&
        t.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        t.right <=
          (window.innerWidth || document.documentElement.clientWidth)) ||
        setTimeout(() => {
          window.scroll({ top: t.top, left: 0, behavior: "smooth" });
        }, 400);
    }
    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  const ho = {
      onLoad() {
        lo[this.id] = [];
        this.container.querySelectorAll(no).forEach((e) => {
          lo[this.id].push(new co(e));
        });
      },
      onUnload() {
        lo[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    uo = "[data-shop-pay-wrapper]",
    po = "shop-login-button",
    mo = "shop-follow-button",
    fo = "follow-on-shop-button",
    go = "heart-icon",
    yo = "shop-logo",
    vo = {};
  class bo {
    constructor(e) {
      (this.container = e),
        (this.shopPayWrapper = document.querySelector(uo)),
        (this.shopLoginButton = document.querySelector(po)),
        this.init();
    }
    init() {
      this.shopLoginButton &&
        this.shopPayWrapper &&
        ((this.mainButtonStyles = `\n      :host {\n        --bg-color: ${this.shopPayWrapper.dataset.bg};\n        --text-color: ${this.shopPayWrapper.dataset.text};\n        --hover-color: ${this.shopPayWrapper.dataset.hover};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
        (this.svgIconsStyles = `\n      :host {\n        color: ${this.shopPayWrapper.dataset.text};\n      }\n    `),
        customElements.whenDefined(po).then((e) => {
          requestAnimationFrame(() => {
            const e = this.shopLoginButton.shadowRoot,
              t = e?.querySelector(mo),
              i = t?.shadowRoot,
              s = i?.querySelector(fo),
              r = s?.shadowRoot;
            r && this.overwriteStyles(r.host.shadowRoot, this.mainButtonStyles);
            const n = r.querySelector(go),
              o = n?.shadowRoot,
              a = r.querySelector(yo),
              l = a?.shadowRoot;
            o && this.overwriteStyles(o.host.shadowRoot, this.svgIconsStyles),
              l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles);
          });
        }));
    }
    overwriteStyles(e, t) {
      let i = document.createElement("style");
      (i.innerHTML = t), e.appendChild(i);
    }
  }
  mi("footer", [
    fn,
    ho,
    {
      onLoad() {
        vo[this.id] = new bo(this.container);
      },
    },
  ]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", sn);
  const wo = {
      cc_load_policy: 1,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      controls: 1,
      showinfo: 0,
      ecver: 2,
      fs: 1,
      rel: 0,
    },
    So = "iframe, [data-replace]",
    Eo = "data-video-id";
  function Lo(e, t) {
    const i = { ...wo, ...t },
      s = document.querySelector(`[data-player="${e}"]`),
      r = s.querySelector(So),
      n = s.querySelector(`[${Eo}]`).getAttribute(Eo);
    Ne({ url: "https://www.youtube.com/iframe_api" });
    return window.youtubeLoaderPromise
      .then(() => {
        let e = new window.YT.Player(r, {
          videoId: n,
          playerVars: { ...i },
          events: {
            onStateChange: (e) => {
              1 == e.data
                ? s.dispatchEvent(new CustomEvent("play"))
                : 2 == e.data && s.dispatchEvent(new CustomEvent("pause"));
            },
          },
        });
        return (
          s.addEventListener("pause", () => {
            try {
              e.pauseVideo();
            } catch (e) {
              console.warn(e);
            }
          }),
          s.addEventListener("play", () => {
            try {
              e.playVideo
                ? e.playVideo()
                : e.addEventListener("onReady", () => {
                    e.playVideo();
                  });
            } catch (e) {
              console.warn(e);
            }
          }),
          s.addEventListener("destroy", () => {
            try {
              e.destroy && e.destroy();
            } catch (e) {
              console.warn(e);
            }
          }),
          e
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
  window.youtubeLoaderPromise = new Promise((e) => {
    window.onYouTubeIframeAPIReady = function () {
      e();
    };
  });
  const ko = {
      autoplay: !0,
      loop: !0,
      controls: !0,
      muted: !1,
      playsinline: !0,
    },
    To = "iframe, [data-replace]",
    xo = "data-video-id";
  function _o(e, t) {
    const i = { ...ko, ...t },
      s = document.querySelector(`[data-player="${e}"]`),
      r = s.querySelector(To),
      n = s.querySelector(`[${xo}]`).getAttribute(xo),
      o = Ne({ url: "https://player.vimeo.com/api/player.js" }),
      a = `select-${e}`;
    r.setAttribute("id", a);
    return o
      .then(() => {
        const e = new window.Vimeo.Player(a, { ...i, id: n });
        return (
          e.on("play", () => {
            s.dispatchEvent(new CustomEvent("play"));
          }),
          e.on("pause", () => {
            s.dispatchEvent(new CustomEvent("pause"));
          }),
          s.addEventListener("pause", () => {
            try {
              e.pause && e.pause();
            } catch (e) {
              console.warn(e);
            }
          }),
          s.addEventListener("play", () => {
            e.play &&
              e.getPaused().then((t) => {
                t && e.play();
              });
          }),
          s.addEventListener("destroy", () => {
            try {
              e.destroy && e.destroy();
            } catch (e) {
              console.log(e);
            }
          }),
          e
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
  const Ao = "[data-video-popup]",
    qo = "[data-video-autoplay]",
    Co = "data-unique",
    Po = "data-video-id",
    $o = "data-video-type",
    Mo = "data-player";
  class Io {
    constructor(e) {
      (this.container = e.container),
        (this.triggers = this.container.querySelectorAll(Ao)),
        (this.backgroundVideo = this.container.querySelector(qo)),
        this.init();
    }
    init() {
      this.triggers.forEach((e) => {
        const t = e.getAttribute(Co),
          i = e.getAttribute(Po),
          s = e.getAttribute($o),
          r = `${i}-${t}`,
          o = document.querySelector(`[${Mo}="${r}"]`);
        n.init({
          onShow: () => {
            this.backgroundVideo &&
              "function" == typeof this.backgroundVideo.pause &&
              this.backgroundVideo.pause();
            let e = {};
            "youtube" === s ? (e = Lo(r)) : "vimeo" === s && (e = _o(r)),
              e.then(() => {
                o.dispatchEvent(new CustomEvent("play"));
              });
          },
          onClose: (e, t, i) => {
            i.preventDefault(),
              o.dispatchEvent(new CustomEvent("destroy")),
              this.backgroundVideo &&
                "function" == typeof this.backgroundVideo.play &&
                this.backgroundVideo.play();
          },
          openTrigger: `data-trigger-${i}-${t}`,
        });
      });
    }
  }
  const Do = {
      onLoad() {
        new Io(this);
      },
    },
    Oo = "[data-scroll-down]";
  class Ho {
    constructor(e) {
      (this.wrapper = e), this.init();
    }
    init() {
      const e = this.wrapper.querySelectorAll(Oo);
      e &&
        e.forEach((e) => {
          e.addEventListener("click", this.scroll.bind(this));
        });
    }
    scroll() {
      const e = this.wrapper.offsetTop + this.wrapper.clientHeight;
      window.scroll({ top: e, left: 0, behavior: "smooth" });
    }
  }
  const Fo = {
    onLoad() {
      this.scrollButton = new Ho(this.container);
    },
    onUnload: function () {
      delete this.scrollButton;
    },
  };
  mi("video", [Hi, Fo, Do]), mi("page-faq", fn), mi("hero", [Hi, Fo, bt]);
  const Bo = "[data-slider]",
    Wo = "[data-grid-slide]",
    No = "[data-wrapper]",
    Ro = "data-custom-scrollbar-items",
    jo = "data-show-dots",
    zo = "wrapper",
    Vo = "wrapper--full",
    Uo = window.innerWidth - document.documentElement.clientWidth,
    Jo = 112,
    Go = {};
  class Qo {
    constructor(e, t) {
      if (
        ((this.container = e),
        (this.slideshow = t),
        (this.wrapper = this.container.querySelector(No)),
        (this.wrapperWidth = Number(
          getComputedStyle(document.documentElement)
            .getPropertyValue("--LAYOUT-WIDTH")
            .replace("px", "")
        )),
        (this.wrapperWidthWithGutter = this.wrapperWidth + Jo + Uo),
        (this.pageDots = "true" === this.slideshow.getAttribute(jo)),
        (this.firstPhoto = this.container.querySelector(Wo)),
        this.firstPhoto)
      ) {
        const e = this.firstPhoto.offsetHeight / 2;
        this.slideshow.style.setProperty("--buttons-top", `${e}px`);
      }
      this.slideshow && ((this.flkty = null), this.init());
    }
    init() {
      const e = this,
        t = {
          initialIndex: 0,
          accessibility: !0,
          autoPlay: !1,
          contain: !0,
          pageDots: this.pageDots,
          adaptiveHeight: !1,
          wrapAround: !1,
          groupCells: !1,
          cellAlign: "left",
          freeScroll: !0,
          prevNextButtons: !0,
          draggable: !0,
          rightToLeft: window.isRTL,
          watchCSS: !0,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 67.5, y2: 42.5, x3: 25 },
          on: {
            ready: function () {
              e.removeIncorrectAria();
            },
          },
        };
      (this.flkty = new s(this.slideshow, t)),
        this.container.addEventListener("theme:tab:change", () => {
          this.flkty.resize();
        }),
        this.toggleWrapperModifier(),
        document.addEventListener(
          "theme:resize:width",
          this.toggleWrapperModifier.bind(this)
        ),
        this.slideshow.hasAttribute(Ro) && new vt(this.container),
        new ae(this.container);
    }
    toggleWrapperModifier() {
      this.wrapper.classList.contains(zo) &&
        this.wrapper.classList.toggle(
          Vo,
          this.wrapperWidthWithGutter >= window.innerWidth
        );
    }
    removeIncorrectAria() {
      this.slideshow
        .querySelectorAll('[aria-hidden="true"]')
        .forEach((e) => e.removeAttribute("aria-hidden"));
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
  }
  const Yo = {
    onLoad() {
      Go[this.id] = [];
      this.container.querySelectorAll(Bo).forEach((e) => {
        Go[this.id].push(new Qo(this.container, e));
      });
    },
    onUnload(e) {
      Go[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload(e);
      });
    },
  };
  mi("custom-content", [Hi, Do, ut, Yo]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr);
  const Xo = [],
    Ko = "[data-slideshow-wrapper]",
    Zo = "data-slideshow-speed",
    ea = "data-slideshow-autoplay",
    ta = "data-slideshow-slides",
    ia = "[data-slide-custom-prev]",
    sa = "[data-slide-custom-next]",
    ra = "data-slideshow-index",
    na = "flickity-enabled";
  class oa {
    constructor(e) {
      (this.container = e.container),
        (this.wrapper = e.container.querySelector(Ko)),
        (this.speed = this.wrapper.getAttribute(Zo)),
        (this.autoplay = "true" === this.wrapper.getAttribute(ea)),
        (this.slideCount = parseInt(this.wrapper.getAttribute(ta), 10)),
        (this.prevButtons = this.wrapper.querySelectorAll(ia)),
        (this.nextButtons = this.wrapper.querySelectorAll(sa)),
        (this.flkty = null),
        (this.scrollEvent = () => this.scrollEvents()),
        this.init();
    }
    init() {
      const e = {
        autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
        contain: !1,
        pageDots: !0,
        adaptiveHeight: !0,
        accessibility: !0,
        wrapAround: 2 !== this.slideCount,
        prevNextButtons: !1,
        draggable: !0,
        fade: !0,
        rightToLeft: window.isRTL,
      };
      (this.flkty = new t(this.wrapper, e)),
        this.prevButtons.length &&
          this.prevButtons.forEach((e) => {
            e.onclick = () => {
              this.flkty.previous(!0, !1);
            };
          }),
        this.nextButtons.length &&
          this.nextButtons.forEach((e) => {
            e.onclick = () => {
              this.flkty.next(!0, !1);
            };
          }),
        document.addEventListener("theme:scroll", this.scrollEvent);
    }
    scrollEvents() {
      if (this.flkty && this.autoplay && this.speed) {
        const e = this.flkty.element,
          t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
        window.pageYOffset > t
          ? "playing" === this.flkty.player.state && this.flkty.pausePlayer()
          : "paused" === this.flkty.player.state && this.flkty.playPlayer();
      }
    }
    unload() {
      document.removeEventListener("theme:scroll", this.scrollEvent),
        this.flkty &&
          this.wrapper &&
          this.wrapper.classList.contains(na) &&
          this.flkty.destroy();
    }
    onBlockSelect(e) {
      const t = e.target.closest(`[${ra}]`).getAttribute(ra),
        i = parseInt(t);
      this.flkty.selectCell(i), this.flkty.stopPlayer();
    }
    onBlockDeselect() {
      this.autoplay && this.flkty.playPlayer();
    }
  }
  mi("slideshow", [
    {
      onLoad() {
        Xo[this.id] = new oa(this);
      },
      onUnload() {
        "function" == typeof Xo[this.id].unload && Xo[this.id].unload();
      },
      onBlockSelect(e) {
        "function" == typeof Xo[this.id].onBlockSelect &&
          Xo[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        "function" == typeof Xo[this.id].onBlockSelect &&
          Xo[this.id].onBlockDeselect(e);
      },
    },
    Hi,
    Fo,
  ]);
  const aa = "[data-range-slider]",
    la = "[data-range-left]",
    ca = "[data-range-right]",
    ha = "[data-range-line]",
    da = "[data-range-holder]",
    ua = "data-se-min",
    pa = "data-se-max",
    ma = "data-se-min-value",
    fa = "data-se-max-value",
    ga = "data-se-step",
    ya = "data-range-filter-update",
    va = "[data-field-price-min]",
    ba = "[data-field-price-max]",
    wa = "is-initialized";
  class Sa {
    constructor(e) {
      (this.container = e.container),
        (this.slider = e.querySelector(aa)),
        this.slider &&
          ((this.onMoveEvent = (e) => this.onMove(e)),
          (this.onStopEvent = (e) => this.onStop(e)),
          (this.onStartEvent = (e) => this.onStart(e)),
          (this.startX = 0),
          (this.x = 0),
          (this.touchLeft = this.slider.querySelector(la)),
          (this.touchRight = this.slider.querySelector(ca)),
          (this.lineSpan = this.slider.querySelector(ha)),
          (this.min = parseFloat(this.slider.getAttribute(ua))),
          (this.max = parseFloat(this.slider.getAttribute(pa))),
          (this.step = 0),
          (this.normalizeFact = 26),
          this.init(),
          document.addEventListener("theme:price-range:reset", () => {
            this.setDefaultValues();
          }));
    }
    init() {
      this.setDefaultValues(),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent),
        this.touchRight.addEventListener("touchstart", this.onStartEvent),
        this.slider.classList.add(wa);
    }
    setDefaultValues() {
      let e = this.min;
      this.slider.hasAttribute(ma) &&
        (e = parseFloat(this.slider.getAttribute(ma)));
      let t = this.max;
      this.slider.hasAttribute(fa) &&
        (t = parseFloat(this.slider.getAttribute(fa))),
        e < this.min && (e = this.min),
        t > this.max && (t = this.max),
        e > t && (e = t),
        this.slider.getAttribute(ga) &&
          (this.step = Math.abs(parseFloat(this.slider.getAttribute(ga)))),
        this.reset(),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(e),
        this.setMaxValue(t);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(e) {
      const t = (e - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(ma, e);
    }
    setMaxValue(e) {
      const t = (e - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(fa, e);
    }
    onStart(e) {
      e.preventDefault();
      let t = e;
      e.touches && (t = e.touches[0]),
        e.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : e.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = t.pageX - this.x),
        (this.selectedTouch = e.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent),
        document.addEventListener("touchend", this.onStopEvent);
    }
    onMove(e) {
      let t = e;
      if (
        (e.touches && (t = e.touches[0]),
        (this.x = t.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change"))
      ) {
        new Function("min, max", this.slider.getAttribute("on-change"))(
          this.slider.getAttribute(ma),
          this.slider.getAttribute(fa)
        );
      }
      this.onChange(this.slider.getAttribute(ma), this.slider.getAttribute(fa));
    }
    onStop(e) {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(ma),
          this.slider.getAttribute(fa)
        );
    }
    onChange(e, t) {
      const i = this.slider.closest(da);
      if (i) {
        const s = i.querySelector(va),
          r = i.querySelector(ba);
        s && r && ((s.value = e), (r.value = t));
      }
    }
    onChanged(e, t) {
      this.slider.hasAttribute(ya) &&
        this.slider.dispatchEvent(
          new CustomEvent("theme:range:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const e =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let t = this.lineSpan.offsetLeft / this.initialValue,
        i = t + e;
      if (
        ((t = t * (this.max - this.min) + this.min),
        (i = i * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let e = Math.floor(t / this.step);
        (t = this.step * e),
          (e = Math.floor(i / this.step)),
          (i = this.step * e);
      }
      this.selectedTouch === this.touchLeft && this.slider.setAttribute(ma, t),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(fa, i);
    }
  }
  const Ea = (e, t) => {
      let i, s;
      return function r(...n) {
        const o = Date.now();
        (s = clearTimeout(s)),
          !i || o - i >= t
            ? (e.apply(null, n), (i = o))
            : (s = setTimeout(r.bind(null, ...n), t - (o - i)));
      };
    },
    La = "data-filters",
    ka = "[data-filters-underlay]",
    Ta = "data-default-hide",
    xa = "data-filters-toggle",
    _a =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    Aa = "data-group-heading",
    qa = "data-show-more",
    Ca = "drawer--visible",
    Pa = "filters--default-visible",
    $a = "hidden",
    Ma = "is-hidden",
    Ia = "focus-enabled",
    Da = {};
  class Oa {
    constructor(e, t = !1) {
      (this.container = e),
        (this.underlay = this.container.querySelector(ka)),
        (this.groupHeadings = this.container.querySelectorAll(`[${Aa}]`)),
        (this.showMoreButtons = this.container.querySelectorAll(`[${qa}]`)),
        (this.triggerKey = this.container.getAttribute(La)),
        (this.selector = `[${xa}='${this.triggerKey}']`),
        (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
        (this.connectToggleMemory = (e) => this.connectToggleFunction(e)),
        (this.connectShowHiddenOptions = (e) => this.showHiddenOptions(e)),
        this.connectToggle(t),
        this.onFocusOut(),
        this.expandingEvents(),
        this.getShowOnLoad() ? this.showFilters() : this.hideFilters();
    }
    unload() {
      this.filtersToggleButtons.length &&
        this.filtersToggleButtons.forEach((e) => {
          e.removeEventListener("click", this.connectToggleMemory);
        }),
        this.showMoreButtons.length &&
          this.showMoreButtons.forEach((e) => {
            e.removeEventListener("click", this.connectShowHiddenOptions);
        });
    }
    expandingEvents() {
      this.showMoreButtons.length &&
        this.showMoreButtons.forEach((e) => {
          e.addEventListener("click", Ea(this.connectShowHiddenOptions, 500));
        });
    }
    showHiddenOptions(e) {
      const t = e.target.hasAttribute(qa)
        ? e.target
        : e.target.closest(`[${qa}]`);
      t.classList.add(Ma),
        t.previousElementSibling.querySelectorAll(`.${Ma}`).forEach((e) => {
          e.classList.remove(Ma);
        });
    }
    connectToggle(e = !1) {
      this.filtersToggleButtons.forEach((t) => {
        const i = null !== t.closest(`[${La}]`);
        ((i && e) || (i && !e) || (!i && !e)) &&
          t.addEventListener("click", this.connectToggleMemory.bind(this));
      });
    }
    connectToggleFunction(e) {
      "true" === e.currentTarget.getAttribute("aria-expanded")
        ? this.hideFilters()
        : this.showFilters();
    }
    onFocusOut() {
      this.container.addEventListener(
        "focusout",
        function (e) {
          if (window.innerWidth >= window.theme.sizes.medium) return;
          const t = e.currentTarget.contains(e.relatedTarget),
            i = this.container.classList.contains(Ca);
          document.body.classList.contains(Ia) && i && !t && this.hideFilters();
        }.bind(this)
      ),
        this.container.addEventListener(
          "keyup",
          function (e) {
            "Escape" === e.code &&
              (this.hideFilters(), this.filtersToggleButtons[0].focus());
          }.bind(this)
        ),
        this.underlay.addEventListener(
          "click",
          function () {
            this.hideFilters();
          }.bind(this)
        );
    }
    getShowOnLoad() {
      const e = `[${Ta}='false']`,
        t = document.querySelector(e),
        i = window.innerWidth >= window.theme.sizes.medium;
      return !(!t || !i);
    }
    showFilters() {
      (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
        this.container.classList.remove($a),
        setTimeout(() => {
          this.filtersToggleButtons.forEach((e) =>
            e.setAttribute("aria-expanded", !0)
          ),
            this.filtersToggleButtons.forEach((e) => e.classList.add(Ca)),
            this.container.classList.add(Ca),
            this.container.querySelector(_a).focus();
        }, 1);
    }
    hideFilters() {
      (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
        this.filtersToggleButtons.forEach((e) =>
          e.setAttribute("aria-expanded", !1)
        ),
        this.container.classList.remove(Ca),
        this.container.classList.remove(Pa),
        this.filtersToggleButtons.forEach((e) => e.classList.remove(Ca)),
        this.filtersToggleButtons.forEach((e) => e.classList.remove(Pa)),
        setTimeout(() => {
          this.container.classList.contains(Ca) ||
            this.container.classList.add($a);
        }, 800);
    }
  }
  const Ha = {
      onLoad() {
        Da[this.id] = [];
        this.container.querySelectorAll(`[${La}]`).forEach((e) => {
          Da[this.id].push(new Oa(e));
        });
      },
      onUnload: function () {
        Da[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Fa = {
      collectionSidebar: "[data-collection-sidebar]",
      form: "[data-sidebar-filter-form]",
      inputs: "input, select, label, textarea",
      priceMin: "data-field-price-min",
      priceMax: "data-field-price-max",
      rangeMin: "data-se-min-value",
      rangeMax: "data-se-max-value",
      rangeMinDefault: "data-se-min",
      rangeMaxDefault: "data-se-max",
      productsContainer: "[data-products-grid]",
      filterUpdateUrlButton: "[data-filter-update-url]",
      activeFiltersHolder: "[data-active-filters]",
      activeFiltersCount: "[data-active-filters-count]",
      productsCount: "[data-products-count]",
      dataSort: "data-sort-enabled",
      collectionTools: "[data-collection-tools]",
      filtersWrappper: "[data-filters]",
      headerSticky: '[data-header-sticky="sticky"]',
      headerHeight: "[data-header-height]",
      gridLarge: "data-grid-large",
      gridSmall: "data-grid-small",
      accordionBody: "[data-accordion-body]",
      checkedOption: "input:checked",
      optionHolder: "[data-option-holder]",
    },
    Ba = "is-hidden",
    Wa = "is-loading",
    Na = 1e3,
    Ra = 1e3;
  class ja {
    constructor(e) {
      (this.section = e),
        (this.container = this.section.container),
        (this.sidebar = this.container.querySelector(Fa.collectionSidebar)),
        (this.form = e.container.querySelector(Fa.form)),
        (this.sort = this.container.querySelector(`[${Fa.dataSort}]`)),
        (this.productsContainer = this.container.querySelector(
          Fa.productsContainer
        )),
        (this.activeFiltersHolder = this.container.querySelector(
          Fa.activeFiltersHolder
        )),
        (this.activeFiltersCount = this.container.querySelector(
          Fa.activeFiltersCount
        )),
        (this.productsCount = this.container.querySelector(Fa.productsCount)),
        (this.headerIsSticky =
          null !== document.querySelector(Fa.headerSticky)),
        (this.layoutLarge = this.container.querySelector(`[${Fa.gridLarge}]`)),
        (this.layoutSmall = this.container.querySelector(`[${Fa.gridSmall}]`)),
        this.productsContainer && this.sidebar && this.init(),
        this.sort &&
          this.container.addEventListener("theme:form:filter", (e) =>
            this.filtering(e)
          ),
        (this.sidebar || this.sort) &&
          window.addEventListener("popstate", (e) => this.filtering(e));
    }
    init() {
      this.showAllOptions(),
        this.form &&
          (new Sa(this.form),
          this.sidebar.addEventListener(
            "input",
            T((e) => {
              const t = e.type,
                i = e.target;
              if (
                !Fa.inputs.includes(t) ||
                !this.form ||
                "function" != typeof this.form.submit
              )
                return;
              const s = this.form.querySelector(`[${Fa.priceMin}]`),
                r = this.form.querySelector(`[${Fa.priceMax}]`);
              if (i.hasAttribute(Fa.priceMin) || i.hasAttribute(Fa.priceMax)) {
                const e = this.form.querySelector(`[${Fa.rangeMin}]`),
                  t = this.form.querySelector(`[${Fa.rangeMax}]`),
                  i = parseInt(e.getAttribute(Fa.rangeMinDefault)),
                  n = parseInt(t.getAttribute(Fa.rangeMaxDefault));
                s.value && !r.value && (r.value = n),
                  r.value && !s.value && (s.value = i),
                  s.value <= i &&
                    r.value >= n &&
                    ((s.placeholder = i),
                    (r.placeholder = n),
                    (s.value = ""),
                    (r.value = ""));
              }
              this.filtering(e);
            }, 1500)
          ),
          this.form.addEventListener("theme:range:update", (e) =>
            this.updateRange(e)
          )),
        this.sidebar &&
          this.sidebar.addEventListener("click", (e) =>
            this.updateFilterFromUrl(e)
          ),
        this.activeFiltersHolder &&
          this.activeFiltersHolder.addEventListener("click", (e) =>
            this.updateFilterFromUrl(e)
          ),
        this.productsContainer &&
          this.productsContainer.addEventListener("click", (e) =>
            this.updateFilterFromUrl(e)
          ),
        Je(this.sidebar);
    }
    updateRange(e) {
      if (this.form && "function" == typeof this.form.submit) {
        const t = this.form.querySelector(`[${Fa.rangeMin}]`),
          i = this.form.querySelector(`[${Fa.rangeMax}]`),
          s = this.form.querySelector(`[${Fa.priceMin}]`),
          r = this.form.querySelector(`[${Fa.priceMax}]`);
        if (
          t &&
          i &&
          s &&
          r &&
          t.hasAttribute(Fa.rangeMin) &&
          i.hasAttribute(Fa.rangeMax)
        ) {
          const n = parseInt(s.placeholder),
            o = parseInt(r.placeholder),
            a = parseInt(t.getAttribute(Fa.rangeMin)),
            l = parseInt(i.getAttribute(Fa.rangeMax));
          (n === a && o === l) ||
            ((s.value = a), (r.value = l), this.filtering(e));
        }
      }
    }
    updateFilterFromUrl(e) {
      const t = e.target;
      if (
        t.matches(Fa.filterUpdateUrlButton) ||
        (t.closest(Fa.filterUpdateUrlButton) && t)
      ) {
        e.preventDefault();
        const i = t.matches(Fa.filterUpdateUrlButton)
          ? t
          : t.closest(Fa.filterUpdateUrlButton);
        this.filtering(e, i.getAttribute("href"));
      }
    }
    addToHistory(e, t = "") {
      const i = this.sort ? this.sort.getAttribute(Fa.dataSort) : "";
      if (!e || (e && "popstate" !== e.type)) {
        if ("" === t) {
          const t = new window.URL(window.location.href).searchParams,
            s = Object.fromEntries(t),
            r = t.toString();
          if (
            r.includes("filter.") ||
            r.includes("sort_by") ||
            r.includes("page")
          )
            for (const e in s)
              (e.includes("filter.") ||
                e.includes("sort_by") ||
                e.includes("page")) &&
                t.delete(e);
          if (this.form) {
            const e = new URLSearchParams(new FormData(this.form));
            for (let [i, s] of e.entries())
              i.includes("filter.") && s && t.append(i, s);
            const i = this.form.querySelector(`[${Fa.rangeMin}]`),
              s = this.form.querySelector(`[${Fa.rangeMax}]`),
              r = this.form.querySelector(`[${Fa.priceMin}]`),
              n = this.form.querySelector(`[${Fa.priceMax}]`);
            if (
              i &&
              s &&
              r &&
              n &&
              i.hasAttribute(Fa.rangeMinDefault) &&
              s.hasAttribute(Fa.rangeMaxDefault)
            ) {
              const e = parseFloat(i.getAttribute(Fa.rangeMinDefault), 10),
                o = parseFloat(s.getAttribute(Fa.rangeMaxDefault), 10),
                a =
                  "" === r.value
                    ? parseFloat(r.placeholder, 10)
                    : parseFloat(r.value, 10),
                l =
                  "" === n.value
                    ? parseFloat(n.placeholder, 10)
                    : parseFloat(n.value, 10);
              a <= e &&
                l >= o &&
                (t.delete("filter.v.price.gte"),
                t.delete("filter.v.price.lte"));
            }
          }
          if (i || (e && e.detail && e.detail.href)) {
            const s = i || e.detail.params;
            t.set("sort_by", s);
          }
          const n = t.toString(),
            o = n ? `?${n}` : location.pathname;
          return void window.history.pushState(null, "", o);
        }
        window.history.pushState(null, "", t);
      }
    }
    getFilterResult() {
      this.productsContainer.classList.add(Wa), this.getGridValues();
      const e = new window.URL(window.location.href);
      e.searchParams.set("section_id", this.section.id),
        fetch(`${window.location.pathname}${e.search}`)
          .then((e) => e.text())
          .then((e) => {
            const t = document.createElement("div");
            (t.innerHTML = e),
              this.sidebar &&
                (this.sidebar.innerHTML = t.querySelector(
                  Fa.collectionSidebar
                ).innerHTML),
              this.activeFiltersCount &&
                (this.activeFiltersCount.innerHTML = t.querySelector(
                  Fa.activeFiltersCount
                ).innerHTML),
              (this.productsContainer.innerHTML = t.querySelector(
                Fa.productsContainer
              ).innerHTML),
              (this.activeFiltersHolder.innerHTML = t.querySelector(
                Fa.activeFiltersHolder
              ).innerHTML),
              this.activeFiltersHolder.parentNode.classList.toggle(
                Ba,
                "" === this.activeFiltersHolder.innerHTML
              ),
              this.productsCount &&
                (this.productsCount.innerHTML = t.querySelector(
                  Fa.productsCount
                ).innerHTML),
              this.setGridValues(),
              this.refreshFunctionalities(),
              setTimeout(() => {
                this.productsContainer.classList.remove(Wa);
              }, Na);
          });
          try {
	          if(typeof iWish!=='undefined'){
	            setTimeout(function(){
	              iWish.checkIwishColl();
	            },2500)
	          }
	        } catch (error) {
	          // console.log(error);
	        }
    }
    refreshFunctionalities() {
      (this.form = this.container.querySelector(Fa.form)),
        this.form &&
          (new Sa(this.form),
          this.form.addEventListener("theme:range:update", (e) =>
            this.updateRange(e)
          ));
      this.container.querySelectorAll(Fa.filtersWrappper).forEach((e) => {
        new Oa(e, !0);
      });
      this.container.querySelectorAll(Fa.accordionBody).forEach((e) => {
        new mn(e);
      }),
        new ae(this.container),
        this.sidebar && Je(this.sidebar),
        dt(this.container),
        this.showAllOptions();
    }
    getGridValues() {
      this.layoutLarge &&
        (this.layoutLargeValue = this.layoutLarge.getAttribute(Fa.gridLarge)),
        this.layoutSmall &&
          (this.layoutSmallValue = this.layoutSmall.getAttribute(Fa.gridSmall));
    }
    setGridValues() {
      this.layoutLarge &&
        ((this.layoutLarge = this.container.querySelector(`[${Fa.gridLarge}]`)),
        this.layoutLarge.setAttribute(Fa.gridLarge, this.layoutLargeValue)),
        this.layoutSmall &&
          ((this.layoutSmall = this.container.querySelector(
            `[${Fa.gridSmall}]`
          )),
          this.layoutSmall.setAttribute(Fa.gridSmall, this.layoutSmallValue));
    }
    showAllOptions() {
      this.container.querySelectorAll(Fa.checkedOption).forEach((e) => {
        if (
          e.closest(Fa.optionHolder) &&
          e.closest(Fa.optionHolder).classList.contains(Ba)
        ) {
          const t = e.closest(Fa.accordionBody).nextElementSibling;
          t.classList.contains(Fa.classHidden) ||
            t.dispatchEvent(new Event("click"));
        }
      });
    }
    filtering(e, t = "") {
      const i = this.headerIsSticky
          ? document.querySelector(Fa.headerHeight).getBoundingClientRect()
              .height
          : 0,
        s = this.container.offsetTop - i;
      const r = new IntersectionObserver(
        (i) => {
          const [n] = i;
          setTimeout(
            () => {
              this.addToHistory(e, t), this.getFilterResult();
            },
            n.isIntersecting ? 10 : Ra
          ),
            r.unobserve(this.productsContainer),
            n.isIntersecting ||
              window.scrollTo({ top: s, left: 0, behavior: "smooth" });
        },
        { root: null, rootMargin: `${i}px`, threshold: 1 }
      );
      r.observe(this.productsContainer);
    }
  }
  const za = {
    onLoad() {
      this.filterForm = new ja(this);
    },
    onUnload() {
      this.filterForm &&
        "function" == typeof this.filterForm.unload &&
        this.filterForm.unload();
    },
  };
  mi("search-page", [Ha, za, ut, fn]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", sn),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr);
  const Va = "[data-image-zoom]",
    Ua = "[data-modal-container]",
    Ja = "data-unique",
    Ga = "data-src";
  class Qa {
    constructor(e) {
      (this.container = e),
        (this.triggers = this.container.querySelectorAll(Va)),
        (this.modalContainer = document.querySelector(Ua)),
        this.init();
    }
    init() {
      this.triggers.forEach((e) => {
        const t = e.getAttribute(Ja),
          i = this.modalContainer.querySelector(`#zoom-${t}`);
        if (i) {
          const e = this.container.querySelector(`#zoom-${t}`);
          e &&
            (i.parentNode.removeChild(i), this.modalContainer.appendChild(e));
        }
        n.init({
          disableScroll: !0,
          openTrigger: `data-popup-${t}`,
          onShow: (e) => {
            e.querySelectorAll(`[${Ga}]`, e).forEach((e) => {
              if (null === e.getAttribute("src")) {
                const t = e.getAttribute(Ga);
                e.setAttribute("src", t);
              }
            });
          },
          onClose: (e, t, i) => {
            i.preventDefault();
          },
        });
      });
    }
  }
  mi("gallery", [
    {
      onLoad() {
        new Qa(this.container);
      },
    },
    Do,
    bt,
  ]);
  const Ya = (e, t) => {
    const {
      el: i,
      elStyle: s,
      elHeight: r,
      rowsLimit: n,
      rowsWrapped: o,
      options: a,
    } = e;
    let l = e.buffer,
      c = l;
    if (o === n + 1) return { ...e };
    const h = l;
    let d = o,
      u = r;
    return (
      (i.innerHTML = c =
        l.length
          ? `${l}${a.delimiter}${t}${a.replaceStr}`
          : `${t}${a.replaceStr}`),
      parseFloat(s.height) > parseFloat(r) && (d++, (u = s.height), d === n + 1)
        ? ((i.innerHTML = c =
            "." === h[h.length - 1] && "..." === a.replaceStr
              ? `${h}..`
              : `${h}${a.replaceStr}`),
          { ...e, elHeight: u, rowsWrapped: d })
        : ((i.innerHTML = c = h.length ? `${h}${a.delimiter}${t}` : `${t}`),
          { ...e, buffer: c, elHeight: u, rowsWrapped: d })
    );
  };
  !(function () {
    const e =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;
    document.documentElement.classList.toggle("supports-touch", e);
  })();
  let Xa = {},
    Ka = {},
    Za = {};
  const el = {
    productSlideshow: "[data-product-slideshow]",
    productXr: "[data-shopify-xr]",
    dataMediaId: "data-media-id",
    dataModelId: "data-model-id",
    modelViewer: "model-viewer",
    dataModel3d: "data-shopify-model3d-id",
    modelJson: "#ModelJson-",
  };
  function tl(e) {
    if (e) console.warn(e);
    else if (window.ShopifyXR) {
      for (const e in Xa)
        if (Xa.hasOwnProperty(e)) {
          const t = Xa[e];
          if (t.loaded) continue;
          const i = document.querySelector(`${el.modelJson}${e}`);
          i &&
            (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)),
            (t.loaded = !0));
        }
      window.ShopifyXR.setupXRElements();
    } else
      document.addEventListener("shopify_xr_initialized", function () {
        tl();
      });
  }
  function il(e) {
    if (e) console.warn(e);
    else
      for (const e in Ka)
        if (Ka.hasOwnProperty(e)) {
          const t = Ka[e];
          t.modelViewerUi ||
            (t.modelViewerUi = new Shopify.ModelViewerUI(t.$element)),
            sl(t);
        }
  }
  function sl(e) {
    const t = Za[e.sectionId];
    e.$container.addEventListener("pause", function () {
      e.modelViewerUi.pause && e.modelViewerUi.pause();
    }),
      e.$container.addEventListener("play", function () {
        e.modelViewerUi.play &&
          (e.modelViewerUi.play(),
          t &&
            t.$element &&
            e &&
            e.modelId &&
            el.dataModel3d &&
            t.$element.setAttribute(el.dataModel3d, e.modelId));
      }),
      e.$element.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
        e.$container.dispatchEvent(new CustomEvent("theme:media:play"));
      }),
      e.$element.addEventListener(
        "shopify_model_viewer_ui_toggle_pause",
        () => {
          e.$container.dispatchEvent(new CustomEvent("theme:media:pause"));
        }
      );
  }
  async function rl(e) {
    const t = document.querySelector(`[data-player="${e}"]`),
      i = t.querySelector("video");
    await Ne({ name: "video-ui", version: "1.0" });
    const s = new window.Shopify.Plyr(i);
    return (
      t.addEventListener("pause", () => {
        s.pause && s.pause();
      }),
      t.addEventListener("play", () => {
        try {
          s.play
            ? s.paused && s.play()
            : s.addEventListener("onReady", () => {
                s.play();
              });
        } catch (e) {
          console.warn(e);
        }
      }),
      t.addEventListener("destroy", () => {
        try {
          s.destroy && s.destroy();
        } catch (e) {
          console.warn(e);
        }
      }),
      s
    );
  }
  const nl = {
      productSlideshow: "[data-product-slideshow]",
      slideshowMobileStyle: "data-slideshow-mobile-style",
      slideshowDesktopStyle: "data-slideshow-desktop-style",
      productThumbs: "[data-product-thumbs]",
      leftThumbsHolder: "[data-thumbs-holder]",
      thumbImage: "[data-slideshow-thumbnail]",
      mediaSlide: "[data-media-slide]",
      dataMediaId: "data-media-id",
      dataMediaSelect: "data-media-select",
      mediaType: "data-type",
      videoPlayerExternal: '[data-type="external_video"]',
      videoPlayerNative: '[data-type="video"]',
      modelViewer: '[data-type="model"]',
      modelViewerTag: "model-viewer",
      allPlayers: "[data-player]",
      loopVideo: "data-enable-video-looping",
      verticalAlignment: "[data-thumbnails-left]",
      arrowPrev: "[data-thumbs-arrow-prev]",
      arrowNext: "[data-thumbs-arrow-next]",
      aspectRatio: "data-aspect-ratio",
      flickitylockHeight: "flickity-lock-height",
    },
    ol = "is-activated",
    al = "show",
    ll = "enable-video-draggable",
    cl = "hide";
  class hl {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.slideshow = this.container.querySelector(nl.productSlideshow)),
        (this.mobileStyle = this.slideshow.getAttribute(
          nl.slideshowMobileStyle
        )),
        (this.desktopStyle = this.slideshow.getAttribute(
          nl.slideshowDesktopStyle
        )),
        (this.arrowPrev = this.container.querySelector(nl.arrowPrev)),
        (this.arrowNext = this.container.querySelector(nl.arrowNext)),
        (this.leftThumbsHolder = this.container.querySelector(
          nl.leftThumbsHolder
        )),
        (this.thumbWrapper = this.container.querySelector(nl.productThumbs)),
        (this.thumbImages = this.container.querySelectorAll(nl.thumbImage)),
        (this.loopVideo = "true" === this.container.getAttribute(nl.loopVideo)),
        (this.verticalAlignment = Boolean(
          this.container.querySelector(nl.verticalAlignment)
        )),
        (this.flkty = null),
        (this.lastMediaSelect = null),
        (this.thumbs = this.container.querySelector(nl.productThumbs)),
        (this.currentSlide = null),
        (this.mediaType = null),
        (this.hasMobileSlider = !1),
        (this.hasDesktopSlider = !1),
        this.init();
    }
    init() {
      this.storeEvents(),
        this.connectSliderMediaEvents(),
        this.detectVideos(),
        this.detect3d(),
        this.scrollThumbs(),
        document.addEventListener("theme:resize:width", () => {
          this.scrollThumbs();
        }),
        Ce.onChange(() => {
          this.connectSliderMediaEvents();
        });
    }
    connectSliderMediaEvents() {
      Ce.isMobile() ? this.createMobileSlider() : this.createDesktopSlider();
    }
    createMobileSlider() {
      this.hasDesktopSlider &&
        this.flkty &&
        (this.destroySlider(), (this.hasDesktopSlider = !1));
      const e = {
        autoPlay: !1,
        prevNextButtons: !1,
        pageDots: !1,
        adaptiveHeight: !0,
        accessibility: !0,
        watchCSS: !1,
        wrapAround: !0,
        rightToLeft: window.isRTL,
        dragThreshold: 80,
        contain: !0,
        fade: !0,
      };
      "carousel" == this.mobileStyle &&
        ((e.contain = !1), (e.dragThreshold = 10), (e.fade = !1)),
        "slideshow" == this.mobileStyle &&
          ((e.pageDots = !0), (e.fade = !1), (e.dragThreshold = 10)),
        "none" != this.mobileStyle &&
          (this.createSlider(e), (this.hasMobileSlider = !0));
    }
    createDesktopSlider() {
      if (
        (this.hasMobileSlider &&
          this.flkty &&
          (this.destroySlider(), (this.hasMobileSlider = !1)),
        "none" == this.desktopStyle)
      )
        return;
      const e = {
        autoPlay: !1,
        prevNextButtons: !1,
        pageDots: !1,
        adaptiveHeight: !0,
        accessibility: !0,
        watchCSS: !1,
        wrapAround: !0,
        rightToLeft: window.isRTL,
        dragThreshold: 80,
        contain: !0,
        fade: !0,
      };
      this.createSlider(e), (this.hasDesktopSlider = !0);
    }
    createSlider(e) {
      (this.flkty = new s(this.slideshow, e)),
        this.flkty.resize(),
        (this.currentSlide = this.slideshow.querySelectorAll(nl.mediaSlide)[0]),
        this.setDraggable(),
        this.addEventListeners();
    }
    destroySlider() {
      this.removeEventListeners(), this.flkty.destroy();
    }
    storeEvents() {
      (this.storeFlktyChange = (e) => this.doFlktyChange(e)),
        (this.storeFlktySettle = (e) => this.doFlktySettle(e)),
        (this.storeImageChange = (e) => this.doImageChange(e)),
        (this.storeArrowPrevClick = (e) => this.doArrowPrevClick(e)),
        (this.storeArrowNextClick = (e) => this.doArrowNextClick(e)),
        (this.storeThumbClick = (e) => this.doThumbClick(e)),
        (this.storeThumbContainerScroll = (e) =>
          this.doThumbContainerScroll(e));
    }
    addEventListeners() {
      this.flkty.on("change", this.storeFlktyChange),
        this.flkty.on("settle", this.storeFlktySettle),
        this.slideshow.addEventListener(
          "theme:image:change",
          this.storeImageChange
        ),
        this.arrowPrev?.addEventListener("click", this.storeArrowPrevClick),
        this.arrowNext?.addEventListener("click", this.storeArrowNextClick),
        this.thumbs?.addEventListener("scroll", this.storeThumbContainerScroll),
        this.thumbImages.forEach((e) => {
          e.addEventListener("click", this.storeThumbClick);
        });
    }
    removeEventListeners() {
      this.flkty.on("change", this.storeFlktyChange),
        this.flkty.on("settle", this.storeFlktySettle),
        this.slideshow.removeEventListener(
          "theme:image:change",
          this.storeImageChange
        ),
        this.arrowPrev?.removeEventListener("click", this.storeArrowPrevClick),
        this.arrowNext?.removeEventListener("click", this.storeArrowNextClick),
        this.thumbs?.removeEventListener(
          "scroll",
          this.storeThumbContainerScroll
        ),
        this.thumbImages.forEach((e) => {
          e.removeEventListener("click", this.storeThumbClick);
        });
    }
    addMediaEventListeners(e) {
      e &&
        (e.addEventListener("play", () => {
          (Ce.isMobile() || Ce.isTouch()) && this.updateDraggable(!1);
        }),
        e.addEventListener("pause", () => {
          (Ce.isMobile() || Ce.isTouch()) && this.updateDraggable(!0);
        }));
    }
    doFlktyChange(e) {
      ("model" !== this.mediaType &&
        "video" !== this.mediaType &&
        "external_video" !== this.mediaType) ||
        this.currentSlide.dispatchEvent(new CustomEvent("pause")),
        (this.currentSlide = this.flkty.cells[e].element),
        this.slideshow.classList.remove(nl.flickitylockHeight);
      const t = this.currentSlide.getAttribute(nl.dataMediaId),
        i = this.thumbWrapper?.querySelector(`[${nl.dataMediaSelect}="${t}"]`);
      this.thumbWrapper?.querySelector(`.${ol}`).classList.remove(ol),
        i?.classList.add(ol),
        this.scrollThumbs(),
        setTimeout(() => {
          (i?.classList.contains(cl) ||
            this.currentSlide.classList.contains(cl)) &&
            (this.lastMediaSelect
              ? this.slideshow.dispatchEvent(
                  new CustomEvent("theme:image:change", {
                    detail: { id: this.lastMediaSelect },
                  })
                )
              : window.location.reload());
        });
    }
    doFlktySettle(e) {
      (this.allSlides = this.flkty.cells),
        (this.currentSlide = this.flkty.cells[e].element),
        this.setDraggable();
      document.body.classList.contains(nl.focusEnabled) &&
        this.currentSlide.dispatchEvent(new Event("focus")),
        this.scrollThumbs();
    }
    doImageChange(e) {
      var t = e.detail.id;
      this.lastMediaSelect = t;
      const i = `[${nl.dataMediaId}="${t}"]`,
        s = this.flkty.cells.findIndex((e) => e.element.matches(i));
      this.flkty.select(s), this.scrollThumbs();
    }
    doThumbContainerScroll() {
      this.scrollThumbs("scroll");
    }
    doArrowPrevClick() {
      this.scrollThumbs("clickPrev");
    }
    doArrowNextClick() {
      this.scrollThumbs("clickNext");
    }
    doThumbClick(e) {
      const t = e.currentTarget.getAttribute(nl.dataMediaSelect);
      this.slideshow.dispatchEvent(
        new CustomEvent("theme:image:change", { detail: { id: t } })
      );
    }
    setDraggable() {
      this.currentSlide &&
        ((this.mediaType = this.currentSlide.getAttribute(nl.mediaType)),
        "model" === this.mediaType ||
        "video" === this.mediaType ||
        "external_video" === this.mediaType
          ? Ce.isMobile() && Ce.isTouch()
            ? this.updateDraggable(!0)
            : (this.currentSlide.dispatchEvent(new CustomEvent("play")),
              this.updateDraggable(!1))
          : this.updateDraggable(!0));
    }
    updateDraggable(e) {
      this.flkty &&
        ((this.flkty.options.draggable = e),
        this.flkty.updateDraggable(),
        this.slideshow.classList.toggle(ll, e));
    }
    detect3d() {
      const e = this.container.querySelectorAll(nl.modelViewer);
      e &&
        (e.forEach((e) => {
          !(function (e, t) {
            Xa[t] = { loaded: !1 };
            const i = e.getAttribute(el.dataMediaId),
              s = e.querySelector(el.modelViewer),
              r = s.getAttribute(el.dataModelId);
            if (null !== e.closest(el.productSlideshow)) {
              const i = e
                .closest(el.productSlideshow)
                .parentElement.querySelector(el.productXr);
              Za[t] = { $element: i, defaultId: r };
            }
            (Ka[i] = {
              modelId: r,
              mediaId: i,
              sectionId: t,
              $container: e,
              $element: s,
            }),
              window.Shopify.loadFeatures([
                { name: "shopify-xr", version: "1.0", onLoad: tl },
                { name: "model-viewer-ui", version: "1.0", onLoad: il },
              ]);
          })(e, this.section.id),
            e.addEventListener("theme:media:play", () => {
              this.updateDraggable(!1);
            }),
            e.addEventListener("theme:media:pause", () => {
              this.updateDraggable(!0);
            });
        }),
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            this.container.querySelectorAll(nl.allPlayers).forEach((e) => {
              e.dispatchEvent(new CustomEvent("pause"));
            });
          }.bind(this)
        ));
    }
    detectVideos() {
      const e = this.section.container.querySelectorAll(
        `${nl.videoPlayerExternal}, ${nl.videoPlayerNative}`
      );
      for (var t of e) {
        const e = t.dataset.player,
          i = t.dataset.host;
        let s;
        (s = "youtube" === i ? Lo(e) : "vimeo" === i ? _o(e) : rl(e)),
          !0 === this.loopVideo &&
            s
              .then((e) => (i ? dl(e, i) : ((e.loop = !0), e)))
              .catch((e) => {
                console.error(e);
              }),
          this.addMediaEventListeners(t);
      }
    }
    pauseAllMedia() {
      this.container
        .querySelector(nl.mediaSlide)
        .dispatchEvent(new CustomEvent("pause"));
    }
    pauseOtherMedia(e) {
      this.container
        .querySelector(`${nl.mediaSlide}:not([data-player="${e}"])`)
        .dispatchEvent(new CustomEvent("pause"));
    }
    destroy() {
      this.container.querySelectorAll(nl.allPlayers).forEach((e) => {
        e.dispatchEvent(new CustomEvent("destroy"));
      });
    }
    scrollThumbs(e) {
      if (
        ((this.thumbs = this.container.querySelector(nl.productThumbs)),
        this.thumbs)
      ) {
        if (
          ((this.thumb = this.thumbs.querySelector(`.${ol}`)),
          (this.thumbItems = this.container.querySelectorAll(nl.thumbImage)),
          (this.lastThumb = this.thumbItems[this.thumbItems.length - 1]),
          !this.thumb)
        )
          return;
        (this.thumbsScrollTop = this.thumbs.scrollTop),
          (this.thumbsScrollLeft = this.thumbs.scrollLeft),
          (this.thumbsWidth = this.thumbs.offsetWidth),
          (this.thumbsHeight =
            this.slideshow.offsetWidth /
            this.thumb.getAttribute(nl.aspectRatio)),
          (this.thumbsPositionBottom =
            this.thumbsScrollTop + this.thumbsHeight),
          (this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth),
          this.checkThumbPositions(),
          this.toggleToActiveThumb(e),
          this.toggleArrows();
      }
    }
    checkThumbPositions() {
      (this.thumbWidth = this.thumb.offsetWidth),
        (this.thumbHeight = this.thumb.offsetHeight),
        (this.thumbPosTop = this.thumb.offsetTop),
        (this.thumbPosLeft = this.thumb.offsetLeft),
        (this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth),
        (this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight),
        (this.scrollTopPosition =
          this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2),
        (this.scrollLeftPosition =
          this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2),
        (this.topCheck = this.thumbsScrollTop > 0),
        (this.bottomCheck =
          this.thumbsPositionBottom < this.lastThumbBottomPos),
        (this.leftCheck = this.thumbsScrollLeft > 0),
        (this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos),
        (this.verticalCheck = this.bottomCheck || this.topCheck),
        (this.horizontalCheck = this.rightCheck || this.leftCheck);
    }
    toggleToActiveThumb(e) {
      "scroll" !== e &&
        ("clickPrev" == e &&
          (this.verticalCheck
            ? ((this.scrollTopPosition =
                this.thumbsScrollTop - this.thumbsHeight),
              (this.scrollLeftPosition = 0))
            : ((this.scrollTopPosition = 0),
              (this.scrollLeftPosition =
                this.thumbsScrollLeft - this.thumbsWidth))),
        "clickNext" == e &&
          (this.verticalCheck
            ? ((this.scrollTopPosition =
                this.thumbsScrollTop + this.thumbsHeight),
              (this.scrollLeftPosition = 0))
            : ((this.scrollTopPosition = 0),
              (this.scrollLeftPosition =
                this.thumbsScrollLeft + this.thumbsWidth))),
        this.thumbs.scrollTo({
          top: this.scrollTopPosition,
          left: this.scrollLeftPosition,
          behavior: "smooth",
        }));
    }
    toggleArrows() {
      (this.verticalCheck || (this.verticalAlignment && !this.verticalCheck)) &&
        (this.arrowPrev.classList.toggle(al, this.topCheck),
        this.arrowNext.classList.toggle(al, this.bottomCheck)),
        (this.horizontalCheck ||
          (!this.verticalAlignment && !this.horizontalCheck)) &&
          (this.arrowPrev.classList.toggle(al, this.leftCheck),
          this.arrowNext.classList.toggle(al, this.rightCheck));
    }
  }
  function dl(e, t) {
    return (
      "youtube" === t
        ? e.addEventListener("onStateChange", (e) => {
            0 === e.data && e.target.playVideo();
          })
        : "vimeo" === t &&
          e.on("ended", () => {
            e.play();
          }),
      e
    );
  }
  const ul = "data-store-availability-container",
    pl = "[data-api-content]",
    ml = "[data-pickup-drawer]",
    fl = "[data-pickup-drawer-open]",
    gl = "[data-pickup-drawer-close]",
    yl = "[data-pickup-body]",
    vl = "drawer--visible",
    bl = "hide",
    wl = "is-pickup-visible";
  let Sl = {};
  class El {
    constructor(e) {
      (this.container = e.container),
        (this.drawer = null),
        (this.buttonDrawerOpen = null),
        (this.buttonDrawerClose = null),
        (this.drawerBody = null),
        this.fetchPickupAvailability(),
        this.container.addEventListener("theme:variant:change", (e) =>
          this.fetchPickupAvailability(e)
        );
    }
    fetchPickupAvailability(e) {
      const t = this.container.querySelector(`[${ul}]`);
      if (!t) return;
      const i =
        e && e.detail.variant ? e.detail.variant.id : t.getAttribute(ul);
      !e || e.detail.variant
        ? i &&
          fetch(
            `${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`
          )
            .then(this.handleErrors)
            .then((e) => e.text())
            .then((e) => {
              const i = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(pl).innerHTML;
              (t.innerHTML = i),
                t.classList.remove(bl),
                (this.drawer = this.container.querySelector(ml)),
                (this.buttonDrawerOpen = this.container.querySelector(fl)),
                (this.buttonDrawerClose = this.container.querySelectorAll(gl)),
                (this.drawerBody = this.container.querySelector(yl)),
                this.buttonDrawerOpen &&
                  this.buttonDrawerOpen.addEventListener("click", () =>
                    this.openDrawer()
                  ),
                this.buttonDrawerClose.length &&
                  this.buttonDrawerClose.forEach((e) => {
                    e.addEventListener("click", () => this.closeDrawer());
                  });
            })
            .catch((e) => {
              console.error(e);
            })
        : t.classList.add(bl);
    }
    openDrawer() {
      this.drawer &&
        (document.body.classList.add(wl),
        this.drawer.classList.add(vl),
        this.drawer.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.drawerBody.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ));
    }
    closeDrawer() {
      this.drawer &&
        (document.body.classList.remove(wl),
        this.drawer.classList.remove(vl),
        this.drawer.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        this.drawerBody.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ));
    }
    handleErrors(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new Z({ status: e.statusText, headers: e.headers, json: t });
          });
    }
  }
  const Ll = {
      onLoad() {
        Sl[this.id] = new El(this);
      },
    },
    kl = "[data-quantity-selector]",
    Tl = "[data-increase-quantity]",
    xl = "[data-decrease-quantity]",
    _l = "[data-quantity-input]";
  class Al {
    constructor(e) {
      (this.wrapper = e),
        (this.increase = this.wrapper.querySelector(Tl)),
        (this.decrease = this.wrapper.querySelector(xl)),
        (this.input = this.wrapper.querySelector(_l)),
        (this.min = parseInt(this.input.getAttribute("min"), 10)),
        this.initButtons();
    }
    initButtons() {
      this.increase.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          let t = parseInt(this.input.value, 10);
          (t = isNaN(t) ? 0 : t),
            t++,
            (this.input.value = t),
            this.input.dispatchEvent(new Event("change"));
        }.bind(this)
      ),
        this.decrease.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            let t = parseInt(this.input.value, 10);
            (t = isNaN(t) ? 0 : t),
              t--,
              (t = Math.max(this.min, t)),
              (this.input.value = t),
              this.input.dispatchEvent(new Event("change"));
          }.bind(this)
        );
    }
  }
  function ql(e) {
    e.querySelectorAll(kl).forEach((e) => {
      new Al(e);
    });
  }
  const Cl = "[data-product-form]",
    Pl = "data-option-position",
    $l = '[name^="options"], [data-popout-option]',
    Ml = "data-value",
    Il = "sold-out",
    Dl = "unavailable";
  class Ol {
    constructor(e, t) {
      (this.container = e),
        (this.productJSON = t),
        (this.form = this.container.querySelector(Cl)),
        (this.formData = new FormData(this.form)),
        (this.optionElements = this.container.querySelectorAll($l)),
        this.productJSON && this.form && this.init();
    }
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((e) => {
          const t = e.value || e.getAttribute(Ml),
            i = e.closest(`[${Pl}]`).getAttribute(Pl),
            s = parseInt(i, 10) - 1;
          let r = [...this.selections];
          r[s] = t;
          const n = this.productJSON.variants.find((e) => {
            let t = !0;
            for (let i = 0; i < r.length; i++)
              e.options[i] !== r[i] && (t = !1);
            return t;
          });
          e.classList.remove(Il, Dl),
            void 0 === n
              ? e.classList.add(Dl)
              : n && !1 === n.available && e.classList.add(Il);
        });
    }
    getCurrentState() {
      for (var e of ((this.formData = new FormData(this.form)),
      (this.selections = []),
      this.formData.entries()))
        e[0].includes("options[") && this.selections.push(e[1]);
    }
  }
  const Hl = "[data-section-id]",
    Fl = "[data-quickview-modal]",
    Bl = "[data-product-form-wrapper]",
    Wl = "[data-product-form]",
    Nl = "[data-product-slideshow]",
    Rl = "[data-add-to-cart]",
    jl = "[data-add-to-cart-text]",
    zl = "[data-compare-price]",
    Vl = "[data-compare-text]",
    Ul = "[data-buttons-wrapper]",
    Jl = "[data-product-select]",
    Gl = "[data-price-wrapper]",
    Ql = "[data-button-price]",
    Yl = "[data-product-json]",
    Xl = "[data-product-price]",
    Kl = "[data-product-unit-price]",
    Zl = "[data-product-base]",
    ec = "[data-product-unit]",
    tc = "data-enable-history-state",
    ic = "data-option-position",
    sc = "[data-option-value]",
    rc = "[data-subscription-watch-price]",
    nc = "[data-subscription-selectors]",
    oc = "[data-price-off]",
    ac = "[data-price-off-type]",
    lc = "[data-price-off-amount]",
    cc = "[data-toggles-group]",
    hc = "data-group-toggle",
    dc = "[data-plan-description]",
    uc = "[data-remaining-count]",
    pc = "data-remaining-max",
    mc = "[data-remaining-wrapper]",
    fc = "[data-product-remaining-json]",
    gc = "[data-product-preorder]",
    yc = "hide",
    vc = "variant--soldout",
    bc = "variant--unavailable",
    wc = "product__price--sale",
    Sc = "count-is-low",
    Ec = "count-is-in",
    Lc = "count-is-out",
    kc = "count-is-unavailable";
  class Tc extends HTMLElement {
    constructor() {
      super(), (this.container = this);
    }
    connectedCallback() {
      (this.outerSection = this.container.closest(Hl)),
        (this.quickview = this.container.closest(Fl)),
        (this.outerWrapper = this.quickview
          ? this.quickview
          : this.outerSection),
        (this.productFormWrapper = this.container.closest(Bl)),
        (this.productFormElement = this.container.querySelector(Wl)),
        (this.productForm = this.container.querySelector(Wl)),
        (this.slideshow = this.outerWrapper.querySelector(Nl)),
        (this.enableHistoryState =
          !(!this.outerSection || !this.outerSection.hasAttribute(tc)) &&
          "true" === this.outerSection.getAttribute(tc)),
        (this.hasUnitPricing = this.outerWrapper.querySelector(ec)),
        (this.subSelectors = this.outerWrapper.querySelector(nc)),
        (this.subPrices = this.outerWrapper.querySelector(rc)),
        (this.priceOffWrap = this.outerWrapper.querySelector(oc)),
        (this.priceOffAmount = this.outerWrapper.querySelector(lc)),
        (this.priceOffType = this.outerWrapper.querySelector(ac)),
        (this.planDecription = this.outerWrapper.querySelector(dc)),
        (this.isPreOrder = this.container.querySelector(gc)),
        (this.remainingWrapper = this.outerWrapper.querySelector(mc));
      const e = this.outerWrapper.querySelector(`[${pc}]`);
      (this.sellout = null),
        this.remainingWrapper &&
          e &&
          ((this.remainingMaxInt = parseInt(e.getAttribute(pc), 10)),
          (this.remainingCount = this.outerWrapper.querySelector(uc)),
          (this.remainingJSONWrapper = this.outerWrapper.querySelector(fc)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON")),
        ql(this.outerWrapper);
      let t = null;
      this.productJSON = null;
      const i = this.outerWrapper.querySelector(Yl);
      i && (t = i.innerHTML),
        t && this.productForm
          ? ((this.productJSON = JSON.parse(t)),
            (this.sellout = new Ol(this.outerWrapper, this.productJSON)),
            this.linkForm())
          : console.warn("Missing product form or product JSON"),
        this.productJSON && new Ae(this.productJSON.handle);
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new Be(
        this.outerWrapper,
        this.productFormElement,
        this.productJSON,
        {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
          onQuantityChange: this.onQuantityChange.bind(this),
        }
      )),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(e) {
      this.pushState(e.dataset);
    }
    onPlanChange(e) {
      this.subPrices && this.pushState(e.dataset);
    }
    onQuantityChange(e) {
      const t = e.dataset;
      (this.productState = this.setProductState(t)), this.updateButtonPrices(t);
    }
    pushState(e, t = !1) {
      (this.productState = this.setProductState(e)),
        this.updateProductImage(e),
        this.updateAddToCartState(e),
        this.updateProductPrices(e),
        this.updateSaleText(e),
        this.updateSubscriptionText(e),
        this.updateLegend(e),
        this.updateRemaining(e),
        this.fireHookEvent(e),
        this.sellout && this.sellout.update(e),
        this.enableHistoryState && !t && this.updateHistoryState(e);
    }
    updateAddToCartState(e) {
      const t = e.variant;
      let i = theme.strings.addToCart;
      const s = this.outerWrapper.querySelectorAll(Gl),
        r = this.outerWrapper.querySelector(Ul),
        n = r?.querySelectorAll(Rl),
        o = r?.querySelectorAll(jl);
      if (
        (this.isPreOrder && (i = theme.strings.preOrder),
        s.length &&
          t &&
          s.forEach((e) => {
            e.classList.remove(yc);
          }),
        n?.length &&
          n.forEach((e) => {
            t && t.available ? (e.disabled = !1) : (e.disabled = !0);
          }),
        o?.length &&
          o.forEach((e) => {
            t
              ? t.available
                ? (e.innerHTML = i)
                : (e.innerHTML = theme.strings.soldOut)
              : (e.innerHTML = theme.strings.unavailable);
          }),
        r && t)
      ) {
        const e = r.querySelector(Jl);
        e && (e.value = t.id);
      }
      r &&
        this.productFormWrapper &&
        (t
          ? t.available
            ? this.productFormWrapper.classList.remove(vc, bc)
            : (this.productFormWrapper.classList.add(vc),
              this.productFormWrapper.classList.remove(bc))
          : (this.productFormWrapper.classList.add(bc),
            this.productFormWrapper.classList.remove(vc)));
    }
    updateLegend(e) {
      const t = e.variant;
      if (t) {
        this.container.parentNode.querySelectorAll(sc).forEach((e) => {
          const i = e.closest(`[${ic}]`);
          if (i) {
            const s = i.getAttribute(ic),
              r = parseInt(s, 10) - 1;
            (this.newValue = t.options[r]), (e.innerHTML = this.newValue);
          }
        });
      }
    }
    updateHistoryState(e) {
      const t = e.variant,
        i = e.plan,
        s = window.location.href;
      if (t && s.includes("/product")) {
        const e = new window.URL(s),
          r = e.searchParams;
        r.set("variant", t.id),
          i && i.detail && i.detail.id && this.productState.hasPlan
            ? r.set("selling_plan", i.detail.id)
            : r.delete("selling_plan"),
          (e.search = r.toString());
        const n = e.toString();
        window.history.replaceState({ path: n }, "", n);
      }
    }
    updateRemaining(e) {
      const t = e.variant;
      if (
        t &&
        this.remainingWrapper &&
        this.remainingJSON &&
        this.remainingCount
      ) {
        const e = this.remainingJSON[t.id];
        e && e <= this.remainingMaxInt && e > 0
          ? (this.remainingWrapper.classList.remove(Ec, Lc, kc),
            this.remainingWrapper.classList.add(Sc),
            (this.remainingCount.innerHTML = e))
          : this.productState.soldOut
          ? (this.remainingWrapper.classList.remove(Sc, Ec, kc),
            this.remainingWrapper.classList.add(Lc))
          : this.productState.available &&
            (this.remainingWrapper.classList.remove(Sc, Lc, kc),
            this.remainingWrapper.classList.add(Ec));
      } else
        this.remainingWrapper &&
          (this.remainingWrapper.classList.remove(Ec, Lc, Sc),
          this.remainingWrapper.classList.add(kc));
    }
    getBaseUnit(e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.outerWrapper.querySelectorAll(cc).forEach((e) => {
        e.addEventListener(
          "change",
          function (e) {
            const t = e.target.value.toString(),
              i = this.outerWrapper.querySelector(`[${hc}="${t}"]`),
              s = this.outerWrapper.querySelectorAll(`[${hc}]`);
            if (i) {
              i.classList.remove(yc);
              const e = i.querySelector('[name="selling_plan"]');
              (e.checked = !0), e.dispatchEvent(new Event("change"));
            }
            s.forEach((e) => {
              if (e !== i) {
                e.classList.add(yc);
                e.querySelectorAll('[name="selling_plan"]').forEach((e) => {
                  (e.checked = !1), e.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(e) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(e)
        : this.productState.onSale
        ? this.updateSaleTextStandard(e)
        : this.priceOffWrap && this.priceOffWrap.classList.add(yc);
    }
    updateSaleTextStandard(e) {
      if (!this.priceOffType) return;
      this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
      const t = e.variant;
      if (
        window.theme.settings.badge_sale_type &&
        "percentage" === window.theme.settings.badge_sale_type
      ) {
        const e = (t.compare_at_price - t.price) / t.compare_at_price,
          i = Math.ceil(100 * e);
        this.priceOffAmount.innerHTML = `${i}%`;
      } else {
        const e = t.compare_at_price - t.price;
        this.priceOffAmount.innerHTML = this.formattingMoney(e);
      }
      this.priceOffWrap.classList.remove(yc);
    }
    updateSaleTextSubscription(e) {
      this.priceOffType.innerHTML =
        window.theme.strings.subscription || "subscripton";
      const t = e.variant,
        i = e.plan.detail.price_adjustments[0],
        s = i.value;
      i && "percentage" === i.value_type
        ? (this.priceOffAmount.innerHTML = `${s}%`)
        : i && "price" === i.value_type
        ? (this.priceOffAmount.innerHTML = this.formattingMoney(
            t.price - i.value
          ))
        : (this.priceOffAmount.innerHTML = this.formattingMoney(s)),
        this.priceOffWrap.classList.remove(yc);
    }
    updateSubscriptionText(e) {
      e.plan && this.planDecription && null !== e.plan.detail.description
        ? ((this.planDecription.innerHTML = e.plan.detail.description),
          this.planDecription.classList.remove(yc))
        : this.planDecription && this.planDecription.classList.add(yc);
    }
    getPrices(e) {
      const t = e.variant,
        i = e.plan;
      let s = "",
        r = "";
      return (
        this.productState.available &&
          ((s = t.compare_at_price), (r = t.price)),
        this.productState.hasPlan && (r = i.allocation.price),
        this.productState.planSale &&
          ((s = i.allocation.compare_at_price), (r = i.allocation.price)),
        { price: r, comparePrice: s }
      );
    }
    updateButtonPrices(e) {
      const t = this.outerWrapper.querySelectorAll(Ql),
        { price: i } = this.getPrices(e);
      t.length &&
        t.forEach((t) => {
          const s = e.quantity * i;
          t.innerHTML = this.formattingMoney(s);
        });
    }
    updateProductPrices(e) {
      const t = e.variant,
        i = this.outerWrapper.querySelectorAll(Gl),
        s = this.outerWrapper.querySelectorAll(Ql),
        { price: r, comparePrice: n } = this.getPrices(e);
      i.forEach((e) => {
        const i = e.querySelector(zl),
          s = e.querySelector(Xl),
          o = e.querySelector(Vl);
        let a = document.querySelector("[data-product-price-compare]");
        a && n > r
          ? (document.querySelector("[data-product-price-compare]").innerHTML =
              this.formattingMoney(n))
          : a &&
            (document.querySelector("[data-product-price-compare]").innerHTML =
              ""),
          i &&
            (this.productState.onSale || this.productState.planSale
              ? (i.classList.remove(yc),
                o.classList.remove(yc),
                s.classList.add(wc))
              : (i.classList.add(yc),
                o.classList.add(yc),
                s.classList.remove(wc)),
            (i.innerHTML = this.formattingMoney(n))),
          s && (s.innerHTML = t ? this.formattingMoney(r) : "&nbsp;");
      }),
        s.length &&
          s.forEach((t) => {
            const i = e.quantity * r;
            t.innerHTML = this.formattingMoney(i);
          }),
        this.hasUnitPricing && this.updateProductUnits(e);
    }
    updateProductUnits(e) {
      const t = e.variant,
        i = e.plan;
      let s = null;
      if (
        (t && t.unit_price && (s = t.unit_price),
        i &&
          i.allocation &&
          i.allocation.unit_price &&
          (s = i.allocation.unit_price),
        s)
      ) {
        const e = this.getBaseUnit(t);
        (this.outerWrapper.querySelector(Kl).innerHTML =
          this.formattingMoney(s)),
          (this.outerWrapper.querySelector(Zl).innerHTML = e),
          K(this.outerWrapper.querySelector(ec));
      } else gn(this.outerWrapper.querySelector(ec));
    }
    fireHookEvent(e) {
      const t = e.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: t },
          bubbles: !0,
        })
      );
    }
    setProductState(e) {
      const t = e.variant,
        i = e.plan,
        s = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !t || (t.requires_selling_plan && !i)
          ? (s.available = !1)
          : (t.available || (s.soldOut = !0),
            t.compare_at_price > t.price && (s.onSale = !0),
            t.unit_price && (s.showUnitPrice = !0),
            this.productJSON &&
              this.productJSON.requires_selling_plan &&
              (s.requiresPlan = !0),
            i &&
              this.subPrices &&
              ((s.hasPlan = !0),
              i.allocation.per_delivery_price !== i.allocation.price &&
                (s.planPerDelivery = !0),
              i.allocation.compare_at_price > i.allocation.price &&
                (s.planSale = !0))),
        s
      );
    }
    updateProductImage(e) {
      const t = e.variant;
      t &&
        this.slideshow &&
        t.featured_media &&
        t.featured_media.id &&
        (this.slideshow.dispatchEvent(
          new CustomEvent("theme:image:change", {
            detail: { id: t.featured_media.id },
          })
        ),
        this.scrollImageViewport(t));
    }
    scrollImageViewport(e) {
      if (
        (Ce.isDesktop() || Ce.isTablet()) &&
        this.slideshow.hasAttribute("data-vertical-images")
      ) {
        const t = this.slideshow
            .querySelector(`[data-media-id="${e.featured_media.id}"]`)
            .getBoundingClientRect(),
          i = t.top,
          s = t.bottom;
        if (i < 0 || s > window.innerHeight) {
          let e = i + window.scrollY;
          i < 0
            ? (e = i + window.scrollY)
            : s > window.innerHeight &&
              (e = i + window.scrollY - (window.innerHeight - t.height)),
            window.scrollTo({ top: e, left: 0, behavior: "smooth" });
        }
      }
    }
    formattingMoney(e) {
      return theme.settings.currency_code_enable
        ? a.formatMoney(e, theme.moneyFormat) + ` ${theme.currencyCode}`
        : a.formatMoney(e, theme.moneyFormat);
    }
  }
  class xc extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      fetch(this.dataset.url)
        .then((e) => e.text())
        .then((e) => {
          const t = document.createElement("div");
          t.innerHTML = e;
          const i = t.querySelector("[data-api-content]");
          i && (this.innerHTML = i.innerHTML);
          const s = this.closest("[data-product-complimentary-loaded]");
          s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded");
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  const _c = "[data-product-slideshow]",
    Ac = "[data-product-image]",
    qc = "[data-zoom-button]",
    Cc = "[data-zoom-wrapper]",
    Pc = "data-media-id";
  const $c = "body",
    Mc = "[data-related-section]",
    Ic = "[data-tabs-holder]",
    Dc = "data-tab",
    Oc = "data-tab-index",
    Hc = "data-block-id",
    Fc = ".tabs > button",
    Bc = ".tab-link",
    Wc = ".tab-link__recent",
    Nc = ".tab-content",
    Rc = "[data-scrollbar]",
    jc = "a:first-child, input:first-child",
    zc = "current",
    Vc = "hide",
    Uc = "alt",
    Jc = "is-focused",
    Gc = {};
  class Qc {
    constructor(e) {
      (this.container = e),
        (this.body = document.querySelector($c)),
        (this.accessibility = window.accessibility),
        this.container &&
          ((this.scrollbarHolder = this.container.querySelectorAll(Rc)),
          this.init(),
          this.initNativeScrollbar());
    }
    init() {
      const e = this.container,
        t = e.querySelectorAll(Fc),
        i = e.querySelector(`${Bc}-0`),
        s = e.querySelector(`${Nc}-0`);
      s && s.classList.add(zc),
        i && i.classList.add(zc),
        this.checkVisibleTabLinks(),
        this.container.addEventListener("theme:tabs:check", () =>
          this.checkRecentTab()
        ),
        this.container.addEventListener("theme:tabs:hide", () =>
          this.hideRelatedTab()
        ),
        t.length &&
          t.forEach((t) => {
            const i = parseInt(t.getAttribute(Dc)),
              s = e.querySelector(`${Nc}-${i}`);
            t.addEventListener("click", () => {
              this.tabChange(t, s);
            }),
              t.addEventListener("keyup", (e) => {
                ("Space" !== e.code && "Enter" !== e.code) ||
                  !this.body.classList.contains(Jc) ||
                  (this.tabChange(t, s),
                  s.querySelector("a, input") &&
                    ((this.accessibility.lastFocused = t),
                    this.accessibility.a11y.trapFocus(s, {
                      elementToFocus: s.querySelector(jc),
                    })));
              });
          });
    }
    tabChange(e, t) {
      this.container.querySelector(`${Fc}.${zc}`).classList.remove(zc),
        this.container.querySelector(`${Nc}.${zc}`).classList.remove(zc),
        e.classList.add(zc),
        t.classList.add(zc),
        e.classList.contains(Vc) && t.classList.add(Vc),
        this.checkVisibleTabLinks(),
        this.container.dispatchEvent(new CustomEvent("theme:tab:change"));
    }
    initNativeScrollbar() {
      this.scrollbarHolder.length &&
        this.scrollbarHolder.forEach((e) => {
          new ne(e);
        });
    }
    checkVisibleTabLinks() {
      const e = this.container.querySelectorAll(Fc),
        t = this.container.querySelectorAll(`${Bc}.${Vc}`);
      e.length - t.length < 2
        ? this.container.classList.add(Uc)
        : this.container.classList.remove(Uc);
    }
    checkRecentTab() {
      const e = this.container.querySelector(Wc);
      if (e) {
        e.classList.remove(Vc);
        const t = parseInt(e.getAttribute(Dc)),
          i = this.container.querySelector(`${Nc}[${Oc}="${t}"]`);
        i && i.classList.remove(Vc),
          this.checkVisibleTabLinks(),
          this.initNativeScrollbar();
      }
    }
    hideRelatedTab() {
      const e = this.container.querySelector(Mc);
      if (!e) return;
      const t = e.closest(`${Nc}.${zc}`);
      if (!t) return;
      const i = parseInt(t.getAttribute(Oc)),
        s = this.container.querySelectorAll(Fc);
      if (s.length > i) {
        const e = s[i].nextElementSibling;
        e &&
          (s[i].classList.add(Vc),
          e.dispatchEvent(new Event("click")),
          this.initNativeScrollbar());
      }
    }
    onBlockSelect(e) {
      const t = this.container.querySelector(
        `${Bc}[${Hc}="${e.detail.blockId}"]`
      );
      t &&
        (t.dispatchEvent(new Event("click")),
        t.parentNode.scrollTo({
          top: 0,
          left: t.offsetLeft - t.clientWidth,
          behavior: "smooth",
        }));
    }
  }
  const Yc = {
      onLoad() {
        Gc[this.id] = [];
        this.container.querySelectorAll(Ic).forEach((e) => {
          Gc[this.id].push(new Qc(e));
        });
      },
      onBlockSelect(e) {
        Gc[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
    },
    Xc = "[data-share-url]",
    Kc = "data-section-type",
    Zc = "[data-share-details]",
    eh = "[data-share-summary]",
    th = "[data-share-copy]",
    ih = "[data-share-button]",
    sh = "[data-close-button]",
    rh = "[data-success-message]",
    nh = "[data-share-holder]",
    oh = "is-hidden";
  class ah extends HTMLElement {
    constructor() {
      super(),
        (this.container = this.closest(`[${Kc}]`)),
        (this.mainDetailsToggle = this.querySelector(Zc)),
        (this.shareButton = this.querySelector(ih)),
        (this.shareCopy = this.querySelector(th)),
        (this.shareSummary = this.querySelector(eh)),
        (this.closeButton = this.querySelector(sh)),
        (this.successMessage = this.querySelector(rh)),
        (this.shareHolder = this.querySelector(nh)),
        (this.urlInput = this.querySelector(Xc)),
        (this.urlToShare = this.urlInput
          ? this.urlInput.value
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
    init() {
      navigator.share
        ? (this.mainDetailsToggle.classList.add(oh),
          this.shareButton.classList.remove(oh),
          this.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          }))
        : (this.mainDetailsToggle.addEventListener(
            "toggle",
            this.toggleDetails.bind(this)
          ),
          this.mainDetailsToggle.addEventListener("focusout", () => {
            setTimeout(() => {
              this.contains(document.activeElement) || this.close();
            });
          }),
          this.shareCopy.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          ),
          this.closeButton.addEventListener("click", this.close.bind(this)),
          this.container.addEventListener(
            "keyup",
            this.keyboardEvents.bind(this)
          ));
    }
    updateShareLink() {
      "product" == this.container.getAttribute(Kc) &&
        this.container.addEventListener("theme:variant:change", (e) => {
          e.detail.variant &&
            ((this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              e.detail.variant.id
            }`),
            this.urlInput &&
              (this.urlInput.value = `${
                this.urlToShare.split("?")[0]
              }?variant=${e.detail.variant.id}`));
        });
    }
    toggleDetails() {
      this.mainDetailsToggle.open ||
        (this.successMessage.classList.add(oh),
        (this.successMessage.textContent = ""),
        this.closeButton.classList.add(oh),
        this.shareCopy.focus());
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        this.successMessage.classList.remove(oh),
          (this.successMessage.textContent = theme.strings.successMessage),
          this.closeButton.classList.remove(oh),
          this.closeButton.focus();
      });
    }
    close() {
      this.mainDetailsToggle.removeAttribute("open"),
        this.shareSummary.setAttribute("aria-expanded", !1);
    }
    keyboardEvents(e) {
      "Escape" === e.code && (this.mainDetailsToggle.focus(), this.close());
    }
  }
  const lh = "data-image-filter",
    ch = "[data-product-slideshow]",
    hh = "[data-product-thumbs]",
    dh = "[data-slideshow-thumbnail]",
    uh = "[data-media-slide]",
    ph = "hide",
    mh = "flickity-enabled";
  class fh {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.slider = this.container.querySelector(ch)),
        (this.thumbSlider = this.container.querySelector(hh)),
        (this.thumbs = this.container.querySelectorAll(dh)),
        (this.slides = this.container.querySelectorAll(uh)),
        (this.variantImage = null),
        this.listen();
    }
    listen() {
      this.container.addEventListener("theme:variant:change", (e) => {
        e.detail.variant &&
          ((this.variantImage = e.detail.variant.featured_image),
          this.filterImages());
      });
    }
    filterImages() {
      null !== this.variantImage && null !== this.variantImage.alt
        ? ((this.variantImageAlt = this.variantImage.alt.split("#")[1]),
          this.showImages())
        : this.resetImages(),
        this.refreshSliders();
    }
    resetImages() {
      this.thumbs.forEach((e) => e.classList.remove(ph)),
        this.slides.forEach((e) => e.classList.remove(ph));
    }
    showImages() {
      this.thumbs.forEach((e) => {
        "" === e.getAttribute(lh) || e.getAttribute(lh) === this.variantImageAlt
          ? e.classList.remove(ph)
          : e.classList.add(ph);
      }),
        this.slides.forEach((e) => {
          "" === e.getAttribute(lh) ||
          e.getAttribute(lh) === this.variantImageAlt
            ? e.classList.remove(ph)
            : e.classList.add(ph);
        });
    }
    refreshSliders() {
      if (null !== this.slider && this.slider.classList.contains(mh)) {
        const e = t.data(this.slider);
        void 0 !== e && e.reloadCells();
      }
      if (
        null !== this.thumbSlider &&
        this.thumbSlider.classList.contains(mh)
      ) {
        const e = c.data(this.thumbSlider);
        void 0 !== e && e.reloadCells();
      }
    }
  }
  const gh = "[data-size-button]",
    yh = "[data-media-slide]",
    vh = "is-expanded";
  class bh {
    constructor(e) {
      (this.container = e),
        (this.sizeButtons = this.container.querySelectorAll(gh)),
        this.sizeButtons.length > 0 && this.init();
    }
    init() {
      this.sizeButtons.forEach((e) => {
        e.addEventListener("click", () => {
          e.classList.toggle(vh), e.closest(yh).classList.toggle(vh);
        });
      });
    }
  }
  const wh = "[data-product-json]",
    Sh = "[data-zoom-button]",
    Eh = "[data-truncated-holder]",
    Lh = "[data-truncated-button]",
    kh = "data-truncated-content",
    Th = "is-expanded",
    xh = "is-visible",
    _h = [];
  class Ah {
    constructor(e) {
      (this.section = e),
        (this.id = e.id),
        (this.container = e.container),
        (this.settings = e.settings),
        qi(this.id),
        (this.media = new hl(e)),
        new fh(e);
      const t = this.container.querySelector(wh);
      t && "" !== t.innerHTML
        ? ((this.product = JSON.parse(t.innerHTML)),
          (this.truncateElementHolder = this.container.querySelector(Eh)),
          (this.truncateElement = this.container.querySelector(`[${kh}]`)),
          (this.resizeEventTruncate = () => this.truncateText()),
          this.init())
        : console.error("Missing product JSON");
    }
    init() {
      (this.zoomEnabled = null !== this.container.querySelector(Sh)),
        this.zoomEnabled &&
          (function (e, t) {
            const i = Ne({ url: window.theme.assets.photoswipe })
              .then(() => {
                const i = window.themePhotoswipe.PhotoSwipe.default,
                  s = window.themePhotoswipe.PhotoSwipeUI.default;
                e.querySelectorAll(qc).forEach((r) => {
                  r.addEventListener("click", (r) => {
                    const n = e.querySelector(Cc),
                      o = r.target
                        .closest(`[${Pc}]`)
                        .getAttribute(Pc)
                        .toString(),
                      a = [];
                    for (let e = 0; e < t.media.length; e++)
                      "image" === t.media[e].media_type &&
                        (a[a.length] = {
                          src: t.media[e].src,
                          w: t.media[e].width,
                          h: t.media[e].height,
                          id: t.media[e].id,
                        });
                    const l = {
                      index: a.findIndex((e) => e.id.toString() === o),
                      showHideOpacity: !0,
                      showAnimationDuration: 150,
                      hideAnimationDuration: 250,
                      bgOpacity: 1,
                      spacing: 0,
                      allowPanToNext: !1,
                      maxSpreadZoom: 3,
                      history: !1,
                      loop: !0,
                      pinchToClose: !1,
                      modal: !1,
                      closeOnScroll: !1,
                      closeOnVerticalDrag: !0,
                      getDoubleTapZoom: function (e, t) {
                        return e ? 1.67 : t.initialZoomLevel < 0.7 ? 1 : 1.3;
                      },
                      getThumbBoundsFn: function () {
                        let t = e.querySelector(_c);
                        t || (t = e.querySelector(Ac));
                        const i =
                            window.pageYOffset ||
                            document.documentElement.scrollTop,
                          s = t.getBoundingClientRect();
                        return { x: s.left, y: s.top + i, w: s.width };
                      },
                    };
                    n.dispatchEvent(
                      new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                    );
                    const c = new i(n, s, a, l);
                    c.init(),
                      c.listen("close", function () {
                        document.dispatchEvent(
                          new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0,
                          })
                        );
                      });
                  });
                });
              })
              .catch((e) => console.error(e));
          })(this.container, this.product),
        this.truncateElementHolder &&
          this.truncateElement &&
          (setTimeout(this.resizeEventTruncate, 50),
          document.addEventListener("theme:resize", this.resizeEventTruncate)),
        new bh(this.container);
    }
    truncateText() {
      if (this.truncateElementHolder.classList.contains(xh)) return;
      const e = this.truncateElement.querySelectorAll("style");
      e.length &&
        e.forEach((e) => {
          this.truncateElementHolder.prepend(e);
        });
      const t = this.truncateElement.cloneNode(!0),
        i = this.truncateElement.getAttribute(kh),
        s = this.truncateElement.nextElementSibling;
      s && s.remove(), this.truncateElement.parentElement.append(t);
      const r = this.truncateElement.nextElementSibling;
      r.classList.add(i),
        r.removeAttribute(kh),
        K(r),
        ((e = "", t = 1, i = {}) => {
          const s = {
              replaceStr: "...",
              debounceDelay: 250,
              delimiter: " ",
              ...i,
            },
            r =
              e &&
              (e instanceof NodeList
                ? e
                : 1 === e.nodeType
                ? [e]
                : document.querySelectorAll(e));
          for (let e = 0; e < r.length; e++) {
            const i = r[e],
              n = /<!--[\s\S]*?-->/g,
              o = i.innerHTML.replace(n, "").split(s.delimiter);
            i.innerHTML = "";
            const a = window.getComputedStyle(i);
            o.reduce(Ya, {
              el: i,
              buffer: i.innerHTML,
              elStyle: a,
              elHeight: 0,
              rowsLimit: t,
              rowsWrapped: 0,
              options: s,
            });
          }
        })(r, 5, { replaceStr: "", delimiter: " " }),
        gn(r),
        this.truncateElement.innerHTML !== r.innerHTML
          ? this.truncateElementHolder.classList.add(Th)
          : (r.remove(), this.truncateElementHolder.classList.remove(Th)),
        this.toggleTruncatedContent(this.truncateElementHolder);
    }
    toggleTruncatedContent(e) {
      const t = e.querySelector(Lh);
      t &&
        t.addEventListener("click", (t) => {
          t.preventDefault(), e.classList.remove(Th), e.classList.add(xh);
        });
    }
    onBlockSelect(e) {
      const t = this.container.querySelector(
        `[data-block-id="${e.detail.blockId}"]`
      );
      t && t.dispatchEvent(new Event("click"));
    }
    onBlockDeselect(e) {
      const t = this.container.querySelector(
        `[data-block-id="${e.detail.blockId}"]`
      );
      t && t.dispatchEvent(new Event("click"));
    }
    onUnload() {
      this.media.destroy(),
        this.truncateElementHolder &&
          this.truncateElement &&
          document.removeEventListener(
            "theme:resize",
            this.resizeEventTruncate
          );
    }
  }
  mi("product", [
    {
      onLoad() {
        _h[this.id] = new Ah(this);
      },
      onUnload() {
        "function" == typeof _h[this.id].unload && _h[this.id].unload();
      },
      onBlockSelect(e) {
        "function" == typeof _h[this.id].onBlockSelect &&
          _h[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        "function" == typeof _h[this.id].onBlockDeselect &&
          _h[this.id].onBlockDeselect(e);
      },
    },
    Ll,
    fn,
    Yc,
    Ge,
  ]),
    customElements.get("product-form") ||
      customElements.define("product-form", Tc),
    customElements.get("product-complimentary") ||
      customElements.define("product-complimentary", xc),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("popout-select") ||
      customElements.define("popout-select", sn),
    customElements.get("share-button") ||
      customElements.define("share-button", ah);
  const qh = "data-toggle-grid",
    Ch = "data-grid-large",
    Ph = "data-grid-small",
    $h = "is-active",
    Mh = window.theme.sizes.small;
  var Ih = {};
  class Dh {
    constructor(e, t) {
      (this.container = t || document),
        (this.toggle = e),
        (this.value = this.toggle.getAttribute(qh)),
        (this.toggleFunction = (e) => this.toggleEvent(e)),
        this.init();
    }
    init() {
      this.toggle.addEventListener("click", this.toggleFunction),
        document.addEventListener("theme:resize:width", this.toggleFunction),
        this.toggleEvent(!1);
    }
    unload() {
      this.toggle.removeEventListener("click", this.toggleFunction),
        document.removeEventListener("theme:resize:width", this.toggleFunction);
    }
    toggleEvent(e = !0) {
      const t = e && "click" === e.type,
        i = window.innerWidth >= Mh ? Ch : Ph,
        s = this.container.querySelector(`[${i}]`),
        r = s.getAttribute(i),
        n = this.toggle.parentElement.querySelector(`[${qh}].${$h}`);
      let o = this.toggle.parentElement.querySelector(`[${qh}="${r}"]`);
      t && ((o = this.toggle), s.setAttribute(i, this.value)),
        n && n.classList.remove($h),
        o && o.classList.add($h);
    }
  }
  const Oh = {
      onLoad() {
        Ih[this.id] = [];
        this.container.querySelectorAll(`[${qh}]`).forEach((e) => {
          Ih[this.id].push(new Dh(e, this.container));
        });
      },
      onUnload: function () {
        Ih[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    Hh = "data-sort-enabled",
    Fh = "[data-sort-link]",
    Bh = "[data-sort-button-text]",
    Wh = "data-value",
    Nh = "popout-list__item--current";
  class Rh {
    constructor(e) {
      (this.container = e.container),
        (this.sort = this.container.querySelector(`[${Hh}]`)),
        (this.sortLinks = this.container.querySelectorAll(Fh)),
        (this.sortButtonText = this.container.querySelector(Bh)),
        this.sort && this.init();
    }
    init() {
      this.sortLinks.forEach((e) => {
        e.addEventListener("click", (e) => {
          e.preventDefault(), this.sortingResults(e);
        });
      });
    }
    sortingResults(e) {
      const t = e.currentTarget,
        i = t.getAttribute(Wh),
        s = t.innerText;
      (this.sortButtonText.innerText = s),
        this.sortButtonText.parentNode.dispatchEvent(new Event("click")),
        this.sort.querySelector(`.${Nh}`).classList.remove(Nh),
        t.parentNode.classList.add(Nh),
        this.sort.setAttribute(Hh, i),
        this.container.dispatchEvent(
          new CustomEvent("theme:form:filter", {
            bubbles: !0,
            detail: { params: i },
          })
        );
    }
  }
  var jh = "data-swatch";
  class zh {
    constructor(e) {
      (this.section = e),
        (this.container = this.section.container),
        (this.swatches = this.container.querySelectorAll(`[${jh}]`)),
        this.init();
    }
    init() {
      new Rh(this.section);
    }
  }
  mi("collection", [
    {
      onLoad() {
        this.collection = new zh(this);
      },
    },
    Ha,
    za,
    Oh,
    ut,
    fn,
    le,
  ]),
    customElements.get("popout-select") ||
      customElements.define("popout-select", sn),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr),
    mi("collection-row", [ut, le, bt]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr),
    mi("collection-tabs", [Yc, Yo, ut]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr);
  var Vh = {};
  function Uh(e) {
    return Vh[e];
  }
  (Vh.basic = []),
    (Vh.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "on" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (Vh.light_blank = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "off" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
          { visibility: "off" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "off" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (Vh.white_blank = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#444444" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (Vh.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (Vh.dark_blank = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (Vh.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let Jh = window.theme.allMaps;
  const Gh = "[data-map-container]",
    Qh = "data-style",
    Yh = "data-api-key",
    Xh = "data-zoom",
    Kh = "data-address",
    Zh = "data-latlong-correction",
    ed = "data-lat",
    td = "data-long";
  class id {
    constructor(e) {
      (this.container = e.container),
        (this.mapWrap = this.container.querySelector(Gh)),
        (this.styleString = this.container.getAttribute(Qh) || ""),
        (this.key = this.container.getAttribute(Yh)),
        (this.zoomString = this.container.getAttribute(Xh) || 14),
        (this.address = this.container.getAttribute(Kh)),
        (this.enableCorrection = this.container.getAttribute(Zh)),
        (this.lat = this.container.getAttribute(ed)),
        (this.long = this.container.getAttribute(td)),
        this.key && this.initMaps();
    }
    initMaps() {
      Ne({ url: `https://maps.googleapis.com/maps/api/js?key=${this.key}` })
        .then(() => {
          return "true" === this.enableCorrection &&
            "" !== this.lat &&
            "" !== this.long
            ? new window.google.maps.LatLng(this.lat, this.long)
            : ((e = this.address),
              new Promise((t, i) => {
                new window.google.maps.Geocoder().geocode(
                  { address: e },
                  function (e, s) {
                    if ("OK" == s) {
                      var r = {
                        lat: e[0].geometry.location.lat(),
                        lng: e[0].geometry.location.lng(),
                      };
                      t(r);
                    } else i(s);
                  }
                );
              }));
          var e;
        })
        .then((e) => {
          var t = {
            zoom: parseInt(this.zoomString, 10),
            styles: Uh(this.styleString),
            center: e,
            draggable: !0,
            clickableIcons: !1,
            scrollwheel: !1,
            zoomControl: !1,
            disableDefaultUI: !0,
          };
          const i = (function (e, t) {
            var i = new window.google.maps.Map(e, t),
              s = i.getCenter();
            return (
              new window.google.maps.Marker({ map: i, position: s }),
              window.google.maps.event.addDomListener(
                window,
                "resize",
                function () {
                  window.google.maps.event.trigger(i, "resize"), i.setCenter(s);
                }
              ),
              i
            );
          })(this.mapWrap, t);
          return i;
        })
        .then((e) => {
          (this.map = e), (Jh[this.id] = e);
        })
        .catch((e) => {
          console.log("Failed to load Google Map"), console.log(e);
        });
    }
    onUnload() {
      void 0 !== window.google &&
        window.google.maps.event.clearListeners(this.map, "resize");
    }
  }
  mi("section-map", {
    onLoad() {
      Jh[this.id] = new id(this);
    },
    onUnload() {
      "function" == typeof Jh[this.id].unload && Jh[this.id].unload();
    },
  }),
    mi("section-columns", [Do, bt]);
  const sd = "[data-related-section]",
    rd = "[data-grid-item]",
    nd = "[data-carousel]",
    od = "data-limit",
    ad = "data-minimum",
    ld = "data-layout-desktop",
    cd = "data-layout-tablet",
    hd = "data-layout-mobile",
    dd = "[data-recent-wrapper]",
    ud = "[data-recently-viewed-wrapper]",
    pd = "data-product-id";
  class md {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        this.init(),
        this.container.addEventListener("theme:recent-products:added", () => {
          this.recent();
        });
    }
    init() {
      const e = this.container.querySelector(sd);
      if (!e) return;
      const t = e.getAttribute(pd),
        i = e.getAttribute(od),
        s = e.getAttribute(ld),
        r = e.getAttribute(cd),
        n = e.getAttribute(hd),
        o = `${
          window.theme.routes.product_recommendations_url ||
          "/recommendations/products/"
        }?section_id=related&limit=${i}&product_id=${t}`;
      l.get(o)
        .then((t) => {
          const i = document.createElement("div");
          i.innerHTML = t.data;
          const o = i.querySelector(sd);
          if (o.querySelector(rd)) {
            const t = o.innerHTML;
            (e.innerHTML = t),
              e.querySelector(nd).style.setProperty("--grid-large-items", s),
              e.querySelector(nd).style.setProperty("--grid-medium-items", r),
              e.querySelector(nd).style.setProperty("--grid-small-items", n),
              e.dispatchEvent(
                new CustomEvent("theme:related-products:added", { bubbles: !0 })
              );
          } else
            e.dispatchEvent(
              new CustomEvent("theme:tabs:hide", { bubbles: !0 })
            );
        })
        .catch(function (e) {
          console.warn(e);
        });
    }
    recent() {
      const e = this.container.querySelector(dd),
        t = this.container.querySelector(ud),
        i = this.container.querySelectorAll(rd),
        s = e.hasAttribute(ad) ? parseInt(e.getAttribute(ad)) : 4,
        r = !t && i.length > 0,
        n = t && i.length >= s;
      (r || n) &&
        e.dispatchEvent(new CustomEvent("theme:tabs:check", { bubbles: !0 }));
    }
  }
  mi("related", [
    {
      onLoad() {
        this.section = new md(this);
      },
    },
    Yc,
    qe,
  ]),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", ct),
    customElements.get("product-grid-item") ||
      customElements.define("product-grid-item", kr),
    customElements.get("product-grid-item-variant") ||
      customElements.define("product-grid-item-variant", Br),
    customElements.get("product-grid-item-image") ||
      customElements.define("product-grid-item-image", Rr);
  const fd = "[data-cart-note]";
  class gd {
    constructor(e) {
      (this.inputs = e.querySelectorAll(fd)), this.initInputs();
    }
    initInputs() {
      this.inputs.forEach((e) => {
        e.addEventListener(
          "input",
          T(
            function (e) {
              const t = e.target.value.toString() || "";
              this.saveNotes(t);
            }.bind(this),
            300
          )
        );
      });
    }
    saveNotes(e) {
      window
        .fetch(`${window.theme.routes.cart}/update.js`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: e }),
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  const yd = (e, t = [], i = !1) => {
      const s = Object.keys(e)
        .map((s) => {
          let r = e[s];
          if (
            "[object Object]" === Object.prototype.toString.call(r) ||
            Array.isArray(r)
          )
            return (
              Array.isArray(e) ? t.push("") : t.push(s),
              yd(r, t, Array.isArray(r))
            );
          {
            let e = s;
            if (t.length > 0) {
              e = (i ? t : [...t, s]).reduce(
                (e, t) => ("" === e ? t : `${e}[${t}]`),
                ""
              );
            }
            return i ? `${e}[]=${r}` : `${e}=${r}`;
          }
        })
        .join("&");
      return t.pop(), s;
    },
    vd = "html",
    bd = "[data-submit-shipping]",
    wd = "[data-shipping-estimate-form]",
    Sd = "[data-response-template]",
    Ed = "#estimate_address_country",
    Ld = "#estimate_address_province",
    kd = "#estimate_address_zip",
    Td = "[data-response-wrapper]",
    xd = "lang",
    _d = "data-default",
    Ad = "shipping--success",
    qd = "errors",
    Cd = "disabled";
  class Pd {
    constructor(e) {
      (this.button = e.container.querySelector(bd)),
        (this.template = e.container.querySelector(Sd).innerHTML),
        (this.ratesWrapper = e.container.querySelector(Td)),
        (this.form = e.container.querySelector(wd)),
        (this.country = e.container.querySelector(Ed)),
        (this.province = e.container.querySelector(Ld)),
        (this.zip = e.container.querySelector(kd)),
        this.init();
    }
    enableButtons() {
      this.button.removeAttribute("disabled"), this.button.classList.remove(Cd);
    }
    disableButtons() {
      this.button.setAttribute("disabled", "disabled"),
        this.button.classList.add(Cd);
    }
    render(e) {
      if (this.template && this.ratesWrapper) {
        const t = u.render(this.template, e);
        this.ratesWrapper.innerHTML = t;
      }
      this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
    }
    estimate(e) {
      const t = encodeURI(yd({ shipping_address: e })),
        i = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
        s = this;
      l.get(i)
        .then(function (e) {
          const t = s.sanitize(e);
          s.render(t),
            s.enableButtons(),
            s.ratesWrapper.style.removeProperty("display");
        })
        .catch(function (e) {
          const t = s.sanitizeErrors(e);
          s.render(t);
        });
    }
    sanitize(e) {
      const t = {};
      if (
        ((t.class = Ad),
        (t.items = []),
        e.data.shipping_rates && e.data.shipping_rates.length > 0)
      ) {
        e.data.shipping_rates.forEach((e) => {
          let i = {};
          (i.title = e.presentment_name),
            (i.value = a.formatMoney(e.price, theme.moneyFormat)),
            t.items.push(i);
        });
      } else t.items[0] = { value: theme.strings.noShippingAvailable };
      return t;
    }
    sanitizeErrors(e) {
      const t = {};
      if (((t.class = qd), (t.items = []), "object" == typeof e.data))
        for (const [i, s] of Object.entries(e.data)) {
          let e = {};
          (e.title = i.toString()), (e.value = s.toString()), t.items.push(e);
        }
      else t.items[0] = { value: theme.strings.noShippingAvailable };
      return t;
    }
    init() {
      const e = document.querySelector(vd);
      let t = "en";
      e.hasAttribute(xd) &&
        "" !== e.getAttribute(xd) &&
        (t = e.getAttribute(xd)),
        this.form && h.AddressForm(this.form, t, { shippingCountriesOnly: !0 }),
        this.country &&
          this.country.hasAttribute(_d) &&
          this.province &&
          this.province.hasAttribute(_d) &&
          this.country.addEventListener("change", function () {
            this.country.removeAttribute(_d), this.province.removeAttribute(_d);
          }),
        this.button &&
          this.button.addEventListener(
            "click",
            function (e) {
              for (
                e.preventDefault(), this.disableButtons();
                this.ratesWrapper.firstChild;

              )
                this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
              this.ratesWrapper.style.display = "none";
              const t = {};
              let i = this.country.value,
                s = this.province.value;
              const r = this.country.getAttribute(_d);
              "" === i && r && "" !== r && (i = r);
              const n = this.province.getAttribute(_d);
              "" === s && n && "" !== n && (s = n),
                (t.zip = this.zip.value || ""),
                (t.country = i || ""),
                (t.province = s || ""),
                this.estimate(t);
            }.bind(this)
          );
    }
  }
  const $d = "[data-cart-message]",
    Md = "data-cart-message",
    Id = "[data-left-to-spend]",
    Dd = "[data-cart-progress]",
    Od = "data-limit",
    Hd = "data-percent",
    Fd = "is-success";
  class Bd {
    constructor(e) {
      (this.container = e),
        (this.cartMessage = this.container.querySelectorAll($d)),
        (this.rate = window.Shopify.currency.rate),
        this.cartMessage.length > 0 && this.init();
    }
    init() {
      (this.cartFreeLimitShipping =
        100 * Number(this.cartMessage[0].getAttribute(Od)) * this.rate),
        (this.shippingAmount = 0),
        (this.circumference = 28 * Math.PI),
        this.exchangeRateConversions(
          this.cartFreeLimitShipping,
          this.shippingAmount
        ),
        this.cartBarProgress(),
        this.listen();
    }
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), this.render();
        }.bind(this)
      );
    }
    render() {
      const e = this.cart.total_price;
      this.freeShippingMessageHandle(e),
        this.cart &&
          this.cart.total_price &&
          this.cartMessage.length > 0 &&
          ((this.shippingAmount = e), this.updateProgress());
    }
    freeShippingMessageHandle(e) {
      this.cartMessage.length > 0 &&
        this.container.querySelectorAll($d).forEach((t) => {
          const i =
            t.hasAttribute(Md) &&
            "true" === t.getAttribute(Md) &&
            e >= this.cartFreeLimitShipping &&
            0 !== e;
          t.classList.toggle(Fd, i);
        });
    }
    cartBarProgress(e = null) {
      this.container.querySelectorAll(Dd).forEach((t) => {
        this.setProgress(t, null === e ? t.getAttribute(Hd) : e);
      });
    }
    setProgress(e, t) {
      const i = this.circumference - ((t / 100) * this.circumference) / 2;
      e.style.strokeDashoffset = i;
    }
    updateProgress() {
      const e = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
      this.exchangeRateConversions(
        this.cartFreeLimitShipping,
        this.shippingAmount
      ),
        this.cartBarProgress(e > 100 ? 100 : e);
    }
    exchangeRateConversions(e, t) {
      const i = theme.settings.currency_code_enable
        ? a.formatMoney(e - t, theme.moneyFormat) + ` ${theme.currencyCode}`
        : a.formatMoney(e - t, theme.moneyFormat);
      this.container.querySelectorAll(Id).forEach((e) => {
        e.innerHTML = i.replace(".00", "");
      });
    }
  }
  const Wd = '[data-drawer="drawer-cart"]',
    Nd = "[data-shipping-estimate-form]",
    Rd = "[data-cart-loading]",
    jd = "[data-cart-form]",
    zd = "[data-cart-empty]",
    Vd = "[data-cart-progress]",
    Ud = "[data-line-items]",
    Jd = "[data-cart-subtotal]",
    Gd = "[data-cart-bottom]",
    Qd = "[data-form-errors]",
    Yd = "[data-cart-item]",
    Xd = "[data-cart-final]",
    Kd = "data-update-cart",
    Zd = "data-remove-key",
    eu = "[data-cart-page-upsell-wrapper]",
    tu = '[data-section-type="cart"]',
    iu = "[data-cart-bar]",
    su = "[data-cart-message]",
    ru = "[data-item-loadbar]",
    nu = "[data-cart-message-container]",
    ou = "[data-api-content]",
    au = "cart--hidden",
    lu = "cart--loading";
  class cu {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.cartMessages = document.querySelectorAll(nu)),
        (this.bar = this.container.querySelector(iu)),
        (this.ship = this.container.querySelector(su)),
        (this.drawer = this.container.querySelector(Wd)),
        (this.form = this.container.querySelector(jd)),
        (this.loader = this.container.querySelector(Rd)),
        (this.bottom = this.container.querySelector(Gd)),
        (this.items = this.container.querySelector(Ud)),
        (this.subtotal = this.container.querySelector(Jd)),
        (this.errors = this.container.querySelector(Qd)),
        (this.finalPrice = this.container.querySelector(Xd)),
        (this.emptystate = this.container.querySelector(zd)),
        (this.progress = this.container.querySelector(Vd)),
        (this.latestClick = null),
        (this.cart = null),
        (this.stale = !0),
        (this.cartPage = document.querySelector(tu)),
        this.listen();
    }
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), (this.stale = !0);
        }.bind(this)
      ),
        document.addEventListener(
          "theme:cart:init",
          function () {
            this.init();
          }.bind(this)
        ),
        document.addEventListener(
          "theme:cart:reload",
          function () {
            (this.stale = !0),
              this.cart
                ? this.loadHTML()
                : this.init().then(() => this.loadHTML());
          }.bind(this)
        ),
        this.drawer &&
          (this.drawer.addEventListener(
            "theme:drawer:open",
            function () {
              this.cart
                ? this.loadHTML()
                : this.init().then(() => this.loadHTML()),
                (window.theme.state.cartOpen = !0);
            }.bind(this)
          ),
          this.drawer.addEventListener("theme:drawer:close", function () {
            window.theme.state.cartOpen = !1;
          })),
        new gd(this.container),
        new Bd(this.container);
    }
    init() {
      return window
        .fetch(`${window.theme.routes.cart}.js`)
        .then(this.handleErrors)
        .then((e) => e.json())
        .then((e) => ((this.cart = e), this.fireChange(e), e))
        .catch((e) => {
          console.error(e);
        });
    }
    loadHTML(e = !1) {
      this.stale &&
        (this.cart && this.cart.item_count > 0
          ? this.loadForm(e)
          : (this.showEmpty(),
            this.cartMessages.forEach((e) => {
              new Bd(e);
            }))),
        (this.stale = !1);
    }
    initInputs() {
      (this.inputs = this.container.querySelectorAll(`[${Kd}]`)),
        this.inputs.forEach((e) => {
          const t = e.getAttribute(Kd);
          e.addEventListener(
            "change",
            function (e) {
              const i = parseInt(e.target.value, 10);
              (this.latestClick = e.target.closest(Yd)),
                this.lockState(),
                this.updateCart(t, i);
            }.bind(this)
          );
        });
    }
    initRemove() {
      (this.removers = this.container.querySelectorAll(`[${Zd}]`)),
        this.removers.forEach((e) => {
          const t = e.getAttribute(Zd);
          e.addEventListener(
            "click",
            function (e) {
              e.preventDefault(),
                (this.latestClick = e.target.closest(Yd)),
                this.lockState(),
                this.updateCart(t, 0);
            }.bind(this)
          );
        });
    }
    lockState() {
      (this.latestClick.querySelector(ru).style.display = "block"),
        this.loader.classList.add(lu);
    }
    updateCart(e, t) {
      window
        .fetch(`${window.theme.routes.cart}/change.js`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: e, quantity: t }),
        })
        .then(this.handleErrors)
        .then((e) => e.json())
        .then((e) => {
          (this.cart = e),
            nn(this.errors),
            this.fireChange(e),
            (this.stale = !0),
            this.loadHTML();
        })
        .catch((e) => {
          if (!(e instanceof Z)) {
            let t = `<p>${e.message || defaultMessage}</p>`;
            throw (this.showError(t), e);
          }
          {
            let t =
                window.theme.strings.stockout ||
                "Could not update cart, please reload",
              i = e.json?.message || e.message || t,
              s = e.json?.description || "",
              r = i === s ? `<p>${i}</p>` : `<p>${i}</p> <p>${s}</p>`;
            this.showError(r), this.loadForm();
          }
        });
    }
    fireChange(e) {
      document.dispatchEvent(
        new CustomEvent("theme:cart:change", {
          detail: { cart: e },
          bubbles: !0,
        })
      );
    }
    updateTotal() {
      if (this.cart && null != this.cart.total_price) {
        const e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
        this.finalPrice.innerHTML = e + ` ${theme.currencyCode}`;
      }
      this.subtotal &&
        this.cart &&
        window
          .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
          .then(this.handleErrors)
          .then((e) => e.text())
          .then((e) => {
            const t = document.createElement("div");
            (t.innerHTML = e),
              (this.subtotal.innerHTML = t.querySelector(ou).innerHTML);
          });
    }
    showError(e) {
      nn(this.errors),
        (this.errors.innerHTML = e),
        window.setTimeout(() => {
          rn(this.errors);
        }, 600);
    }
    loadForm(e = !1) {
      if (e)
        return (
          this.showForm(),
          this.initQuantity(),
          this.initQuickview(),
          void this.updateTotal()
        );
      window
        .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
        .then(this.handleErrors)
        .then((e) => e.text())
        .then((e) => {
          const t = document.createElement("div");
          (t.innerHTML = e),
            (this.items.innerHTML = t.querySelector(ou).innerHTML),
            this.showForm(),
            this.initQuantity(),
            this.initQuickview(),
            this.updateTotal();
        });
    }
    initQuickview() {
      const e = this.items.querySelector(eu),
        t = this.bottom.querySelector(eu);
      t && t.remove(),
        this.cartPage &&
          e &&
          (this.bottom.insertBefore(e, this.bottom.firstChild),
          Alpine.initTree(this.bottom));
    }
    initQuantity() {
      ql(this.container), this.initInputs(), this.initRemove();
    }
    showForm() {
      this.bar && this.bar.classList.remove(au),
        this.ship && this.ship.classList.remove(au),
        this.progress && this.progress.classList.remove(au),
        this.form.classList.remove(au),
        this.bottom.classList.remove(au),
        this.loader.classList.remove(lu),
        this.emptystate.classList.add(au);
    }
    showEmpty() {
      this.bar && this.bar.classList.add(au),
        this.ship && this.ship.classList.add(au),
        this.progress && this.progress.classList.add(au),
        this.emptystate.classList.remove(au),
        this.loader.classList.remove(lu),
        this.form.classList.add(au),
        this.bottom.classList.add(au);
    }
    handleErrors(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new Z({ status: e.statusText, headers: e.headers, json: t });
          });
    }
  }
  const hu = {
      onLoad() {
        document.querySelector(Wd) && (this.cart = new cu(this));
        this.container.querySelector(Nd) && new Pd(this);
      },
      onUnload: function () {
        this.cart &&
          "function" == typeof this.cart.unload &&
          this.cart.unload();
      },
    },
    du = {
      ajaxDisable: "data-ajax-disable",
      shipping: "[data-shipping-estimate-form]",
      input: "[data-update-cart]",
      update: "[data-update-button]",
      bottom: "[data-cart-bottom]",
      upsellWrapper: "[data-cart-page-upsell-wrapper]",
    },
    uu = "cart--dirty",
    pu = "heart-beat",
    mu = {
      onLoad() {
        if (
          (this.container.querySelector(du.shipping) && new Pd(this),
          (this.disabled =
            "true" == this.container.getAttribute(du.ajaxDisable)),
          this.disabled)
        )
          return void (this.cart = new fu(this));
        this.cart = new cu(this);
        this.cart.init().then(() => {
          this.cart.loadHTML(!0);
        });
      },
    };
  class fu {
    constructor(e) {
      (window.theme.state.cartOpen = !0),
        (this.section = e),
        (this.container = e.container),
        (this.inputs = this.container.querySelectorAll(du.input)),
        (this.quantityWrappers = this.container.querySelectorAll(du.qty)),
        (this.updateBtn = this.container.querySelector(du.update)),
        (this.upsellWrapper = this.container.querySelector(du.upsellWrapper)),
        this.initQuantity(),
        this.initInputs(),
        this.upsellWrapper && this.moveUpsell(),
        document.addEventListener(
          "theme:cart:reload",
          function () {
            window.location.reload();
          }.bind(this)
        );
    }
    initQuantity() {
      ql(this.container);
    }
    moveUpsell() {
      const e = this.container.querySelector(du.bottom);
      e.insertBefore(this.upsellWrapper, e.firstChild);
    }
    initInputs() {
      this.inputs.forEach((e) => {
        e.addEventListener(
          "change",
          function () {
            this.updateBtn.classList.add(uu),
              this.updateBtn.classList.add(pu),
              setTimeout(
                function () {
                  this.updateBtn.classList.remove(pu);
                }.bind(this),
                1300
              );
          }.bind(this)
        );
      });
    }
  }
  mi("cart", [mu, fn]),
    mi("cart-drawer", [ms, hu, fn]),
    mi("accordion-single", fn);
  const gu = (e, t, i = null) => {
      (e.style.opacity = 0),
        (e.style.display = t || "block"),
        (function t() {
          let s = parseFloat(e.style.opacity);
          (s += 0.1) > 1 || ((e.style.opacity = s), requestAnimationFrame(t)),
            1 === s && "function" == typeof i && i();
        })();
    },
    yu = (e, t = null) => {
      (e.style.opacity = 1),
        (function i() {
          (e.style.opacity -= 0.1) < 0
            ? (e.style.display = "none")
            : requestAnimationFrame(i),
            0 === parseFloat(e.style.opacity) && "function" == typeof t && t();
        })();
    },
    vu = "[data-tracking-consent]",
    bu = "[data-confirm-cookies]",
    wu = "[data-close-modal]",
    Su = "[data-popup-inner]",
    Eu = "[data-newsletter]",
    Lu = "[data-newsletter-holder]",
    ku = "[data-newsletter-field]",
    Tu = "[data-newsletter-form]",
    xu = "[data-promo-text]",
    _u = "data-popup-delay",
    Au = "data-cookie-name",
    qu = "data-target-referrer",
    Cu = "has-value",
    Pu = "has-success",
    $u = "has-error",
    Mu = "desktop",
    Iu = "mobile";
  let Du = {};
  class Ou {
    constructor(e, t) {
      (this.configuration = {
        expires: null,
        path: "/",
        domain: window.location.hostname,
      }),
        (this.name = e),
        (this.value = t);
    }
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((e) => e.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((e) => e.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((e) => e.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
  }
  class Hu {
    constructor(e, t) {
      (this.show = !0),
        (this.element = t),
        (this.delay = e.getAttribute(_u)),
        "always" === this.delay && this.always(),
        "delayed" === this.delay && this.delayed(),
        "bottom" === this.delay && this.bottom(),
        "idle" === this.delay && this.idle();
    }
    hide() {
      this.show = !1;
    }
    always() {
      this.show && gu(this.element);
    }
    delayed() {
      setTimeout(() => {
        this.always();
      }, 1e4);
    }
    bottom() {
      let e;
      const t = () => {
        e && window.cancelAnimationFrame(e),
          (e = window.requestAnimationFrame(() => {
            window.requestIdleCallback(
              () => {
                Math.round(window.scrollY + window.innerHeight) >=
                  Math.round(document.body.clientHeight) &&
                  (this.always(),
                  window.removeEventListener("scroll", t, { passive: !0 }));
              },
              { timeout: 300 }
            );
          }));
      };
      window.addEventListener("scroll", t, { passive: !0 });
    }
    onScroll() {}
    idle() {
      let e = 0;
      const t = [
          "mousemove",
          "mousedown",
          "click",
          "touchmove",
          "touchstart",
          "touchend",
          "keydown",
          "keypress",
        ],
        i = ["load", "resize", "scroll"],
        s = () => {
          (e = setTimeout(() => {
            (e = 0), this.always();
          }, 6e4)),
            t.forEach((e) => {
              document.addEventListener(e, r);
            }),
            i.forEach((e) => {
              window.addEventListener(e, r);
            });
        },
        r = () => {
          e && clearTimeout(e),
            t.forEach((e) => {
              document.removeEventListener(e, r);
            }),
            i.forEach((e) => {
              window.removeEventListener(e, r);
            }),
            s();
        };
      s();
    }
  }
  class Fu {
    constructor(e) {
      (this.el = e),
        (this.locationPath = location.href),
        this.el.hasAttribute(qu) && this.init();
    }
    init() {
      -1 !== this.locationPath.indexOf(this.el.getAttribute(qu)) ||
        window.Shopify.designMode ||
        this.el.parentNode.removeChild(this.el);
    }
  }
  class Bu {
    constructor(e) {
      (this.popup = e),
        (this.modal = document.querySelector(vu)),
        (this.modalInner = this.popup.querySelector(Su)),
        (this.close = this.modal.querySelector(wu)),
        (this.acceptButton = this.modal.querySelector(bu)),
        (this.enable = "true" === this.modal.getAttribute("data-enable")),
        (this.showPopup = !1),
        window.Shopify.loadFeatures(
          [{ name: "consent-tracking-api", version: "0.1" }],
          (e) => {
            if (e) throw e;
            const t = window.Shopify.customerPrivacy.userCanBeTracked(),
              i = window.Shopify.customerPrivacy.getTrackingConsent();
            (this.showPopup = !t && "no_interaction" === i && this.enable),
              window.Shopify.designMode && (this.showPopup = !0),
              this.init();
          }
        );
    }
    init() {
      this.showPopup && gu(this.modalInner), this.clickEvents();
    }
    clickEvents() {
      this.close.addEventListener("click", (e) => {
        e.preventDefault(),
          window.Shopify.customerPrivacy.setTrackingConsent(!1, () =>
            yu(this.modalInner)
          );
      }),
        this.acceptButton.addEventListener("click", (e) => {
          e.preventDefault(),
            window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
              yu(this.modalInner)
            );
        }),
        document.addEventListener("trackingConsentAccepted", function () {
          console.log("trackingConsentAccepted event fired");
        });
    }
    onBlockSelect(e) {
      this.popup.contains(e.target) && this.showPopup && gu(this.modalInner);
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) && yu(this.modalInner);
    }
  }
  class Wu {
    constructor(e) {
      (this.popup = e),
        (this.popupInner = this.popup.querySelector(Su)),
        (this.close = this.popup.querySelector(wu)),
        (this.cookie = new Ou(this.popup.getAttribute(Au), "user_has_closed")),
        (this.isTargeted = new Fu(this.popup)),
        (this.hasDeviceClass = ""),
        this.init();
    }
    init() {
      (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
        (window.Shopify.designMode
          ? gu(this.popupInner)
          : new Hu(this.popup, this.popupInner),
        this.clickEvents());
    }
    clickEvents() {
      this.close.addEventListener("click", (e) => {
        e.preventDefault(), yu(this.popupInner), this.cookie.write();
      });
    }
    onBlockSelect(e) {
      this.popup.classList.contains(Iu) && (this.hasDeviceClass = Iu),
        this.popup.classList.contains(Mu) && (this.hasDeviceClass = Mu),
        "" !== this.hasDeviceClass &&
          this.popup.classList.remove(this.hasDeviceClass),
        this.popup.contains(e.target) && gu(this.popupInner);
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) && yu(this.popupInner),
        "" !== this.hasDeviceClass &&
          this.popup.classList.add(this.hasDeviceClass);
    }
  }
  class Nu {
    constructor(e) {
      (this.popup = e),
        (this.popupInner = this.popup.querySelector(Su)),
        (this.holder = this.popup.querySelector(Lu)),
        (this.close = this.popup.querySelector(wu)),
        (this.newsletterField = this.popup.querySelector(ku)),
        (this.cookie = new Ou(
          this.popup.getAttribute(Au),
          "newsletter_is_closed"
        )),
        (this.form = this.popup.querySelector(Tu)),
        (this.isTargeted = new Fu(this.popup)),
        (this.delayShow = null),
        this.init();
    }
    init() {
      (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
        (this.show(), this.checkForSuccess());
    }
    show() {
      window.Shopify.designMode
        ? gu(this.popupInner)
        : (this.delayShow = new Hu(this.popup, this.popupInner)),
        this.inputField(),
        this.closePopup();
    }
    preventDelayShow() {
      this.delayShow && this.delayShow.hide();
    }
    checkForSuccess() {
      const e = this.form.classList.contains($u),
        t = this.form.classList.contains(Pu);
      (t || e) &&
        (gu(this.popupInner),
        this.preventDelayShow(),
        t && this.cookie.write());
    }
    closePopup() {
      this.close.addEventListener("click", (e) => {
        e.preventDefault(),
          yu(this.popupInner),
          this.cookie.write(),
          this.preventDelayShow();
      });
    }
    inputField() {
      this.newsletterField.addEventListener("input", () => {
        "" !== this.newsletterField.value &&
          this.holder.classList.add(Cu, "" !== this.newsletterField.value);
      }),
        this.newsletterField.addEventListener("focus", () => {
          "" !== this.newsletterField.value &&
            this.holder.classList.add(Cu, "" !== this.newsletterField.value);
        }),
        this.newsletterField.addEventListener("focusout", () => {
          setTimeout(() => {
            this.holder.classList.remove(Cu);
          }, 2e3);
        });
    }
    onBlockSelect(e) {
      this.popup.contains(e.target) && gu(this.popupInner);
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) && yu(this.popupInner);
    }
  }
  mi("popups", [
    ho,
    {
      onLoad() {
        Du[this.id] = [];
        this.container.querySelectorAll(vu).forEach((e) => {
          Du[this.id].push(new Bu(e));
        });
        this.container.querySelectorAll(Eu).forEach((e) => {
          Du[this.id].push(new Nu(e));
        });
        this.container.querySelectorAll(xu).forEach((e) => {
          Du[this.id].push(new Wu(e));
        });
      },
      onBlockSelect(e) {
        Du[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        Du[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
    },
  ]);
  const Ru = "data-look-dot",
    ju = "data-products-holder",
    zu = "[data-carousel]",
    Vu = "[data-button-close-holder]",
    Uu = "data-carousel-index",
    Ju = "data-block-id",
    Gu = "button",
    Qu = "is-active",
    Yu = "is-expanded",
    Xu = {};
  class Ku {
    constructor(e) {
      (this.section = e),
        (this.container = this.section.container),
        (this.dots = this.container.querySelectorAll(`[${Ru}]`)),
        (this.productsHolder = this.container.querySelector(`[${ju}]`)),
        (this.slider = this.container.querySelector(zu)),
        (this.buttonClose = this.container.querySelector(Vu)),
        (this.currentDot = this.container.querySelector(`[${Ru}].${Qu}`)),
        (this.hasDefaultOpen = Boolean(this.currentDot)),
        this.init();
    }
    init() {
      (this.keyEvents = (e) => this.keyboardEventShowProductHolder(e)),
        (this.keyCloseEvent = (e) => this.hideProductsHolder(e)),
        (this.clickEventsDot = (e) => this.clickEventShowProductsHolder(e)),
        (this.clickEventToClose = (e) => this.clickEventCloseProductsHolder(e)),
        (this.toggleOnResize = (e) => T(this.onResize(e), 200)),
        this.initSlider(),
        this.addEvents();
    }
    initSlider() {
      this.slider &&
        ((this.carousel = s.data(this.slider)),
        (this.carousel.options.wrapAround = !0),
        (this.carousel.options.freeScroll = !1),
        this.carousel.resize(),
        this.carousel.on("change", (e) => {
          (this.currentDot = this.container.querySelector(`[${Ru}="${e}"]`)),
            this.currentDot.classList.add(Qu),
            this.removeClassOnSiblingDots();
        }));
    }
    addEvents() {
      this.dots.forEach((e) => {
        e.addEventListener("click", this.clickEventsDot),
          e.addEventListener("keyup", this.keyEvents);
      }),
        document.addEventListener("keyup", this.keyCloseEvent),
        document.addEventListener("theme:resize", this.toggleOnResize),
        this.buttonClose &&
          this.buttonClose.addEventListener("click", this.clickEventToClose);
    }
    showProductsHolder() {
      const e = !this.productsHolder.classList.contains(Yu);
      this.currentDot.classList.toggle(Qu),
        this.productsHolder.classList.toggle(
          Yu,
          this.currentDot.classList.contains(Qu)
        ),
        this.currentDot.classList.contains(Qu) &&
          ((this.hasDefaultOpen = !0),
          this.carousel.selectCell(
            Number(this.currentDot.getAttribute(Ru)),
            !0,
            e
          )),
        this.removeClassOnSiblingDots();
    }
    hideProductsHolder(e) {
      "Escape" === e.code &&
        (this.removeClasses(), xi(), this.currentDot.focus());
    }
    removeClasses() {
      this.productsHolder.classList.remove(Yu),
        this.currentDot.classList.remove(Qu),
        (this.hasDefaultOpen = !1);
    }
    clickEventShowProductsHolder(e) {
      (this.currentDot = e.currentTarget), this.showProductsHolder();
    }
    clickEventCloseProductsHolder() {
      this.removeClasses();
    }
    keyboardEventShowProductHolder(e) {
      ("Enter" !== e.code && "Space" !== e.code) ||
        setTimeout(() => {
          const e = this.productsHolder.querySelector(Gu);
          Ti(this.productsHolder, { elementToFocus: e });
        }, 400);
    }
    onResize() {
      this.currentDot &&
        (window.innerWidth < window.theme.sizes.medium
          ? (this.currentDot.classList.remove(Qu),
            this.productsHolder.classList.remove(Yu))
          : this.hasDefaultOpen &&
            (this.currentDot.classList.add(Qu),
            this.productsHolder.classList.add(Yu)));
    }
    removeEvents() {
      this.dots.forEach((e) => {
        e.removeEventListener("click", this.clickEventsDot),
          e.removeEventListener("keyup", this.keyEvents);
      }),
        document.removeEventListener("keyup", this.keyCloseEvent),
        document.removeEventListener("theme:resize", this.toggleOnResize),
        this.buttonClose &&
          this.buttonClose.removeEventListener("click", this.clickEventToClose);
    }
    removeClassOnSiblingDots() {
      for (let e of this.currentDot.parentNode.children)
        e !== this.currentDot && e.classList.remove(Qu);
    }
    onUnload() {
      this.slider && this.carousel && this.carousel.destroy(),
        this.removeEvents();
    }
    onBlockSelect(e) {
      if (this.slider && this.carousel) {
        const t = this.container.querySelector(`[${Ju}="${e.detail.blockId}"]`);
        this.productsHolder.classList.add(Yu),
          this.carousel.selectCell(Number(t.getAttribute(Uu)), !0, !0);
      }
    }
    onBlockDeselect() {
      window.innerWidth < window.theme.sizes.medium &&
        (this.productsHolder.classList.remove(Yu),
        this.currentDot.classList.remove(Qu));
    }
  }
  mi("look", [
    {
      onLoad() {
        (Xu[this.id] = []), Xu[this.id].push(new Ku(this));
      },
      onUnload() {
        Xu[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
      onBlockSelect(e) {
        Xu[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        Xu[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
    },
  ]);
  const Zu = (e, t = "", i) => (
    (i = i || document.createElement("div")).classList.add(t),
    e.parentNode.insertBefore(i, e),
    i.appendChild(e)
  );
  window.theme.settings.animate_scroll && e.init({ once: !0 }),
    document.addEventListener("DOMContentLoaded", function () {
      const e = document.querySelector("[data-header-height]");
      if (e) {
        const t = e.clientHeight || 0;
        document.documentElement.style.setProperty("--menu-height", `${t}px`);
      }
      fi("*"),
        window.theme.settings.animate_hover &&
          document.body.classList.add("theme-animate-hover");
      document.querySelectorAll(".rte table").forEach((e) => {
        Zu(e, "rte__table-wrapper");
      });
      document
        .querySelectorAll(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
        )
        .forEach((e) => {
          Zu(e, "rte__video-wrapper");
        }),
        document.addEventListener("mousedown", () => {
          document.body.classList.remove("focus-enabled");
        }),
        document.addEventListener("keyup", (e) => {
          "Tab" === e.code && document.body.classList.add("focus-enabled");
        }),
        window.navigator.cookieEnabled &&
          (document.documentElement.className =
            document.documentElement.className.replace(
              "supports-no-cookies",
              "supports-cookies"
            )),
        Si(),
        Ei(),
        "scrollBehavior" in document.documentElement.style ||
          Ne({ url: window.theme.assets.smoothscroll });
    });
  var ep = [
      "input",
      "select",
      "textarea",
      "a[href]",
      "button",
      "[tabindex]",
      "audio[controls]",
      "video[controls]",
      '[contenteditable]:not([contenteditable="false"])',
      "details>summary:first-of-type",
      "details",
    ],
    tp = ep.join(","),
    ip =
      "undefined" == typeof Element
        ? function () {}
        : Element.prototype.matches ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector,
    sp = function (e, t, i) {
      var s = Array.prototype.slice.apply(e.querySelectorAll(tp));
      return t && ip.call(e, tp) && s.unshift(e), (s = s.filter(i));
    },
    rp = function (e) {
      var t = parseInt(e.getAttribute("tabindex"), 10);
      return isNaN(t)
        ? (function (e) {
            return "true" === e.contentEditable;
          })(e)
          ? 0
          : ("AUDIO" !== e.nodeName &&
              "VIDEO" !== e.nodeName &&
              "DETAILS" !== e.nodeName) ||
            null !== e.getAttribute("tabindex")
          ? e.tabIndex
          : 0
        : t;
    },
    np = function (e, t) {
      return e.tabIndex === t.tabIndex
        ? e.documentOrder - t.documentOrder
        : e.tabIndex - t.tabIndex;
    },
    op = function (e) {
      return "INPUT" === e.tagName;
    },
    ap = function (e) {
      return (
        (function (e) {
          return op(e) && "radio" === e.type;
        })(e) &&
        !(function (e) {
          if (!e.name) return !0;
          var t,
            i = e.form || e.ownerDocument,
            s = function (e) {
              return i.querySelectorAll(
                'input[type="radio"][name="' + e + '"]'
              );
            };
          if (
            "undefined" != typeof window &&
            void 0 !== window.CSS &&
            "function" == typeof window.CSS.escape
          )
            t = s(window.CSS.escape(e.name));
          else
            try {
              t = s(e.name);
            } catch (e) {
              return (
                console.error(
                  "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
                  e.message
                ),
                !1
              );
            }
          var r = (function (e, t) {
            for (var i = 0; i < e.length; i++)
              if (e[i].checked && e[i].form === t) return e[i];
          })(t, e.form);
          return !r || r === e;
        })(e)
      );
    },
    lp = function (e, t) {
      return !(
        t.disabled ||
        (function (e) {
          return op(e) && "hidden" === e.type;
        })(t) ||
        (function (e, t) {
          if ("hidden" === getComputedStyle(e).visibility) return !0;
          var i = ip.call(e, "details>summary:first-of-type")
            ? e.parentElement
            : e;
          if (ip.call(i, "details:not([open]) *")) return !0;
          if (t && "full" !== t) {
            if ("non-zero-area" === t) {
              var s = e.getBoundingClientRect(),
                r = s.width,
                n = s.height;
              return 0 === r && 0 === n;
            }
          } else
            for (; e; ) {
              if ("none" === getComputedStyle(e).display) return !0;
              e = e.parentElement;
            }
          return !1;
        })(t, e.displayCheck) ||
        (function (e) {
          return (
            "DETAILS" === e.tagName &&
            Array.prototype.slice.apply(e.children).some(function (e) {
              return "SUMMARY" === e.tagName;
            })
          );
        })(t) ||
        (function (e) {
          if (
            op(e) ||
            "SELECT" === e.tagName ||
            "TEXTAREA" === e.tagName ||
            "BUTTON" === e.tagName
          )
            for (var t = e.parentElement; t; ) {
              if ("FIELDSET" === t.tagName && t.disabled) {
                for (var i = 0; i < t.children.length; i++) {
                  var s = t.children.item(i);
                  if ("LEGEND" === s.tagName) return !s.contains(e);
                }
                return !0;
              }
              t = t.parentElement;
            }
          return !1;
        })(t)
      );
    },
    cp = function (e, t) {
      return !(!lp(e, t) || ap(t) || rp(t) < 0);
    },
    hp = function (e, t) {
      var i = [],
        s = [];
      return (
        sp(e, (t = t || {}).includeContainer, cp.bind(null, t)).forEach(
          function (e, t) {
            var r = rp(e);
            0 === r
              ? i.push(e)
              : s.push({ documentOrder: t, tabIndex: r, node: e });
          }
        ),
        s
          .sort(np)
          .map(function (e) {
            return e.node;
          })
          .concat(i)
      );
    },
    dp = ep.concat("iframe").join(","),
    up = function (e, t) {
      if (((t = t || {}), !e)) throw new Error("No node provided");
      return !1 !== ip.call(e, dp) && lp(t, e);
    };
  function pp(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(e);
      t &&
        (s = s.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        i.push.apply(i, s);
    }
    return i;
  }
  function mp(e, t, i) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = i),
      e
    );
  }
  var fp,
    gp =
      ((fp = []),
      {
        activateTrap: function (e) {
          if (fp.length > 0) {
            var t = fp[fp.length - 1];
            t !== e && t.pause();
          }
          var i = fp.indexOf(e);
          -1 === i || fp.splice(i, 1), fp.push(e);
        },
        deactivateTrap: function (e) {
          var t = fp.indexOf(e);
          -1 !== t && fp.splice(t, 1),
            fp.length > 0 && fp[fp.length - 1].unpause();
        },
      }),
    yp = function (e) {
      return setTimeout(e, 0);
    },
    vp = function (e, t) {
      var i = -1;
      return (
        e.every(function (e, s) {
          return !t(e) || ((i = s), !1);
        }),
        i
      );
    },
    bp = function (e) {
      for (
        var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1;
        s < t;
        s++
      )
        i[s - 1] = arguments[s];
      return "function" == typeof e ? e.apply(void 0, i) : e;
    },
    wp = function (e, t) {
      var i,
        s = document,
        r = (function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = null != arguments[t] ? arguments[t] : {};
            t % 2
              ? pp(Object(i), !0).forEach(function (t) {
                  mp(e, t, i[t]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
              : pp(Object(i)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(i, t)
                  );
                });
          }
          return e;
        })(
          {
            returnFocusOnDeactivate: !0,
            escapeDeactivates: !0,
            delayInitialFocus: !0,
          },
          t
        ),
        n = {
          containers: [],
          tabbableGroups: [],
          nodeFocusedBeforeActivation: null,
          mostRecentlyFocusedNode: null,
          active: !1,
          paused: !1,
          delayInitialFocusTimer: void 0,
        },
        o = function (e, t, i) {
          return e && void 0 !== e[t] ? e[t] : r[i || t];
        },
        a = function (e) {
          return n.containers.some(function (t) {
            return t.contains(e);
          });
        },
        l = function (e) {
          var t = r[e];
          if (!t) return null;
          var i = t;
          if ("string" == typeof t && !(i = s.querySelector(t)))
            throw new Error("`".concat(e, "` refers to no known node"));
          if ("function" == typeof t && !(i = t()))
            throw new Error("`".concat(e, "` did not return a node"));
          return i;
        },
        c = function () {
          var e;
          if (!1 === o({}, "initialFocus")) return !1;
          if (null !== l("initialFocus")) e = l("initialFocus");
          else if (a(s.activeElement)) e = s.activeElement;
          else {
            var t = n.tabbableGroups[0];
            e = (t && t.firstTabbableNode) || l("fallbackFocus");
          }
          if (!e)
            throw new Error(
              "Your focus-trap needs to have at least one focusable element"
            );
          return e;
        },
        h = function () {
          if (
            ((n.tabbableGroups = n.containers
              .map(function (e) {
                var t = hp(e);
                if (t.length > 0)
                  return {
                    container: e,
                    firstTabbableNode: t[0],
                    lastTabbableNode: t[t.length - 1],
                  };
              })
              .filter(function (e) {
                return !!e;
              })),
            n.tabbableGroups.length <= 0 && !l("fallbackFocus"))
          )
            throw new Error(
              "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
            );
        },
        d = function e(t) {
          !1 !== t &&
            t !== s.activeElement &&
            (t && t.focus
              ? (t.focus({ preventScroll: !!r.preventScroll }),
                (n.mostRecentlyFocusedNode = t),
                (function (e) {
                  return (
                    e.tagName &&
                    "input" === e.tagName.toLowerCase() &&
                    "function" == typeof e.select
                  );
                })(t) && t.select())
              : e(c()));
        },
        u = function (e) {
          var t = l("setReturnFocus");
          return t || e;
        },
        p = function (e) {
          a(e.target) ||
            (bp(r.clickOutsideDeactivates, e)
              ? i.deactivate({
                  returnFocus: r.returnFocusOnDeactivate && !up(e.target),
                })
              : bp(r.allowOutsideClick, e) || e.preventDefault());
        },
        m = function (e) {
          var t = a(e.target);
          t || e.target instanceof Document
            ? t && (n.mostRecentlyFocusedNode = e.target)
            : (e.stopImmediatePropagation(),
              d(n.mostRecentlyFocusedNode || c()));
        },
        f = function (e) {
          if (
            (function (e) {
              return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
            })(e) &&
            !1 !== bp(r.escapeDeactivates)
          )
            return e.preventDefault(), void i.deactivate();
          (function (e) {
            return "Tab" === e.key || 9 === e.keyCode;
          })(e) &&
            (function (e) {
              h();
              var t = null;
              if (n.tabbableGroups.length > 0) {
                var i = vp(n.tabbableGroups, function (t) {
                  return t.container.contains(e.target);
                });
                if (i < 0)
                  t = e.shiftKey
                    ? n.tabbableGroups[n.tabbableGroups.length - 1]
                        .lastTabbableNode
                    : n.tabbableGroups[0].firstTabbableNode;
                else if (e.shiftKey) {
                  var s = vp(n.tabbableGroups, function (t) {
                    var i = t.firstTabbableNode;
                    return e.target === i;
                  });
                  if (
                    (s < 0 &&
                      n.tabbableGroups[i].container === e.target &&
                      (s = i),
                    s >= 0)
                  ) {
                    var r = 0 === s ? n.tabbableGroups.length - 1 : s - 1;
                    t = n.tabbableGroups[r].lastTabbableNode;
                  }
                } else {
                  var o = vp(n.tabbableGroups, function (t) {
                    var i = t.lastTabbableNode;
                    return e.target === i;
                  });
                  if (
                    (o < 0 &&
                      n.tabbableGroups[i].container === e.target &&
                      (o = i),
                    o >= 0)
                  ) {
                    var a = o === n.tabbableGroups.length - 1 ? 0 : o + 1;
                    t = n.tabbableGroups[a].firstTabbableNode;
                  }
                }
              } else t = l("fallbackFocus");
              t && (e.preventDefault(), d(t));
            })(e);
        },
        g = function (e) {
          bp(r.clickOutsideDeactivates, e) ||
            a(e.target) ||
            bp(r.allowOutsideClick, e) ||
            (e.preventDefault(), e.stopImmediatePropagation());
        },
        y = function () {
          if (n.active)
            return (
              gp.activateTrap(i),
              (n.delayInitialFocusTimer = r.delayInitialFocus
                ? yp(function () {
                    d(c());
                  })
                : d(c())),
              s.addEventListener("focusin", m, !0),
              s.addEventListener("mousedown", p, { capture: !0, passive: !1 }),
              s.addEventListener("touchstart", p, { capture: !0, passive: !1 }),
              s.addEventListener("click", g, { capture: !0, passive: !1 }),
              s.addEventListener("keydown", f, { capture: !0, passive: !1 }),
              i
            );
        },
        v = function () {
          if (n.active)
            return (
              s.removeEventListener("focusin", m, !0),
              s.removeEventListener("mousedown", p, !0),
              s.removeEventListener("touchstart", p, !0),
              s.removeEventListener("click", g, !0),
              s.removeEventListener("keydown", f, !0),
              i
            );
        };
      return (
        (i = {
          activate: function (e) {
            if (n.active) return this;
            var t = o(e, "onActivate"),
              i = o(e, "onPostActivate"),
              r = o(e, "checkCanFocusTrap");
            r || h(),
              (n.active = !0),
              (n.paused = !1),
              (n.nodeFocusedBeforeActivation = s.activeElement),
              t && t();
            var a = function () {
              r && h(), y(), i && i();
            };
            return r
              ? (r(n.containers.concat()).then(a, a), this)
              : (a(), this);
          },
          deactivate: function (e) {
            if (!n.active) return this;
            clearTimeout(n.delayInitialFocusTimer),
              (n.delayInitialFocusTimer = void 0),
              v(),
              (n.active = !1),
              (n.paused = !1),
              gp.deactivateTrap(i);
            var t = o(e, "onDeactivate"),
              s = o(e, "onPostDeactivate"),
              r = o(e, "checkCanReturnFocus");
            t && t();
            var a = o(e, "returnFocus", "returnFocusOnDeactivate"),
              l = function () {
                yp(function () {
                  a && d(u(n.nodeFocusedBeforeActivation)), s && s();
                });
              };
            return a && r
              ? (r(u(n.nodeFocusedBeforeActivation)).then(l, l), this)
              : (l(), this);
          },
          pause: function () {
            return n.paused || !n.active || ((n.paused = !0), v()), this;
          },
          unpause: function () {
            return n.paused && n.active
              ? ((n.paused = !1), h(), y(), this)
              : this;
          },
          updateContainerElements: function (e) {
            var t = [].concat(e).filter(Boolean);
            return (
              (n.containers = t.map(function (e) {
                return "string" == typeof e ? s.querySelector(e) : e;
              })),
              n.active && h(),
              this
            );
          },
        }).updateContainerElements(e),
        i
      );
    };
  function Sp(e) {
    let t = [];
    return (
      Ep(e, (e) => {
        let i = e.hasAttribute("aria-hidden");
        e.setAttribute("aria-hidden", "true"),
          t.push(() => i || e.removeAttribute("aria-hidden"));
      }),
      () => {
        for (; t.length; ) t.pop()();
      }
    );
  }
  function Ep(e, t) {
    !e.isSameNode(document.body) &&
      e.parentNode &&
      Array.from(e.parentNode.children).forEach((i) => {
        i.isSameNode(e) ? Ep(e.parentNode, t) : t(i);
      });
  }
  var Lp,
    kp,
    Tp,
    xp,
    _p = function (e) {
      let t, i;
      window.addEventListener("focusin", () => {
        (t = i), (i = document.activeElement);
      }),
        e.magic("focus", (e) => {
          let s = e;
          return {
            __noscroll: !1,
            __wrapAround: !1,
            within(e) {
              return (s = e), this;
            },
            withoutScrolling() {
              return (this.__noscroll = !0), this;
            },
            noscroll() {
              return (this.__noscroll = !0), this;
            },
            withWrapAround() {
              return (this.__wrapAround = !0), this;
            },
            wrap() {
              return this.withWrapAround();
            },
            focusable: (e) => up(e),
            previouslyFocused: () => t,
            lastFocused: () => t,
            focused: () => i,
            focusables: () =>
              Array.isArray(s)
                ? s
                : (function (e, t) {
                    return sp(
                      e,
                      (t = t || {}).includeContainer,
                      lp.bind(null, t)
                    );
                  })(s, { displayCheck: "none" }),
            all() {
              return this.focusables();
            },
            isFirst(e) {
              let t = this.all();
              return t[0] && t[0].isSameNode(e);
            },
            isLast(e) {
              let t = this.all();
              return t.length && t.slice(-1)[0].isSameNode(e);
            },
            getFirst() {
              return this.all()[0];
            },
            getLast() {
              return this.all().slice(-1)[0];
            },
            getNext() {
              let e = this.all(),
                t = document.activeElement;
              if (-1 !== e.indexOf(t))
                return this.__wrapAround && e.indexOf(t) === e.length - 1
                  ? e[0]
                  : e[e.indexOf(t) + 1];
            },
            getPrevious() {
              let e = this.all(),
                t = document.activeElement;
              if (-1 !== e.indexOf(t))
                return this.__wrapAround && 0 === e.indexOf(t)
                  ? e.slice(-1)[0]
                  : e[e.indexOf(t) - 1];
            },
            first() {
              this.focus(this.getFirst());
            },
            last() {
              this.focus(this.getLast());
            },
            next() {
              this.focus(this.getNext());
            },
            previous() {
              this.focus(this.getPrevious());
            },
            prev() {
              return this.previous();
            },
            focus(e) {
              e &&
                setTimeout(() => {
                  e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"),
                    e.focus({ preventScroll: this._noscroll });
                });
            },
          };
        }),
        e.directive(
          "trap",
          e.skipDuringClone(
            (
              e,
              { expression: t, modifiers: i },
              { effect: s, evaluateLater: r, cleanup: n }
            ) => {
              let o = r(t),
                a = !1,
                l = wp(e, {
                  escapeDeactivates: !1,
                  allowOutsideClick: !0,
                  fallbackFocus: () => e,
                  initialFocus: e.querySelector("[autofocus]"),
                }),
                c = () => {},
                h = () => {};
              const d = () => {
                c(),
                  (c = () => {}),
                  h(),
                  (h = () => {}),
                  l.deactivate({ returnFocus: !i.includes("noreturn") });
              };
              s(() =>
                o((t) => {
                  a !== t &&
                    (t &&
                      !a &&
                      setTimeout(() => {
                        i.includes("inert") && (c = Sp(e)),
                          i.includes("noscroll") &&
                            (h = (function () {
                              let e = document.documentElement.style.overflow,
                                t = document.documentElement.style.paddingRight,
                                i =
                                  window.innerWidth -
                                  document.documentElement.clientWidth;
                              return (
                                (document.documentElement.style.overflow =
                                  "hidden"),
                                (document.documentElement.style.paddingRight = `${i}px`),
                                () => {
                                  (document.documentElement.style.overflow = e),
                                    (document.documentElement.style.paddingRight =
                                      t);
                                }
                              );
                            })()),
                          l.activate();
                      }),
                    !t && a && d(),
                    (a = !!t));
                })
              ),
                n(d);
            },
            (e, { expression: t, modifiers: i }, { evaluate: s }) => {
              i.includes("inert") && s(t) && Sp(e);
            }
          )
        );
    },
    Ap = !1,
    qp = !1,
    Cp = [],
    Pp = -1;
  /*! Bundled license information:

    tabbable/dist/index.esm.js:
      (*!
      * tabbable 5.2.1
      * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
      *)

    focus-trap/dist/focus-trap.esm.js:
      (*!
      * focus-trap 6.6.1
      * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
      *)
    */ function $p(e) {
    !(function (e) {
      Cp.includes(e) || Cp.push(e);
      qp || Ap || ((Ap = !0), queueMicrotask(Ip));
    })(e);
  }
  function Mp(e) {
    let t = Cp.indexOf(e);
    -1 !== t && t > Pp && Cp.splice(t, 1);
  }
  function Ip() {
    (Ap = !1), (qp = !0);
    for (let e = 0; e < Cp.length; e++) Cp[e](), (Pp = e);
    (Cp.length = 0), (Pp = -1), (qp = !1);
  }
  var Dp = !0;
  function Op(e) {
    kp = e;
  }
  var Hp = [],
    Fp = [],
    Bp = [];
  function Wp(e, t) {
    "function" == typeof t
      ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t))
      : ((t = e), Fp.push(t));
  }
  function Np(e, t) {
    e._x_attributeCleanups &&
      Object.entries(e._x_attributeCleanups).forEach(([i, s]) => {
        (void 0 === t || t.includes(i)) &&
          (s.forEach((e) => e()), delete e._x_attributeCleanups[i]);
      });
  }
  var Rp = new MutationObserver(Xp),
    jp = !1;
  function zp() {
    Rp.observe(document, {
      subtree: !0,
      childList: !0,
      attributes: !0,
      attributeOldValue: !0,
    }),
      (jp = !0);
  }
  function Vp() {
    (Up = Up.concat(Rp.takeRecords())).length &&
      !Jp &&
      ((Jp = !0),
      queueMicrotask(() => {
        Xp(Up), (Up.length = 0), (Jp = !1);
      })),
      Rp.disconnect(),
      (jp = !1);
  }
  var Up = [],
    Jp = !1;
  function Gp(e) {
    if (!jp) return e();
    Vp();
    let t = e();
    return zp(), t;
  }
  var Qp = !1,
    Yp = [];
  function Xp(e) {
    if (Qp) return void (Yp = Yp.concat(e));
    let t = [],
      i = [],
      s = new Map(),
      r = new Map();
    for (let n = 0; n < e.length; n++)
      if (
        !e[n].target._x_ignoreMutationObserver &&
        ("childList" === e[n].type &&
          (e[n].addedNodes.forEach((e) => 1 === e.nodeType && t.push(e)),
          e[n].removedNodes.forEach((e) => 1 === e.nodeType && i.push(e))),
        "attributes" === e[n].type)
      ) {
        let t = e[n].target,
          i = e[n].attributeName,
          o = e[n].oldValue,
          a = () => {
            s.has(t) || s.set(t, []),
              s.get(t).push({ name: i, value: t.getAttribute(i) });
          },
          l = () => {
            r.has(t) || r.set(t, []), r.get(t).push(i);
          };
        t.hasAttribute(i) && null === o
          ? a()
          : t.hasAttribute(i)
          ? (l(), a())
          : l();
      }
    r.forEach((e, t) => {
      Np(t, e);
    }),
      s.forEach((e, t) => {
        Hp.forEach((i) => i(t, e));
      });
    for (let e of i)
      if (!t.includes(e) && (Fp.forEach((t) => t(e)), e._x_cleanups))
        for (; e._x_cleanups.length; ) e._x_cleanups.pop()();
    t.forEach((e) => {
      (e._x_ignoreSelf = !0), (e._x_ignore = !0);
    });
    for (let e of t)
      i.includes(e) ||
        (e.isConnected &&
          (delete e._x_ignoreSelf,
          delete e._x_ignore,
          Bp.forEach((t) => t(e)),
          (e._x_ignore = !0),
          (e._x_ignoreSelf = !0)));
    t.forEach((e) => {
      delete e._x_ignoreSelf, delete e._x_ignore;
    }),
      (t = null),
      (i = null),
      (s = null),
      (r = null);
  }
  function Kp(e) {
    return tm(em(e));
  }
  function Zp(e, t, i) {
    return (
      (e._x_dataStack = [t, ...em(i || e)]),
      () => {
        e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
      }
    );
  }
  function em(e) {
    return e._x_dataStack
      ? e._x_dataStack
      : "function" == typeof ShadowRoot && e instanceof ShadowRoot
      ? em(e.host)
      : e.parentNode
      ? em(e.parentNode)
      : [];
  }
  function tm(e) {
    let t = new Proxy(
      {},
      {
        ownKeys: () => Array.from(new Set(e.flatMap((e) => Object.keys(e)))),
        has: (t, i) => e.some((e) => e.hasOwnProperty(i)),
        get: (i, s) =>
          (e.find((e) => {
            if (e.hasOwnProperty(s)) {
              let i = Object.getOwnPropertyDescriptor(e, s);
              if (
                (i.get && i.get._x_alreadyBound) ||
                (i.set && i.set._x_alreadyBound)
              )
                return !0;
              if ((i.get || i.set) && i.enumerable) {
                let r = i.get,
                  n = i.set,
                  o = i;
                (r = r && r.bind(t)),
                  (n = n && n.bind(t)),
                  r && (r._x_alreadyBound = !0),
                  n && (n._x_alreadyBound = !0),
                  Object.defineProperty(e, s, { ...o, get: r, set: n });
              }
              return !0;
            }
            return !1;
          }) || {})[s],
        set: (t, i, s) => {
          let r = e.find((e) => e.hasOwnProperty(i));
          return r ? (r[i] = s) : (e[e.length - 1][i] = s), !0;
        },
      }
    );
    return t;
  }
  function im(e) {
    let t = (i, s = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(i)).forEach(
        ([r, { value: n, enumerable: o }]) => {
          if (!1 === o || void 0 === n) return;
          let a = "" === s ? r : `${s}.${r}`;
          var l;
          "object" == typeof n && null !== n && n._x_interceptor
            ? (i[r] = n.initialize(e, a, r))
            : "object" != typeof (l = n) ||
              Array.isArray(l) ||
              null === l ||
              n === i ||
              n instanceof Element ||
              t(n, a);
        }
      );
    };
    return t(e);
  }
  function sm(e, t = () => {}) {
    let i = {
      initialValue: void 0,
      _x_interceptor: !0,
      initialize(t, i, s) {
        return e(
          this.initialValue,
          () =>
            (function (e, t) {
              return t.split(".").reduce((e, t) => e[t], e);
            })(t, i),
          (e) => rm(t, i, e),
          i,
          s
        );
      },
    };
    return (
      t(i),
      (e) => {
        if ("object" == typeof e && null !== e && e._x_interceptor) {
          let t = i.initialize.bind(i);
          i.initialize = (s, r, n) => {
            let o = e.initialize(s, r, n);
            return (i.initialValue = o), t(s, r, n);
          };
        } else i.initialValue = e;
        return i;
      }
    );
  }
  function rm(e, t, i) {
    if (("string" == typeof t && (t = t.split(".")), 1 !== t.length)) {
      if (0 === t.length) throw error;
      return e[t[0]] || (e[t[0]] = {}), rm(e[t[0]], t.slice(1), i);
    }
    e[t[0]] = i;
  }
  var nm = {};
  function om(e, t) {
    nm[e] = t;
  }
  function am(e, t) {
    return (
      Object.entries(nm).forEach(([i, s]) => {
        let r = null;
        Object.defineProperty(e, `$${i}`, {
          get: () =>
            s(
              t,
              (function () {
                if (r) return r;
                {
                  let [e, i] = _m(t);
                  return (r = { interceptor: sm, ...e }), Wp(t, i), r;
                }
              })()
            ),
          enumerable: !1,
        });
      }),
      e
    );
  }
  function lm(e, t, i, ...s) {
    try {
      return i(...s);
    } catch (i) {
      cm(i, e, t);
    }
  }
  function cm(e, t, i = void 0) {
    Object.assign(e, { el: t, expression: i }),
      console.warn(
        `Alpine Expression Error: ${e.message}\n\n${
          i ? 'Expression: "' + i + '"\n\n' : ""
        }`,
        t
      ),
      setTimeout(() => {
        throw e;
      }, 0);
  }
  var hm = !0;
  function dm(e) {
    let t = hm;
    hm = !1;
    let i = e();
    return (hm = t), i;
  }
  function um(e, t, i = {}) {
    let s;
    return pm(e, t)((e) => (s = e), i), s;
  }
  function pm(...e) {
    return mm(...e);
  }
  var mm = fm;
  function fm(e, t) {
    let i = {};
    am(i, e);
    let s = [i, ...em(e)],
      r =
        "function" == typeof t
          ? (function (e, t) {
              return (i = () => {}, { scope: s = {}, params: r = [] } = {}) => {
                ym(i, t.apply(tm([s, ...e]), r));
              };
            })(s, t)
          : (function (e, t, i) {
              let s = (function (e, t) {
                if (gm[e]) return gm[e];
                let i = Object.getPrototypeOf(async function () {}).constructor,
                  s =
                    /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e)
                      ? `(async()=>{ ${e} })()`
                      : e;
                const r = () => {
                  try {
                    return new i(
                      ["__self", "scope"],
                      `with (scope) { __self.result = ${s} }; __self.finished = true; return __self.result;`
                    );
                  } catch (i) {
                    return cm(i, t, e), Promise.resolve();
                  }
                };
                let n = r();
                return (gm[e] = n), n;
              })(t, i);
              return (r = () => {}, { scope: n = {}, params: o = [] } = {}) => {
                (s.result = void 0), (s.finished = !1);
                let a = tm([n, ...e]);
                if ("function" == typeof s) {
                  let e = s(s, a).catch((e) => cm(e, i, t));
                  s.finished
                    ? (ym(r, s.result, a, o, i), (s.result = void 0))
                    : e
                        .then((e) => {
                          ym(r, e, a, o, i);
                        })
                        .catch((e) => cm(e, i, t))
                        .finally(() => (s.result = void 0));
                }
              };
            })(s, t, e);
    return lm.bind(null, e, t, r);
  }
  var gm = {};
  function ym(e, t, i, s, r) {
    if (hm && "function" == typeof t) {
      let n = t.apply(i, s);
      n instanceof Promise
        ? n.then((t) => ym(e, t, i, s)).catch((e) => cm(e, r, t))
        : e(n);
    } else
      "object" == typeof t && t instanceof Promise ? t.then((t) => e(t)) : e(t);
  }
  var vm = "x-";
  function bm(e = "") {
    return vm + e;
  }
  var wm = {};
  function Sm(e, t) {
    return (
      (wm[e] = t),
      {
        before(t) {
          if (!wm[t])
            return void console.warn(
              "Cannot find directive `${directive}`. `${name}` will use the default order of execution"
            );
          const i = Dm.indexOf(t);
          Dm.splice(i >= 0 ? i : Dm.indexOf("DEFAULT"), 0, e);
        },
      }
    );
  }
  function Em(e, t, i) {
    if (((t = Array.from(t)), e._x_virtualDirectives)) {
      let i = Object.entries(e._x_virtualDirectives).map(([e, t]) => ({
          name: e,
          value: t,
        })),
        s = Lm(i);
      (i = i.map((e) =>
        s.find((t) => t.name === e.name)
          ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
          : e
      )),
        (t = t.concat(i));
    }
    let s = {},
      r = t
        .map(qm((e, t) => (s[e] = t)))
        .filter($m)
        .map(
          (function (e, t) {
            return ({ name: i, value: s }) => {
              let r = i.match(Mm()),
                n = i.match(/:([a-zA-Z0-9\-:]+)/),
                o = i.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                a = t || e[i] || i;
              return {
                type: r ? r[1] : null,
                value: n ? n[1] : null,
                modifiers: o.map((e) => e.replace(".", "")),
                expression: s,
                original: a,
              };
            };
          })(s, i)
        )
        .sort(Om);
    return r.map((t) =>
      (function (e, t) {
        let i = () => {},
          s = wm[t.type] || i,
          [r, n] = _m(e);
        !(function (e, t, i) {
          e._x_attributeCleanups || (e._x_attributeCleanups = {}),
            e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []),
            e._x_attributeCleanups[t].push(i);
        })(e, t.original, n);
        let o = () => {
          e._x_ignore ||
            e._x_ignoreSelf ||
            (s.inline && s.inline(e, t, r),
            (s = s.bind(s, e, t, r)),
            km ? Tm.get(xm).push(s) : s());
        };
        return (o.runCleanups = n), o;
      })(e, t)
    );
  }
  function Lm(e) {
    return Array.from(e)
      .map(qm())
      .filter((e) => !$m(e));
  }
  var km = !1,
    Tm = new Map(),
    xm = Symbol();
  function _m(e) {
    let t = [],
      [i, s] = (function (e) {
        let t = () => {};
        return [
          (i) => {
            let s = kp(i);
            return (
              e._x_effects ||
                ((e._x_effects = new Set()),
                (e._x_runEffects = () => {
                  e._x_effects.forEach((e) => e());
                })),
              e._x_effects.add(s),
              (t = () => {
                void 0 !== s && (e._x_effects.delete(s), Tp(s));
              }),
              s
            );
          },
          () => {
            t();
          },
        ];
      })(e);
    t.push(s);
    return [
      {
        Alpine: Tf,
        effect: i,
        cleanup: (e) => t.push(e),
        evaluateLater: pm.bind(pm, e),
        evaluate: um.bind(um, e),
      },
      () => t.forEach((e) => e()),
    ];
  }
  var Am =
    (e, t) =>
    ({ name: i, value: s }) => (
      i.startsWith(e) && (i = i.replace(e, t)), { name: i, value: s }
    );
  function qm(e = () => {}) {
    return ({ name: t, value: i }) => {
      let { name: s, value: r } = Cm.reduce((e, t) => t(e), {
        name: t,
        value: i,
      });
      return s !== t && e(s, t), { name: s, value: r };
    };
  }
  var Cm = [];
  function Pm(e) {
    Cm.push(e);
  }
  function $m({ name: e }) {
    return Mm().test(e);
  }
  var Mm = () => new RegExp(`^${vm}([^:^.]+)\\b`);
  var Im = "DEFAULT",
    Dm = [
      "ignore",
      "ref",
      "data",
      "id",
      "bind",
      "init",
      "for",
      "model",
      "modelable",
      "transition",
      "show",
      "if",
      Im,
      "teleport",
    ];
  function Om(e, t) {
    let i = -1 === Dm.indexOf(e.type) ? Im : e.type,
      s = -1 === Dm.indexOf(t.type) ? Im : t.type;
    return Dm.indexOf(i) - Dm.indexOf(s);
  }
  function Hm(e, t, i = {}) {
    e.dispatchEvent(
      new CustomEvent(t, {
        detail: i,
        bubbles: !0,
        composed: !0,
        cancelable: !0,
      })
    );
  }
  function Fm(e, t) {
    if ("function" == typeof ShadowRoot && e instanceof ShadowRoot)
      return void Array.from(e.children).forEach((e) => Fm(e, t));
    let i = !1;
    if ((t(e, () => (i = !0)), i)) return;
    let s = e.firstElementChild;
    for (; s; ) Fm(s, t), (s = s.nextElementSibling);
  }
  function Bm(e, ...t) {
    console.warn(`Alpine Warning: ${e}`, ...t);
  }
  var Wm = !1;
  var Nm = [],
    Rm = [];
  function jm() {
    return Nm.map((e) => e());
  }
  function zm() {
    return Nm.concat(Rm).map((e) => e());
  }
  function Vm(e) {
    Nm.push(e);
  }
  function Um(e) {
    Rm.push(e);
  }
  function Jm(e, t = !1) {
    return Gm(e, (e) => {
      if ((t ? zm() : jm()).some((t) => e.matches(t))) return !0;
    });
  }
  function Gm(e, t) {
    if (e) {
      if (t(e)) return e;
      if ((e._x_teleportBack && (e = e._x_teleportBack), e.parentElement))
        return Gm(e.parentElement, t);
    }
  }
  var Qm = [];
  function Ym(e, t = Fm, i = () => {}) {
    !(function (e) {
      km = !0;
      let t = Symbol();
      (xm = t), Tm.set(t, []);
      let i = () => {
        for (; Tm.get(t).length; ) Tm.get(t).shift()();
        Tm.delete(t);
      };
      e(i), (km = !1), i();
    })(() => {
      t(e, (e, t) => {
        i(e, t),
          Qm.forEach((i) => i(e, t)),
          Em(e, e.attributes).forEach((e) => e()),
          e._x_ignore && t();
      });
    });
  }
  function Xm(e) {
    Fm(e, (e) => Np(e));
  }
  var Km = [],
    Zm = !1;
  function ef(e = () => {}) {
    return (
      queueMicrotask(() => {
        Zm ||
          setTimeout(() => {
            tf();
          });
      }),
      new Promise((t) => {
        Km.push(() => {
          e(), t();
        });
      })
    );
  }
  function tf() {
    for (Zm = !1; Km.length; ) Km.shift()();
  }
  function sf(e, t) {
    return Array.isArray(t)
      ? rf(e, t.join(" "))
      : "object" == typeof t && null !== t
      ? (function (e, t) {
          let i = (e) => e.split(" ").filter(Boolean),
            s = Object.entries(t)
              .flatMap(([e, t]) => !!t && i(e))
              .filter(Boolean),
            r = Object.entries(t)
              .flatMap(([e, t]) => !t && i(e))
              .filter(Boolean),
            n = [],
            o = [];
          return (
            r.forEach((t) => {
              e.classList.contains(t) && (e.classList.remove(t), o.push(t));
            }),
            s.forEach((t) => {
              e.classList.contains(t) || (e.classList.add(t), n.push(t));
            }),
            () => {
              o.forEach((t) => e.classList.add(t)),
                n.forEach((t) => e.classList.remove(t));
            }
          );
        })(e, t)
      : "function" == typeof t
      ? sf(e, t())
      : rf(e, t);
  }
  function rf(e, t) {
    return (
      (t = !0 === t ? (t = "") : t || ""),
      ((t) => (
        e.classList.add(...t),
        () => {
          e.classList.remove(...t);
        }
      ))(
        t
          .split(" ")
          .filter((t) => !e.classList.contains(t))
          .filter(Boolean)
      )
    );
  }
  function nf(e, t) {
    return "object" == typeof t && null !== t
      ? (function (e, t) {
          let i = {};
          return (
            Object.entries(t).forEach(([t, s]) => {
              (i[t] = e.style[t]),
                t.startsWith("--") ||
                  (t = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()),
                e.style.setProperty(t, s);
            }),
            setTimeout(() => {
              0 === e.style.length && e.removeAttribute("style");
            }),
            () => {
              nf(e, i);
            }
          );
        })(e, t)
      : (function (e, t) {
          let i = e.getAttribute("style", t);
          return (
            e.setAttribute("style", t),
            () => {
              e.setAttribute("style", i || "");
            }
          );
        })(e, t);
  }
  function of(e, t = () => {}) {
    let i = !1;
    return function () {
      i ? t.apply(this, arguments) : ((i = !0), e.apply(this, arguments));
    };
  }
  function af(e, t, i = {}) {
    e._x_transition ||
      (e._x_transition = {
        enter: { during: i, start: i, end: i },
        leave: { during: i, start: i, end: i },
        in(i = () => {}, s = () => {}) {
          cf(
            e,
            t,
            {
              during: this.enter.during,
              start: this.enter.start,
              end: this.enter.end,
            },
            i,
            s
          );
        },
        out(i = () => {}, s = () => {}) {
          cf(
            e,
            t,
            {
              during: this.leave.during,
              start: this.leave.start,
              end: this.leave.end,
            },
            i,
            s
          );
        },
      });
  }
  function lf(e) {
    let t = e.parentNode;
    if (t) return t._x_hidePromise ? t : lf(t);
  }
  function cf(
    e,
    t,
    { during: i, start: s, end: r } = {},
    n = () => {},
    o = () => {}
  ) {
    if (
      (e._x_transitioning && e._x_transitioning.cancel(),
      0 === Object.keys(i).length &&
        0 === Object.keys(s).length &&
        0 === Object.keys(r).length)
    )
      return n(), void o();
    let a, l, c;
    !(function (e, t) {
      let i,
        s,
        r,
        n = of(() => {
          Gp(() => {
            (i = !0),
              s || t.before(),
              r || (t.end(), tf()),
              t.after(),
              e.isConnected && t.cleanup(),
              delete e._x_transitioning;
          });
        });
      (e._x_transitioning = {
        beforeCancels: [],
        beforeCancel(e) {
          this.beforeCancels.push(e);
        },
        cancel: of(function () {
          for (; this.beforeCancels.length; ) this.beforeCancels.shift()();
          n();
        }),
        finish: n,
      }),
        Gp(() => {
          t.start(), t.during();
        }),
        (Zm = !0),
        requestAnimationFrame(() => {
          if (i) return;
          let n =
              1e3 *
              Number(
                getComputedStyle(e)
                  .transitionDuration.replace(/,.*/, "")
                  .replace("s", "")
              ),
            o =
              1e3 *
              Number(
                getComputedStyle(e)
                  .transitionDelay.replace(/,.*/, "")
                  .replace("s", "")
              );
          0 === n &&
            (n =
              1e3 *
              Number(getComputedStyle(e).animationDuration.replace("s", ""))),
            Gp(() => {
              t.before();
            }),
            (s = !0),
            requestAnimationFrame(() => {
              i ||
                (Gp(() => {
                  t.end();
                }),
                tf(),
                setTimeout(e._x_transitioning.finish, n + o),
                (r = !0));
            });
        });
    })(e, {
      start() {
        a = t(e, s);
      },
      during() {
        l = t(e, i);
      },
      before: n,
      end() {
        a(), (c = t(e, r));
      },
      after: o,
      cleanup() {
        l(), c();
      },
    });
  }
  function hf(e, t, i) {
    if (-1 === e.indexOf(t)) return i;
    const s = e[e.indexOf(t) + 1];
    if (!s) return i;
    if ("scale" === t && isNaN(s)) return i;
    if ("duration" === t || "delay" === t) {
      let e = s.match(/([0-9]+)ms/);
      if (e) return e[1];
    }
    return "origin" === t &&
      ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2])
      ? [s, e[e.indexOf(t) + 2]].join(" ")
      : s;
  }
  Sm(
    "transition",
    (e, { value: t, modifiers: i, expression: s }, { evaluate: r }) => {
      "function" == typeof s && (s = r(s)),
        !1 !== s &&
          (s && "boolean" != typeof s
            ? (function (e, t, i) {
                af(e, sf, "");
                let s = {
                  enter: (t) => {
                    e._x_transition.enter.during = t;
                  },
                  "enter-start": (t) => {
                    e._x_transition.enter.start = t;
                  },
                  "enter-end": (t) => {
                    e._x_transition.enter.end = t;
                  },
                  leave: (t) => {
                    e._x_transition.leave.during = t;
                  },
                  "leave-start": (t) => {
                    e._x_transition.leave.start = t;
                  },
                  "leave-end": (t) => {
                    e._x_transition.leave.end = t;
                  },
                };
                s[i](t);
              })(e, s, t)
            : (function (e, t, i) {
                af(e, nf);
                let s = !t.includes("in") && !t.includes("out") && !i,
                  r = s || t.includes("in") || ["enter"].includes(i),
                  n = s || t.includes("out") || ["leave"].includes(i);
                t.includes("in") &&
                  !s &&
                  (t = t.filter((e, i) => i < t.indexOf("out")));
                t.includes("out") &&
                  !s &&
                  (t = t.filter((e, i) => i > t.indexOf("out")));
                let o = !t.includes("opacity") && !t.includes("scale"),
                  a = o || t.includes("opacity"),
                  l = o || t.includes("scale"),
                  c = a ? 0 : 1,
                  h = l ? hf(t, "scale", 95) / 100 : 1,
                  d = hf(t, "delay", 0) / 1e3,
                  u = hf(t, "origin", "center"),
                  p = "opacity, transform",
                  m = hf(t, "duration", 150) / 1e3,
                  f = hf(t, "duration", 75) / 1e3,
                  g = "cubic-bezier(0.4, 0.0, 0.2, 1)";
                r &&
                  ((e._x_transition.enter.during = {
                    transformOrigin: u,
                    transitionDelay: `${d}s`,
                    transitionProperty: p,
                    transitionDuration: `${m}s`,
                    transitionTimingFunction: g,
                  }),
                  (e._x_transition.enter.start = {
                    opacity: c,
                    transform: `scale(${h})`,
                  }),
                  (e._x_transition.enter.end = {
                    opacity: 1,
                    transform: "scale(1)",
                  }));
                n &&
                  ((e._x_transition.leave.during = {
                    transformOrigin: u,
                    transitionDelay: `${d}s`,
                    transitionProperty: p,
                    transitionDuration: `${f}s`,
                    transitionTimingFunction: g,
                  }),
                  (e._x_transition.leave.start = {
                    opacity: 1,
                    transform: "scale(1)",
                  }),
                  (e._x_transition.leave.end = {
                    opacity: c,
                    transform: `scale(${h})`,
                  }));
              })(e, i, t));
    }
  ),
    (window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
      e,
      t,
      i,
      s
    ) {
      const r =
        "visible" === document.visibilityState
          ? requestAnimationFrame
          : setTimeout;
      let n = () => r(i);
      t
        ? e._x_transition && (e._x_transition.enter || e._x_transition.leave)
          ? e._x_transition.enter &&
            (Object.entries(e._x_transition.enter.during).length ||
              Object.entries(e._x_transition.enter.start).length ||
              Object.entries(e._x_transition.enter.end).length)
            ? e._x_transition.in(i)
            : n()
          : e._x_transition
          ? e._x_transition.in(i)
          : n()
        : ((e._x_hidePromise = e._x_transition
            ? new Promise((t, i) => {
                e._x_transition.out(
                  () => {},
                  () => t(s)
                ),
                  e._x_transitioning.beforeCancel(() =>
                    i({ isFromCancelledTransition: !0 })
                  );
              })
            : Promise.resolve(s)),
          queueMicrotask(() => {
            let t = lf(e);
            t
              ? (t._x_hideChildren || (t._x_hideChildren = []),
                t._x_hideChildren.push(e))
              : r(() => {
                  let t = (e) => {
                    let i = Promise.all([
                      e._x_hidePromise,
                      ...(e._x_hideChildren || []).map(t),
                    ]).then(([e]) => e());
                    return delete e._x_hidePromise, delete e._x_hideChildren, i;
                  };
                  t(e).catch((e) => {
                    if (!e.isFromCancelledTransition) throw e;
                  });
                });
          }));
    });
  var df = !1;
  function uf(e, t = () => {}) {
    return (...i) => (df ? t(...i) : e(...i));
  }
  function pf(e, t, i, s = []) {
    switch (
      (e._x_bindings || (e._x_bindings = Lp({})),
      (e._x_bindings[t] = i),
      (t = s.includes("camel")
        ? t.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase())
        : t))
    ) {
      case "value":
        !(function (e, t) {
          if ("radio" === e.type)
            void 0 === e.attributes.value && (e.value = t),
              window.fromModel && (e.checked = ff(e.value, t));
          else if ("checkbox" === e.type)
            Number.isInteger(t)
              ? (e.value = t)
              : Number.isInteger(t) ||
                Array.isArray(t) ||
                "boolean" == typeof t ||
                [null, void 0].includes(t)
              ? Array.isArray(t)
                ? (e.checked = t.some((t) => ff(t, e.value)))
                : (e.checked = !!t)
              : (e.value = String(t));
          else if ("SELECT" === e.tagName)
            !(function (e, t) {
              const i = [].concat(t).map((e) => e + "");
              Array.from(e.options).forEach((e) => {
                e.selected = i.includes(e.value);
              });
            })(e, t);
          else {
            if (e.value === t) return;
            e.value = t;
          }
        })(e, i);
        break;
      case "style":
        !(function (e, t) {
          e._x_undoAddedStyles && e._x_undoAddedStyles();
          e._x_undoAddedStyles = nf(e, t);
        })(e, i);
        break;
      case "class":
        !(function (e, t) {
          e._x_undoAddedClasses && e._x_undoAddedClasses();
          e._x_undoAddedClasses = sf(e, t);
        })(e, i);
        break;
      case "selected":
      case "checked":
        !(function (e, t, i) {
          mf(e, t, i),
            (function (e, t, i) {
              e[t] !== i && (e[t] = i);
            })(e, t, i);
        })(e, t, i);
        break;
      default:
        mf(e, t, i);
    }
  }
  function mf(e, t, i) {
    [null, void 0, !1].includes(i) &&
    (function (e) {
      return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected",
      ].includes(e);
    })(t)
      ? e.removeAttribute(t)
      : (gf(t) && (i = t),
        (function (e, t, i) {
          e.getAttribute(t) != i && e.setAttribute(t, i);
        })(e, t, i));
  }
  function ff(e, t) {
    return e == t;
  }
  function gf(e) {
    return [
      "disabled",
      "checked",
      "required",
      "readonly",
      "hidden",
      "open",
      "selected",
      "autofocus",
      "itemscope",
      "multiple",
      "novalidate",
      "allowfullscreen",
      "allowpaymentrequest",
      "formnovalidate",
      "autoplay",
      "controls",
      "loop",
      "muted",
      "playsinline",
      "default",
      "ismap",
      "reversed",
      "async",
      "defer",
      "nomodule",
    ].includes(e);
  }
  function yf(e, t, i) {
    let s = e.getAttribute(t);
    return null === s
      ? "function" == typeof i
        ? i()
        : i
      : "" === s || (gf(t) ? !![t, "true"].includes(s) : s);
  }
  function vf(e, t) {
    var i;
    return function () {
      var s = this,
        r = arguments;
      clearTimeout(i),
        (i = setTimeout(function () {
          (i = null), e.apply(s, r);
        }, t));
    };
  }
  function bf(e, t) {
    let i;
    return function () {
      let s = this,
        r = arguments;
      i || (e.apply(s, r), (i = !0), setTimeout(() => (i = !1), t));
    };
  }
  var wf = {},
    Sf = !1;
  var Ef = {};
  function Lf(e, t, i) {
    let s = [];
    for (; s.length; ) s.pop()();
    let r = Object.entries(t).map(([e, t]) => ({ name: e, value: t })),
      n = Lm(r);
    (r = r.map((e) =>
      n.find((t) => t.name === e.name)
        ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
        : e
    )),
      Em(e, r, i).map((e) => {
        s.push(e.runCleanups), e();
      });
  }
  var kf = {};
  var Tf = {
    get reactive() {
      return Lp;
    },
    get release() {
      return Tp;
    },
    get effect() {
      return kp;
    },
    get raw() {
      return xp;
    },
    version: "3.12.3",
    flushAndStopDeferringMutations: function () {
      (Qp = !1), Xp(Yp), (Yp = []);
    },
    dontAutoEvaluateFunctions: dm,
    disableEffectScheduling: function (e) {
      (Dp = !1), e(), (Dp = !0);
    },
    startObservingMutations: zp,
    stopObservingMutations: Vp,
    setReactivityEngine: function (e) {
      (Lp = e.reactive),
        (Tp = e.release),
        (kp = (t) =>
          e.effect(t, {
            scheduler: (e) => {
              Dp ? $p(e) : e();
            },
          })),
        (xp = e.raw);
    },
    closestDataStack: em,
    skipDuringClone: uf,
    onlyDuringClone: function (e) {
      return (...t) => df && e(...t);
    },
    addRootSelector: Vm,
    addInitSelector: Um,
    addScopeToNode: Zp,
    deferMutations: function () {
      Qp = !0;
    },
    mapAttributes: Pm,
    evaluateLater: pm,
    interceptInit: function (e) {
      Qm.push(e);
    },
    setEvaluator: function (e) {
      mm = e;
    },
    mergeProxies: tm,
    extractProp: function (e, t, i, s = !0) {
      if (e._x_bindings && void 0 !== e._x_bindings[t]) return e._x_bindings[t];
      if (e._x_inlineBindings && void 0 !== e._x_inlineBindings[t]) {
        let i = e._x_inlineBindings[t];
        return (i.extract = s), dm(() => um(e, i.expression));
      }
      return yf(e, t, i);
    },
    findClosest: Gm,
    closestRoot: Jm,
    destroyTree: Xm,
    interceptor: sm,
    transition: cf,
    setStyles: nf,
    mutateDom: Gp,
    directive: Sm,
    throttle: bf,
    debounce: vf,
    evaluate: um,
    initTree: Ym,
    nextTick: ef,
    prefixed: bm,
    prefix: function (e) {
      vm = e;
    },
    plugin: function (e) {
      (Array.isArray(e) ? e : [e]).forEach((e) => e(Tf));
    },
    magic: om,
    store: function (e, t) {
      if ((Sf || ((wf = Lp(wf)), (Sf = !0)), void 0 === t)) return wf[e];
      (wf[e] = t),
        "object" == typeof t &&
          null !== t &&
          t.hasOwnProperty("init") &&
          "function" == typeof t.init &&
          wf[e].init(),
        im(wf[e]);
    },
    start: function () {
      var e;
      Wm &&
        Bm(
          "Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."
        ),
        (Wm = !0),
        document.body ||
          Bm(
            "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
          ),
        Hm(document, "alpine:init"),
        Hm(document, "alpine:initializing"),
        zp(),
        (e = (e) => Ym(e, Fm)),
        Bp.push(e),
        Wp((e) => Xm(e)),
        (function (e) {
          Hp.push(e);
        })((e, t) => {
          Em(e, t).forEach((e) => e());
        }),
        Array.from(document.querySelectorAll(zm()))
          .filter((e) => !Jm(e.parentElement, !0))
          .forEach((e) => {
            Ym(e);
          }),
        Hm(document, "alpine:initialized");
    },
    clone: function (e, t) {
      t._x_dataStack || (t._x_dataStack = e._x_dataStack),
        (df = !0),
        (function (e) {
          let t = kp;
          Op((e, i) => {
            let s = t(e);
            return Tp(s), () => {};
          }),
            e(),
            Op(t);
        })(() => {
          !(function (e) {
            let t = !1;
            Ym(e, (e, i) => {
              Fm(e, (e, s) => {
                if (
                  t &&
                  (function (e) {
                    return jm().some((t) => e.matches(t));
                  })(e)
                )
                  return s();
                (t = !0), i(e, s);
              });
            });
          })(t);
        }),
        (df = !1);
    },
    bound: function (e, t, i) {
      return e._x_bindings && void 0 !== e._x_bindings[t]
        ? e._x_bindings[t]
        : yf(e, t, i);
    },
    $data: Kp,
    walk: Fm,
    data: function (e, t) {
      kf[e] = t;
    },
    bind: function (e, t) {
      let i = "function" != typeof t ? () => t : t;
      e instanceof Element ? Lf(e, i()) : (Ef[e] = i);
    },
  };
  function xf(e, t) {
    const i = Object.create(null),
      s = e.split(",");
    for (let e = 0; e < s.length; e++) i[s[e]] = !0;
    return t ? (e) => !!i[e.toLowerCase()] : (e) => !!i[e];
  }
  var _f = Object.freeze({});
  Object.freeze([]);
  var Af,
    qf = Object.assign,
    Cf = Object.prototype.hasOwnProperty,
    Pf = (e, t) => Cf.call(e, t),
    $f = Array.isArray,
    Mf = (e) => "[object Map]" === Hf(e),
    If = (e) => "symbol" == typeof e,
    Df = (e) => null !== e && "object" == typeof e,
    Of = Object.prototype.toString,
    Hf = (e) => Of.call(e),
    Ff = (e) => Hf(e).slice(8, -1),
    Bf = (e) =>
      "string" == typeof e &&
      "NaN" !== e &&
      "-" !== e[0] &&
      "" + parseInt(e, 10) === e,
    Wf = ((e) => {
      const t = Object.create(null);
      return (i) => t[i] || (t[i] = e(i));
    })((e) => e.charAt(0).toUpperCase() + e.slice(1)),
    Nf = (e, t) => e !== t && (e == e || t == t),
    Rf = new WeakMap(),
    jf = [],
    zf = Symbol("iterate"),
    Vf = Symbol("Map key iterate");
  var Uf = 0;
  function Jf(e) {
    const { deps: t } = e;
    if (t.length) {
      for (let i = 0; i < t.length; i++) t[i].delete(e);
      t.length = 0;
    }
  }
  var Gf = !0,
    Qf = [];
  function Yf() {
    const e = Qf.pop();
    Gf = void 0 === e || e;
  }
  function Xf(e, t, i) {
    if (!Gf || void 0 === Af) return;
    let s = Rf.get(e);
    s || Rf.set(e, (s = new Map()));
    let r = s.get(i);
    r || s.set(i, (r = new Set())),
      r.has(Af) ||
        (r.add(Af),
        Af.deps.push(r),
        Af.options.onTrack &&
          Af.options.onTrack({ effect: Af, target: e, type: t, key: i }));
  }
  function Kf(e, t, i, s, r, n) {
    const o = Rf.get(e);
    if (!o) return;
    const a = new Set(),
      l = (e) => {
        e &&
          e.forEach((e) => {
            (e !== Af || e.allowRecurse) && a.add(e);
          });
      };
    if ("clear" === t) o.forEach(l);
    else if ("length" === i && $f(e))
      o.forEach((e, t) => {
        ("length" === t || t >= s) && l(e);
      });
    else
      switch ((void 0 !== i && l(o.get(i)), t)) {
        case "add":
          $f(e)
            ? Bf(i) && l(o.get("length"))
            : (l(o.get(zf)), Mf(e) && l(o.get(Vf)));
          break;
        case "delete":
          $f(e) || (l(o.get(zf)), Mf(e) && l(o.get(Vf)));
          break;
        case "set":
          Mf(e) && l(o.get(zf));
      }
    a.forEach((o) => {
      o.options.onTrigger &&
        o.options.onTrigger({
          effect: o,
          target: e,
          key: i,
          type: t,
          newValue: s,
          oldValue: r,
          oldTarget: n,
        }),
        o.options.scheduler ? o.options.scheduler(o) : o();
    });
  }
  var Zf = xf("__proto__,__v_isRef,__isVue"),
    eg = new Set(
      Object.getOwnPropertyNames(Symbol)
        .map((e) => Symbol[e])
        .filter(If)
    ),
    tg = og(),
    ig = og(!1, !0),
    sg = og(!0),
    rg = og(!0, !0),
    ng = {};
  function og(e = !1, t = !1) {
    return function (i, s, r) {
      if ("__v_isReactive" === s) return !e;
      if ("__v_isReadonly" === s) return e;
      if ("__v_raw" === s && r === (e ? (t ? Dg : Ig) : t ? Mg : $g).get(i))
        return i;
      const n = $f(i);
      if (!e && n && Pf(ng, s)) return Reflect.get(ng, s, r);
      const o = Reflect.get(i, s, r);
      if (If(s) ? eg.has(s) : Zf(s)) return o;
      if ((e || Xf(i, "get", s), t)) return o;
      if (Wg(o)) {
        return !n || !Bf(s) ? o.value : o;
      }
      return Df(o) ? (e ? Hg(o) : Og(o)) : o;
    };
  }
  function ag(e = !1) {
    return function (t, i, s, r) {
      let n = t[i];
      if (!e && ((s = Bg(s)), (n = Bg(n)), !$f(t) && Wg(n) && !Wg(s)))
        return (n.value = s), !0;
      const o = $f(t) && Bf(i) ? Number(i) < t.length : Pf(t, i),
        a = Reflect.set(t, i, s, r);
      return (
        t === Bg(r) &&
          (o ? Nf(s, n) && Kf(t, "set", i, s, n) : Kf(t, "add", i, s)),
        a
      );
    };
  }
  ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
    const t = Array.prototype[e];
    ng[e] = function (...e) {
      const i = Bg(this);
      for (let e = 0, t = this.length; e < t; e++) Xf(i, "get", e + "");
      const s = t.apply(i, e);
      return -1 === s || !1 === s ? t.apply(i, e.map(Bg)) : s;
    };
  }),
    ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
      const t = Array.prototype[e];
      ng[e] = function (...e) {
        Qf.push(Gf), (Gf = !1);
        const i = t.apply(this, e);
        return Yf(), i;
      };
    });
  var lg = {
      get: tg,
      set: ag(),
      deleteProperty: function (e, t) {
        const i = Pf(e, t),
          s = e[t],
          r = Reflect.deleteProperty(e, t);
        return r && i && Kf(e, "delete", t, void 0, s), r;
      },
      has: function (e, t) {
        const i = Reflect.has(e, t);
        return (If(t) && eg.has(t)) || Xf(e, "has", t), i;
      },
      ownKeys: function (e) {
        return Xf(e, "iterate", $f(e) ? "length" : zf), Reflect.ownKeys(e);
      },
    },
    cg = {
      get: sg,
      set: (e, t) => (
        console.warn(
          `Set operation on key "${String(t)}" failed: target is readonly.`,
          e
        ),
        !0
      ),
      deleteProperty: (e, t) => (
        console.warn(
          `Delete operation on key "${String(t)}" failed: target is readonly.`,
          e
        ),
        !0
      ),
    };
  qf({}, lg, { get: ig, set: ag(!0) }), qf({}, cg, { get: rg });
  var hg = (e) => (Df(e) ? Og(e) : e),
    dg = (e) => (Df(e) ? Hg(e) : e),
    ug = (e) => e,
    pg = (e) => Reflect.getPrototypeOf(e);
  function mg(e, t, i = !1, s = !1) {
    const r = Bg((e = e.__v_raw)),
      n = Bg(t);
    t !== n && !i && Xf(r, "get", t), !i && Xf(r, "get", n);
    const { has: o } = pg(r),
      a = s ? ug : i ? dg : hg;
    return o.call(r, t)
      ? a(e.get(t))
      : o.call(r, n)
      ? a(e.get(n))
      : void (e !== r && e.get(t));
  }
  function fg(e, t = !1) {
    const i = this.__v_raw,
      s = Bg(i),
      r = Bg(e);
    return (
      e !== r && !t && Xf(s, "has", e),
      !t && Xf(s, "has", r),
      e === r ? i.has(e) : i.has(e) || i.has(r)
    );
  }
  function gg(e, t = !1) {
    return (
      (e = e.__v_raw), !t && Xf(Bg(e), "iterate", zf), Reflect.get(e, "size", e)
    );
  }
  function yg(e) {
    e = Bg(e);
    const t = Bg(this);
    return pg(t).has.call(t, e) || (t.add(e), Kf(t, "add", e, e)), this;
  }
  function vg(e, t) {
    t = Bg(t);
    const i = Bg(this),
      { has: s, get: r } = pg(i);
    let n = s.call(i, e);
    n ? Pg(i, s, e) : ((e = Bg(e)), (n = s.call(i, e)));
    const o = r.call(i, e);
    return (
      i.set(e, t),
      n ? Nf(t, o) && Kf(i, "set", e, t, o) : Kf(i, "add", e, t),
      this
    );
  }
  function bg(e) {
    const t = Bg(this),
      { has: i, get: s } = pg(t);
    let r = i.call(t, e);
    r ? Pg(t, i, e) : ((e = Bg(e)), (r = i.call(t, e)));
    const n = s ? s.call(t, e) : void 0,
      o = t.delete(e);
    return r && Kf(t, "delete", e, void 0, n), o;
  }
  function wg() {
    const e = Bg(this),
      t = 0 !== e.size,
      i = Mf(e) ? new Map(e) : new Set(e),
      s = e.clear();
    return t && Kf(e, "clear", void 0, void 0, i), s;
  }
  function Sg(e, t) {
    return function (i, s) {
      const r = this,
        n = r.__v_raw,
        o = Bg(n),
        a = t ? ug : e ? dg : hg;
      return (
        !e && Xf(o, "iterate", zf),
        n.forEach((e, t) => i.call(s, a(e), a(t), r))
      );
    };
  }
  function Eg(e, t, i) {
    return function (...s) {
      const r = this.__v_raw,
        n = Bg(r),
        o = Mf(n),
        a = "entries" === e || (e === Symbol.iterator && o),
        l = "keys" === e && o,
        c = r[e](...s),
        h = i ? ug : t ? dg : hg;
      return (
        !t && Xf(n, "iterate", l ? Vf : zf),
        {
          next() {
            const { value: e, done: t } = c.next();
            return t
              ? { value: e, done: t }
              : { value: a ? [h(e[0]), h(e[1])] : h(e), done: t };
          },
          [Symbol.iterator]() {
            return this;
          },
        }
      );
    };
  }
  function Lg(e) {
    return function (...t) {
      {
        const i = t[0] ? `on key "${t[0]}" ` : "";
        console.warn(
          `${Wf(e)} operation ${i}failed: target is readonly.`,
          Bg(this)
        );
      }
      return "delete" !== e && this;
    };
  }
  var kg = {
      get(e) {
        return mg(this, e);
      },
      get size() {
        return gg(this);
      },
      has: fg,
      add: yg,
      set: vg,
      delete: bg,
      clear: wg,
      forEach: Sg(!1, !1),
    },
    Tg = {
      get(e) {
        return mg(this, e, !1, !0);
      },
      get size() {
        return gg(this);
      },
      has: fg,
      add: yg,
      set: vg,
      delete: bg,
      clear: wg,
      forEach: Sg(!1, !0),
    },
    xg = {
      get(e) {
        return mg(this, e, !0);
      },
      get size() {
        return gg(this, !0);
      },
      has(e) {
        return fg.call(this, e, !0);
      },
      add: Lg("add"),
      set: Lg("set"),
      delete: Lg("delete"),
      clear: Lg("clear"),
      forEach: Sg(!0, !1),
    },
    _g = {
      get(e) {
        return mg(this, e, !0, !0);
      },
      get size() {
        return gg(this, !0);
      },
      has(e) {
        return fg.call(this, e, !0);
      },
      add: Lg("add"),
      set: Lg("set"),
      delete: Lg("delete"),
      clear: Lg("clear"),
      forEach: Sg(!0, !0),
    };
  function Ag(e, t) {
    const i = t ? (e ? _g : Tg) : e ? xg : kg;
    return (t, s, r) =>
      "__v_isReactive" === s
        ? !e
        : "__v_isReadonly" === s
        ? e
        : "__v_raw" === s
        ? t
        : Reflect.get(Pf(i, s) && s in t ? i : t, s, r);
  }
  ["keys", "values", "entries", Symbol.iterator].forEach((e) => {
    (kg[e] = Eg(e, !1, !1)),
      (xg[e] = Eg(e, !0, !1)),
      (Tg[e] = Eg(e, !1, !0)),
      (_g[e] = Eg(e, !0, !0));
  });
  var qg = { get: Ag(!1, !1) },
    Cg = { get: Ag(!0, !1) };
  function Pg(e, t, i) {
    const s = Bg(i);
    if (s !== i && t.call(e, s)) {
      const t = Ff(e);
      console.warn(
        `Reactive ${t} contains both the raw and reactive versions of the same object${
          "Map" === t ? " as keys" : ""
        }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  var $g = new WeakMap(),
    Mg = new WeakMap(),
    Ig = new WeakMap(),
    Dg = new WeakMap();
  function Og(e) {
    return e && e.__v_isReadonly ? e : Fg(e, !1, lg, qg, $g);
  }
  function Hg(e) {
    return Fg(e, !0, cg, Cg, Ig);
  }
  function Fg(e, t, i, s, r) {
    if (!Df(e))
      return console.warn(`value cannot be made reactive: ${String(e)}`), e;
    if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
    const n = r.get(e);
    if (n) return n;
    const o =
      (a = e).__v_skip || !Object.isExtensible(a)
        ? 0
        : (function (e) {
            switch (e) {
              case "Object":
              case "Array":
                return 1;
              case "Map":
              case "Set":
              case "WeakMap":
              case "WeakSet":
                return 2;
              default:
                return 0;
            }
          })(Ff(a));
    var a;
    if (0 === o) return e;
    const l = new Proxy(e, 2 === o ? s : i);
    return r.set(e, l), l;
  }
  function Bg(e) {
    return (e && Bg(e.__v_raw)) || e;
  }
  function Wg(e) {
    return Boolean(e && !0 === e.__v_isRef);
  }
  om("nextTick", () => ef),
    om("dispatch", (e) => Hm.bind(Hm, e)),
    om("watch", (e, { evaluateLater: t, effect: i }) => (s, r) => {
      let n,
        o = t(s),
        a = !0,
        l = i(() =>
          o((e) => {
            JSON.stringify(e),
              a
                ? (n = e)
                : queueMicrotask(() => {
                    r(e, n), (n = e);
                  }),
              (a = !1);
          })
        );
      e._x_effects.delete(l);
    }),
    om("store", function () {
      return wf;
    }),
    om("data", (e) => Kp(e)),
    om("root", (e) => Jm(e)),
    om(
      "refs",
      (e) => (
        e._x_refs_proxy ||
          (e._x_refs_proxy = tm(
            (function (e) {
              let t = [],
                i = e;
              for (; i; ) i._x_refs && t.push(i._x_refs), (i = i.parentNode);
              return t;
            })(e)
          )),
        e._x_refs_proxy
      )
    );
  var Ng = {};
  function Rg(e) {
    return Ng[e] || (Ng[e] = 0), ++Ng[e];
  }
  function jg(e, t, i) {
    om(t, (t) =>
      Bm(
        `You can't use [$${directiveName}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`,
        t
      )
    );
  }
  om("id", (e) => (t, i = null) => {
    let s = (function (e, t) {
        return Gm(e, (e) => {
          if (e._x_ids && e._x_ids[t]) return !0;
        });
      })(e, t),
      r = s ? s._x_ids[t] : Rg(t);
    return i ? `${t}-${r}-${i}` : `${t}-${r}`;
  }),
    om("el", (e) => e),
    jg("Focus", "focus", "focus"),
    jg("Persist", "persist", "persist"),
    Sm(
      "modelable",
      (e, { expression: t }, { effect: i, evaluateLater: s, cleanup: r }) => {
        let n = s(t),
          o = () => {
            let e;
            return n((t) => (e = t)), e;
          },
          a = s(`${t} = __placeholder`),
          l = (e) => a(() => {}, { scope: { __placeholder: e } }),
          c = o();
        l(c),
          queueMicrotask(() => {
            if (!e._x_model) return;
            e._x_removeModelListeners.default();
            let t = e._x_model.get,
              i = e._x_model.set,
              s = (function ({ get: e, set: t }, { get: i, set: s }) {
                let r,
                  n,
                  o = !0,
                  a = kp(() => {
                    let a, l;
                    o
                      ? ((a = e()), s(a), (l = i()), (o = !1))
                      : ((a = e()),
                        (l = i()),
                        (n = JSON.stringify(a)),
                        JSON.stringify(l),
                        n !== r ? ((l = i()), s(a), (l = a)) : (t(l), (a = l))),
                      (r = JSON.stringify(a)),
                      JSON.stringify(l);
                  });
                return () => {
                  Tp(a);
                };
              })(
                {
                  get: () => t(),
                  set(e) {
                    i(e);
                  },
                },
                {
                  get: () => o(),
                  set(e) {
                    l(e);
                  },
                }
              );
            r(s);
          });
      }
    );
  var zg = document.createElement("div");
  Sm("teleport", (e, { modifiers: t, expression: i }, { cleanup: s }) => {
    "template" !== e.tagName.toLowerCase() &&
      Bm("x-teleport can only be used on a <template> tag", e);
    let r = uf(
      () => document.querySelector(i),
      () => zg
    )();
    r || Bm(`Cannot find x-teleport element for selector: "${i}"`);
    let n = e.content.cloneNode(!0).firstElementChild;
    (e._x_teleport = n),
      (n._x_teleportBack = e),
      e._x_forwardEvents &&
        e._x_forwardEvents.forEach((t) => {
          n.addEventListener(t, (t) => {
            t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t));
          });
        }),
      Zp(n, {}, e),
      Gp(() => {
        t.includes("prepend")
          ? r.parentNode.insertBefore(n, r)
          : t.includes("append")
          ? r.parentNode.insertBefore(n, r.nextSibling)
          : r.appendChild(n),
          Ym(n),
          (n._x_ignore = !0);
      }),
      s(() => n.remove());
  });
  var Vg = () => {};
  function Ug(e, t, i, s) {
    let r = e,
      n = (e) => s(e),
      o = {},
      a = (e, t) => (i) => t(e, i);
    if (
      (i.includes("dot") && (t = t.replace(/-/g, ".")),
      i.includes("camel") &&
        (t = (function (e) {
          return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
        })(t)),
      i.includes("passive") && (o.passive = !0),
      i.includes("capture") && (o.capture = !0),
      i.includes("window") && (r = window),
      i.includes("document") && (r = document),
      i.includes("debounce"))
    ) {
      let e = i[i.indexOf("debounce") + 1] || "invalid-wait",
        t = Jg(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
      n = vf(n, t);
    }
    if (i.includes("throttle")) {
      let e = i[i.indexOf("throttle") + 1] || "invalid-wait",
        t = Jg(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
      n = bf(n, t);
    }
    return (
      i.includes("prevent") &&
        (n = a(n, (e, t) => {
          t.preventDefault(), e(t);
        })),
      i.includes("stop") &&
        (n = a(n, (e, t) => {
          t.stopPropagation(), e(t);
        })),
      i.includes("self") &&
        (n = a(n, (t, i) => {
          i.target === e && t(i);
        })),
      (i.includes("away") || i.includes("outside")) &&
        ((r = document),
        (n = a(n, (t, i) => {
          e.contains(i.target) ||
            (!1 !== i.target.isConnected &&
              ((e.offsetWidth < 1 && e.offsetHeight < 1) ||
                (!1 !== e._x_isShown && t(i))));
        }))),
      i.includes("once") &&
        (n = a(n, (e, i) => {
          e(i), r.removeEventListener(t, n, o);
        })),
      (n = a(n, (e, s) => {
        ((function (e) {
          return ["keydown", "keyup"].includes(e);
        })(t) &&
          (function (e, t) {
            let i = t.filter(
              (e) =>
                ![
                  "window",
                  "document",
                  "prevent",
                  "stop",
                  "once",
                  "capture",
                ].includes(e)
            );
            if (i.includes("debounce")) {
              let e = i.indexOf("debounce");
              i.splice(
                e,
                Jg((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
              );
            }
            if (i.includes("throttle")) {
              let e = i.indexOf("throttle");
              i.splice(
                e,
                Jg((i[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
              );
            }
            if (0 === i.length) return !1;
            if (1 === i.length && Gg(e.key).includes(i[0])) return !1;
            const s = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter(
              (e) => i.includes(e)
            );
            if (((i = i.filter((e) => !s.includes(e))), s.length > 0)) {
              if (
                s.filter(
                  (t) => (
                    ("cmd" !== t && "super" !== t) || (t = "meta"), e[`${t}Key`]
                  )
                ).length === s.length &&
                Gg(e.key).includes(i[0])
              )
                return !1;
            }
            return !0;
          })(s, i)) ||
          e(s);
      })),
      r.addEventListener(t, n, o),
      () => {
        r.removeEventListener(t, n, o);
      }
    );
  }
  function Jg(e) {
    return !Array.isArray(e) && !isNaN(e);
  }
  function Gg(e) {
    if (!e) return [];
    var t;
    e = [" ", "_"].includes((t = e))
      ? t
      : t
          .replace(/([a-z])([A-Z])/g, "$1-$2")
          .replace(/[_\s]/, "-")
          .toLowerCase();
    let i = {
      ctrl: "control",
      slash: "/",
      space: " ",
      spacebar: " ",
      cmd: "meta",
      esc: "escape",
      up: "arrow-up",
      down: "arrow-down",
      left: "arrow-left",
      right: "arrow-right",
      period: ".",
      equal: "=",
      minus: "-",
      underscore: "_",
    };
    return (
      (i[e] = e),
      Object.keys(i)
        .map((t) => {
          if (i[t] === e) return t;
        })
        .filter((e) => e)
    );
  }
  function Qg(e) {
    let t = e ? parseFloat(e) : null;
    return (i = t), Array.isArray(i) || isNaN(i) ? e : t;
    var i;
  }
  function Yg(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "function" == typeof e.get &&
      "function" == typeof e.set
    );
  }
  (Vg.inline = (e, { modifiers: t }, { cleanup: i }) => {
    t.includes("self") ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
      i(() => {
        t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
      });
  }),
    Sm("ignore", Vg),
    Sm("effect", (e, { expression: t }, { effect: i }) => i(pm(e, t))),
    Sm(
      "model",
      (e, { modifiers: t, expression: i }, { effect: s, cleanup: r }) => {
        let n = e;
        t.includes("parent") && (n = e.parentNode);
        let o,
          a = pm(n, i);
        o =
          "string" == typeof i
            ? pm(n, `${i} = __placeholder`)
            : "function" == typeof i && "string" == typeof i()
            ? pm(n, `${i()} = __placeholder`)
            : () => {};
        let l = () => {
            let e;
            return a((t) => (e = t)), Yg(e) ? e.get() : e;
          },
          c = (e) => {
            let t;
            a((e) => (t = e)),
              Yg(t) ? t.set(e) : o(() => {}, { scope: { __placeholder: e } });
          };
        "string" == typeof i &&
          "radio" === e.type &&
          Gp(() => {
            e.hasAttribute("name") || e.setAttribute("name", i);
          });
        var h =
          "select" === e.tagName.toLowerCase() ||
          ["checkbox", "radio"].includes(e.type) ||
          t.includes("lazy")
            ? "change"
            : "input";
        let d = df
          ? () => {}
          : Ug(e, h, t, (i) => {
              c(
                (function (e, t, i, s) {
                  return Gp(() => {
                    if (i instanceof CustomEvent && void 0 !== i.detail)
                      return i.detail ?? i.target.value;
                    if ("checkbox" === e.type) {
                      if (Array.isArray(s)) {
                        let e = t.includes("number")
                          ? Qg(i.target.value)
                          : i.target.value;
                        return i.target.checked
                          ? s.concat([e])
                          : s.filter((t) => !(t == e));
                      }
                      return i.target.checked;
                    }
                    if ("select" === e.tagName.toLowerCase() && e.multiple)
                      return t.includes("number")
                        ? Array.from(i.target.selectedOptions).map((e) =>
                            Qg(e.value || e.text)
                          )
                        : Array.from(i.target.selectedOptions).map(
                            (e) => e.value || e.text
                          );
                    {
                      let e = i.target.value;
                      return t.includes("number")
                        ? Qg(e)
                        : t.includes("trim")
                        ? e.trim()
                        : e;
                    }
                  });
                })(e, t, i, l())
              );
            });
        if (
          (t.includes("fill") &&
            [null, ""].includes(l()) &&
            e.dispatchEvent(new Event(h, {})),
          e._x_removeModelListeners || (e._x_removeModelListeners = {}),
          (e._x_removeModelListeners.default = d),
          r(() => e._x_removeModelListeners.default()),
          e.form)
        ) {
          let t = Ug(e.form, "reset", [], (t) => {
            ef(() => e._x_model && e._x_model.set(e.value));
          });
          r(() => t());
        }
        (e._x_model = {
          get: () => l(),
          set(e) {
            c(e);
          },
        }),
          (e._x_forceModelUpdate = (t) => {
            void 0 === (t = void 0 === t ? l() : t) &&
              "string" == typeof i &&
              i.match(/\./) &&
              (t = ""),
              (window.fromModel = !0),
              Gp(() => pf(e, "value", t)),
              delete window.fromModel;
          }),
          s(() => {
            let i = l();
            (t.includes("unintrusive") &&
              document.activeElement.isSameNode(e)) ||
              e._x_forceModelUpdate(i);
          });
      }
    ),
    Sm("cloak", (e) =>
      queueMicrotask(() => Gp(() => e.removeAttribute(bm("cloak"))))
    ),
    Um(() => `[${bm("init")}]`),
    Sm(
      "init",
      uf((e, { expression: t }, { evaluate: i }) =>
        "string" == typeof t ? !!t.trim() && i(t, {}, !1) : i(t, {}, !1)
      )
    ),
    Sm("text", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
      let r = s(t);
      i(() => {
        r((t) => {
          Gp(() => {
            e.textContent = t;
          });
        });
      });
    }),
    Sm("html", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
      let r = s(t);
      i(() => {
        r((t) => {
          Gp(() => {
            (e.innerHTML = t),
              (e._x_ignoreSelf = !0),
              Ym(e),
              delete e._x_ignoreSelf;
          });
        });
      });
    }),
    Pm(Am(":", bm("bind:")));
  var Xg = (
    e,
    { value: t, modifiers: i, expression: s, original: r },
    { effect: n }
  ) => {
    if (!t) {
      let t = {};
      return (
        (o = t),
        Object.entries(Ef).forEach(([e, t]) => {
          Object.defineProperty(o, e, {
            get:
              () =>
              (...e) =>
                t(...e),
          });
        }),
        void pm(e, s)(
          (t) => {
            Lf(e, t, r);
          },
          { scope: t }
        )
      );
    }
    var o;
    if ("key" === t)
      return (function (e, t) {
        e._x_keyExpression = t;
      })(e, s);
    if (
      e._x_inlineBindings &&
      e._x_inlineBindings[t] &&
      e._x_inlineBindings[t].extract
    )
      return;
    let a = pm(e, s);
    n(() =>
      a((r) => {
        void 0 === r && "string" == typeof s && s.match(/\./) && (r = ""),
          Gp(() => pf(e, t, r, i));
      })
    );
  };
  function Kg(e, t, i, s) {
    let r = {};
    if (/^\[.*\]$/.test(e.item) && Array.isArray(t)) {
      e.item
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map((e) => e.trim())
        .forEach((e, i) => {
          r[e] = t[i];
        });
    } else if (
      /^\{.*\}$/.test(e.item) &&
      !Array.isArray(t) &&
      "object" == typeof t
    ) {
      e.item
        .replace("{", "")
        .replace("}", "")
        .split(",")
        .map((e) => e.trim())
        .forEach((e) => {
          r[e] = t[e];
        });
    } else r[e.item] = t;
    return (
      e.index && (r[e.index] = i), e.collection && (r[e.collection] = s), r
    );
  }
  function Zg() {}
  function ey(e, t, i) {
    Sm(t, (s) =>
      Bm(
        `You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`,
        s
      )
    );
  }
  (Xg.inline = (e, { value: t, modifiers: i, expression: s }) => {
    t &&
      (e._x_inlineBindings || (e._x_inlineBindings = {}),
      (e._x_inlineBindings[t] = { expression: s, extract: !1 }));
  }),
    Sm("bind", Xg),
    Vm(() => `[${bm("data")}]`),
    Sm(
      "data",
      uf((e, { expression: t }, { cleanup: i }) => {
        t = "" === t ? "{}" : t;
        let s = {};
        am(s, e);
        let r = {};
        var n, o;
        (n = r),
          (o = s),
          Object.entries(kf).forEach(([e, t]) => {
            Object.defineProperty(n, e, {
              get:
                () =>
                (...e) =>
                  t.bind(o)(...e),
              enumerable: !1,
            });
          });
        let a = um(e, t, { scope: r });
        (void 0 !== a && !0 !== a) || (a = {}), am(a, e);
        let l = Lp(a);
        im(l);
        let c = Zp(e, l);
        l.init && um(e, l.init),
          i(() => {
            l.destroy && um(e, l.destroy), c();
          });
      })
    ),
    Sm("show", (e, { modifiers: t, expression: i }, { effect: s }) => {
      let r = pm(e, i);
      e._x_doHide ||
        (e._x_doHide = () => {
          Gp(() => {
            e.style.setProperty(
              "display",
              "none",
              t.includes("important") ? "important" : void 0
            );
          });
        }),
        e._x_doShow ||
          (e._x_doShow = () => {
            Gp(() => {
              1 === e.style.length && "none" === e.style.display
                ? e.removeAttribute("style")
                : e.style.removeProperty("display");
            });
          });
      let n,
        o = () => {
          e._x_doHide(), (e._x_isShown = !1);
        },
        a = () => {
          e._x_doShow(), (e._x_isShown = !0);
        },
        l = () => setTimeout(a),
        c = of(
          (e) => (e ? a() : o()),
          (t) => {
            "function" == typeof e._x_toggleAndCascadeWithTransitions
              ? e._x_toggleAndCascadeWithTransitions(e, t, a, o)
              : t
              ? l()
              : o();
          }
        ),
        h = !0;
      s(() =>
        r((e) => {
          (h || e !== n) &&
            (t.includes("immediate") && (e ? l() : o()),
            c(e),
            (n = e),
            (h = !1));
        })
      );
    }),
    Sm("for", (e, { expression: t }, { effect: i, cleanup: s }) => {
      let r = (function (e) {
          let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
            i = /^\s*\(|\)\s*$/g,
            s = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
            r = e.match(s);
          if (!r) return;
          let n = {};
          n.items = r[2].trim();
          let o = r[1].replace(i, "").trim(),
            a = o.match(t);
          a
            ? ((n.item = o.replace(t, "").trim()),
              (n.index = a[1].trim()),
              a[2] && (n.collection = a[2].trim()))
            : (n.item = o);
          return n;
        })(t),
        n = pm(e, r.items),
        o = pm(e, e._x_keyExpression || "index");
      (e._x_prevKeys = []),
        (e._x_lookup = {}),
        i(() =>
          (function (e, t, i, s) {
            let r = (e) => "object" == typeof e && !Array.isArray(e),
              n = e;
            i((i) => {
              var o;
              (o = i),
                !Array.isArray(o) &&
                  !isNaN(o) &&
                  i >= 0 &&
                  (i = Array.from(Array(i).keys(), (e) => e + 1)),
                void 0 === i && (i = []);
              let a = e._x_lookup,
                l = e._x_prevKeys,
                c = [],
                h = [];
              if (r(i))
                i = Object.entries(i).map(([e, r]) => {
                  let n = Kg(t, r, e, i);
                  s((e) => h.push(e), { scope: { index: e, ...n } }), c.push(n);
                });
              else
                for (let e = 0; e < i.length; e++) {
                  let r = Kg(t, i[e], e, i);
                  s((e) => h.push(e), { scope: { index: e, ...r } }), c.push(r);
                }
              let d = [],
                u = [],
                p = [],
                m = [];
              for (let e = 0; e < l.length; e++) {
                let t = l[e];
                -1 === h.indexOf(t) && p.push(t);
              }
              l = l.filter((e) => !p.includes(e));
              let f = "template";
              for (let e = 0; e < h.length; e++) {
                let t = h[e],
                  i = l.indexOf(t);
                if (-1 === i) l.splice(e, 0, t), d.push([f, e]);
                else if (i !== e) {
                  let t = l.splice(e, 1)[0],
                    s = l.splice(i - 1, 1)[0];
                  l.splice(e, 0, s), l.splice(i, 0, t), u.push([t, s]);
                } else m.push(t);
                f = t;
              }
              for (let e = 0; e < p.length; e++) {
                let t = p[e];
                a[t]._x_effects && a[t]._x_effects.forEach(Mp),
                  a[t].remove(),
                  (a[t] = null),
                  delete a[t];
              }
              for (let e = 0; e < u.length; e++) {
                let [t, i] = u[e],
                  s = a[t],
                  r = a[i],
                  o = document.createElement("div");
                Gp(() => {
                  r || Bm('x-for ":key" is undefined or invalid', n),
                    r.after(o),
                    s.after(r),
                    r._x_currentIfEl && r.after(r._x_currentIfEl),
                    o.before(s),
                    s._x_currentIfEl && s.after(s._x_currentIfEl),
                    o.remove();
                }),
                  r._x_refreshXForScope(c[h.indexOf(i)]);
              }
              for (let e = 0; e < d.length; e++) {
                let [t, i] = d[e],
                  s = "template" === t ? n : a[t];
                s._x_currentIfEl && (s = s._x_currentIfEl);
                let r = c[i],
                  o = h[i],
                  l = document.importNode(n.content, !0).firstElementChild,
                  u = Lp(r);
                Zp(l, u, n),
                  (l._x_refreshXForScope = (e) => {
                    Object.entries(e).forEach(([e, t]) => {
                      u[e] = t;
                    });
                  }),
                  Gp(() => {
                    s.after(l), Ym(l);
                  }),
                  "object" == typeof o &&
                    Bm(
                      "x-for key cannot be an object, it must be a string or an integer",
                      n
                    ),
                  (a[o] = l);
              }
              for (let e = 0; e < m.length; e++)
                a[m[e]]._x_refreshXForScope(c[h.indexOf(m[e])]);
              n._x_prevKeys = h;
            });
          })(e, r, n, o)
        ),
        s(() => {
          Object.values(e._x_lookup).forEach((e) => e.remove()),
            delete e._x_prevKeys,
            delete e._x_lookup;
        });
    }),
    (Zg.inline = (e, { expression: t }, { cleanup: i }) => {
      let s = Jm(e);
      s._x_refs || (s._x_refs = {}),
        (s._x_refs[t] = e),
        i(() => delete s._x_refs[t]);
    }),
    Sm("ref", Zg),
    Sm("if", (e, { expression: t }, { effect: i, cleanup: s }) => {
      let r = pm(e, t);
      i(() =>
        r((t) => {
          t
            ? (() => {
                if (e._x_currentIfEl) return e._x_currentIfEl;
                let t = e.content.cloneNode(!0).firstElementChild;
                Zp(t, {}, e),
                  Gp(() => {
                    e.after(t), Ym(t);
                  }),
                  (e._x_currentIfEl = t),
                  (e._x_undoIf = () => {
                    Fm(t, (e) => {
                      e._x_effects && e._x_effects.forEach(Mp);
                    }),
                      t.remove(),
                      delete e._x_currentIfEl;
                  });
              })()
            : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
        })
      ),
        s(() => e._x_undoIf && e._x_undoIf());
    }),
    Sm("id", (e, { expression: t }, { evaluate: i }) => {
      i(t).forEach((t) =>
        (function (e, t) {
          e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = Rg(t));
        })(e, t)
      );
    }),
    Pm(Am("@", bm("on:"))),
    Sm(
      "on",
      uf((e, { value: t, modifiers: i, expression: s }, { cleanup: r }) => {
        let n = s ? pm(e, s) : () => {};
        "template" === e.tagName.toLowerCase() &&
          (e._x_forwardEvents || (e._x_forwardEvents = []),
          e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
        let o = Ug(e, t, i, (e) => {
          n(() => {}, { scope: { $event: e }, params: [e] });
        });
        r(() => o());
      })
    ),
    ey("Collapse", "collapse", "collapse"),
    ey("Intersect", "intersect", "intersect"),
    ey("Focus", "trap", "focus"),
    ey("Mask", "mask", "mask"),
    Tf.setEvaluator(fm),
    Tf.setReactivityEngine({
      reactive: Og,
      effect: function (e, t = _f) {
        (function (e) {
          return e && !0 === e._isEffect;
        })(e) && (e = e.raw);
        const i = (function (e, t) {
          const i = function () {
            if (!i.active) return e();
            if (!jf.includes(i)) {
              Jf(i);
              try {
                return Qf.push(Gf), (Gf = !0), jf.push(i), (Af = i), e();
              } finally {
                jf.pop(), Yf(), (Af = jf[jf.length - 1]);
              }
            }
          };
          return (
            (i.id = Uf++),
            (i.allowRecurse = !!t.allowRecurse),
            (i._isEffect = !0),
            (i.active = !0),
            (i.raw = e),
            (i.deps = []),
            (i.options = t),
            i
          );
        })(e, t);
        return t.lazy || i(), i;
      },
      release: function (e) {
        e.active &&
          (Jf(e), e.options.onStop && e.options.onStop(), (e.active = !1));
      },
      raw: Bg,
    });
  var ty = Tf;
  const iy = "[data-announcement-bar]",
    sy = "[data-ticker-frame]",
    ry = "[data-ticker-scale]",
    ny = "[data-ticker-text]",
    oy = "is-selected",
    ay = "ticker--animated";
  const ly = 0,
    cy = 1,
    hy = 2,
    dy = 3,
    uy = "[data-product-add-popdown-wrapper]",
    py = "[data-add-action-errors]",
    my = "[data-error-boundary]",
    fy = "[data-error-display]",
    gy = "[data-quickview-modal]",
    yy = "[data-cart-page-upsell-wrapper]",
    vy = '[data-section-type="cart"]',
    by = '[data-ajax-disable="true"]',
    wy = { durationAddButtonDisable: 3500, hideErrorTime: 5e3 };
  const Sy = 0,
    Ey = 1,
    Ly = "data-quickview-holder",
    ky = "[data-product-quickview-ajax]",
    Ty = "[data-quickview-modal]",
    xy = "[data-drawer-scrolls]",
    _y = "[data-quickview-modal-template]",
    Ay = "[data-quickview-head]",
    qy = "[data-quickview-form-area]",
    Cy = "[data-toggle-button]",
    Py = "[data-media-slide]",
    $y = "[data-media-id]",
    My = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Iy = "hide",
    Dy = "is-active",
    Oy = "is-expanded",
    Hy = "loading",
    Fy = 250,
    By = 400;
  function Wy() {
    return {
      isOpen: !1,
      get isClosed() {
        return !this.isOpen;
      },
      toggle() {
        if (this.isOpen) return this.close();
        this.open();
      },
      open() {
        this.isOpen = !0;
      },
      close() {
        this.isOpen && (this.isOpen = !1);
      },
    };
  }
  const Ny = '[role="tablist"]',
    Ry = '[role="tab"]';
  ty.data("announcement", function () {
    new Bd(this.$el);
  }),
    ty.data("announcementSlider", function (e = 4e3) {
      return {
        options: {
          initialIndex: 0,
          autoPlay: e,
          contain: !0,
          pageDots: !1,
          adaptiveHeight: !0,
          wrapAround: !0,
          groupCells: !1,
          cellAlign: "left",
          freeScroll: !1,
          prevNextButtons: !0,
          draggable: !0,
          rightToLeft: window.isRTL,
          on: {
            ready: () => {
              setTimeout(() => {
                this.$el.dispatchEvent(
                  new CustomEvent("theme:announcement:loaded", {
                    bubbles: !0,
                    detail: { slider: this.$el },
                  })
                );
              }, 50);
            },
          },
        },
        flkty: null,
        desktopSlides: [],
        mobileSlides: [],
        isMobileSliderInitialized: !1,
        init() {
          this.$nextTick(() => {
            this.$el.children.length < 2 ||
              ((this.flkty = new s(this.$el, this.options)),
              this.removeDeviceSpecificSlides(),
              Ce.onChange(() => {
                this.updateDeviceSpecificSlides();
              }),
              (this.scrollEvent = () => this.scrollEvents()),
              (this.resizeEvent = () => this.resizeEvents()),
              document.addEventListener("theme:resize", this.resizeEvent),
              document.addEventListener("theme:scroll", this.scrollEvent));
          });
        },
        removeDeviceSpecificSlides() {
          this.flkty.getCellElements().forEach((e, t) => {
            e.classList.remove(oy),
              "desktop" == e.dataset.device &&
                (this.desktopSlides.push([e, t]),
                Ce.isMobile() && this.flkty.remove(e)),
              "mobile" == e.dataset.device &&
                (this.mobileSlides.push([e, t]),
                (Ce.isDesktop() || Ce.isTablet()) && this.flkty.remove(e));
          }),
            setTimeout(() => {
              this.flkty.resize();
            }, 1e3),
            this.handleSliderAutoplay(),
            (this.isMobileSliderInitialized = Ce.isMobile());
        },
        updateDeviceSpecificSlides() {
          (Ce.isDesktop() || Ce.isTablet()) &&
            this.isMobileSliderInitialized &&
            (this.desktopSlides.forEach((e) => {
              this.flkty.insert(e[0], e[1]);
            }),
            this.mobileSlides.forEach((e) => {
              this.flkty.remove(e[0]);
            })),
            Ce.isMobile() &&
              (this.isMobileSliderInitialized ||
                (this.mobileSlides.forEach((e) => {
                  this.flkty.insert(e[0], e[1]);
                }),
                this.desktopSlides.forEach((e) => {
                  this.flkty.remove(e[0]);
                }))),
            setTimeout(() => {
              this.flkty.resize();
            }, 1e3),
            this.handleSliderAutoplay(),
            (this.isMobileSliderInitialized = Ce.isMobile());
        },
        handleSliderAutoplay() {
          this.flkty?.slides.length > 1
            ? this.flkty.playPlayer()
            : this.flkty.pausePlayer();
        },
        resizeEvents() {
          this.flkty.resize();
        },
        scrollEvents() {
          if (!this.flkty.options.autoPlay) return;
          const e = this.flkty.element,
            t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
          window.pageYOffset > t
            ? "playing" === this.flkty.player.state && this.flkty.pausePlayer()
            : "paused" === this.flkty.player.state && this.flkty.playPlayer();
        },
        onBlockSelect(e) {
          const t = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
          if (!t) return;
          const i = parseInt([...t.parentNode.children].indexOf(t));
          this.flkty.selectCell(i), this.flkty.stopPlayer();
        },
        onBlockDeselect() {
          this.flkty.playPlayer();
        },
        onUnload() {
          (this.flkty.options.watchCSS = !1), this.flkty.destroy();
        },
      };
    }),
    ty.data(
      "announcementTicker",
      function (e = { stopClone: !1, waitForSlider: !1 }) {
        return {
          tickerFrames: this.$el.closest(iy)?.querySelectorAll(sy),
          init() {
            e?.waitForSlider && this.tickerFrames?.length > 1
              ? document.addEventListener(
                  "theme:announcement:loaded",
                  this.initTicker.bind(this)
                )
              : this.initTicker();
          },
          initTicker() {
            new Ji(this.$el, e?.stopClone);
          },
          toggleTicker(e, t) {
            const i = this.$el.querySelector(ry),
              s = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
            if (s && null !== s.offsetParent) {
              if (t) {
                const e = Number(
                    getComputedStyle(s)
                      .getPropertyValue("--items-spacing")
                      .replace("px", "")
                  ),
                  t = -(s.offsetLeft + e);
                i.setAttribute("data-stop", ""),
                  i.querySelectorAll(ny).forEach((e) => {
                    e.classList.remove(ay),
                      (e.style.transform = `translate3d(${t}px, 0, 0)`);
                  });
              }
              t ||
                (i.querySelectorAll(ny).forEach((e) => {
                  e.classList.add(ay), e.removeAttribute("style");
                }),
                i.removeAttribute("data-stop"));
            }
          },
          onBlockSelect(e) {
            this.toggleTicker(e, !0);
          },
          onBlockDeselect(e) {
            this.toggleTicker(e, !1);
          },
        };
      }
    ),
    ty.data("productAddButtonForm", function (e = {}) {
      const t = { ...wy, ...e.times };
      return {
        state: ly,
        error: "",
        isUpsell: !1,
        isInCartPage: !1,
        get cartPageUpsellWrapper() {
          return this.$el.closest(yy);
        },
        get sectionTypeCart() {
          return this.$el.closest(vy);
        },
        get form() {
          return this.isUpsell && this.isInCartPage
            ? this.$el.closest("form")
            : this.$el.querySelector("form");
        },
        get button() {
          return this.$el.querySelector("button");
        },
        get popdown() {
          return document.querySelector(uy);
        },
        get errorDisplay() {
          let e = this.$el.querySelector(py);
          if (!e) {
            const t = this.$el.closest(my);
            t && (e = t.querySelector(fy));
          }
          return e || (e = this.$el.querySelector(fy)), e;
        },
        get quickViewModal() {
          return this.$el.closest(gy);
        },
        get isInitial() {
          return this.state === ly;
        },
        get isLoading() {
          return this.state === cy;
        },
        get isSuccess() {
          return this.state === hy;
        },
        get isError() {
          return this.state === dy;
        },
        get isDisabled() {
          return this.isLoading;
        },
        get isAjaxDisabled() {
          return !!this.$el.closest(by);
        },
        get isInsideQuickViewModal() {
          return Boolean(this.quickViewModal);
        },
        handleClickAddButton(e) {
          e.preventDefault(), (this.state = cy);
          const t = new FormData(this.form);
          this.addToCart(t)
            .then(this.handleSuccess.bind(this))
            .catch(this.handleError.bind(this));
        },
        handleSuccess(e) {
          const i = e.data;
          (this.state = hy),
            this.updateHeaderTotal(),
            setTimeout(() => {
              this.state = ly;
            }, t.durationAddButtonDisable),
            this.isInsideQuickViewModal && this.closeQuickView(),
            window.theme.state.cartOpen ||
            this.isInCartPage ||
            this.isOnCartPage
              ? this.reloadCart()
              : this.openPopdown(i);
        },
        handleError(e) {
          if (!e?.data) throw e;
          if (
            ((this.state = dy),
            e.data.description && "string" == typeof e.data.description
              ? (this.error = e.data.description)
              : e.data.message && "string" == typeof e.data.message
              ? (this.error = e.data.message)
              : e.data.description && "object" == typeof e.data.description
              ? (this.error = Object.keys(e.data.description)
                  .map((t) => `${t}: ${e.data.description[t]}`)
                  .join("<br>"))
              : (this.error = "Network error: please try again"),
            this.errorDisplay)
          ) {
            const e = `<div class="errors">${this.error}</div>`;
            (this.errorDisplay.innerHTML = e),
              rn(this.errorDisplay),
              setTimeout(() => {
                nn(this.errorDisplay);
              }, t.hideErrorTime);
          }
        },
        addToCart(e) {
          const t = `${window.theme.routes.cart}/add.js`,
            i = new URLSearchParams(e).toString();
          return l.post(t, i, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
        },
        updateHeaderTotal: () =>
          l
            .get(`${window.theme.routes.cart}.js`)
            .then((e) => {
              document.dispatchEvent(
                new CustomEvent("theme:cart:change", {
                  detail: { cart: e.data },
                  bubbles: !0,
                })
              );
            })
            .catch((e) => {
              console.error(e);
            }),
        closeQuickView() {
          this.quickViewModal.dispatchEvent(
            new CustomEvent("theme:quickview:close")
          );
        },
        reloadCart() {
          document.dispatchEvent(
            new CustomEvent("theme:cart:reload", { bubbles: !0 })
          );
        },
        openPopdown(e) {
          // handleFloCartBtn();
            this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown",{detail:{variant:e},bubbles:!0})
                                    )
        },
        get isInCartPage() {
          return Boolean(this.sectionTypeCart);
        },
        get isOnCartPage() {
          return Boolean(document.body.querySelector(vy));
        },
        get isUpsell() {
          return Boolean(this.cartPageUpsellWrapper);
        },
        init() {
          this.button.addEventListener(
            "click",
            this.handleClickAddButton.bind(this)
          );
        },
      };
    }),
    ty.data("productQuickViewButton", function (e, t) {
      return {
        state: Sy,
        get quickviewHolder() {
          return this.$el.querySelector(`[${Ly}]`);
        },
        get isInitial() {
          return this.state === Sy;
        },
        get isLoading() {
          return this.state === Ey;
        },
        get isDisabled() {
          return this.isLoading;
        },
        clickQuickviewButton(e) {
          this.modal && this.modalID && (this.modal.id = this.modalID),
            document.documentElement.hasAttribute("data-scroll-locked") &&
              (this.scrollLockEnable = !1),
            (this.state = Ey),
            this.getQuickviewHTML();
        },
        getQuickviewHTML() {
          window
            .fetch(
              `${window.theme.routes.root_url}products/${t}?section_id=api-product-quickview`
            )
            .then(this.handleErrors)
            .then((e) => e.text())
            .then((e) => {
              const t = document.createElement("div");
              (t.innerHTML = e),
                (this.modalContent = this.modal.querySelector(ky)),
                (this.modalContent.innerHTML =
                  t.querySelector("[data-api-content]").innerHTML),
                (this.modalScroll = this.modal.querySelector(xy));
              const i = this.modalContent.querySelector($y);
              if (i) {
                const e = document.createElement("div");
                (e.innerHTML = i.parentElement.innerHTML),
                  this.quickviewHolder.dispatchEvent(
                    new CustomEvent("theme:quickview:media", {
                      bubbles: !0,
                      detail: { media: e },
                    })
                  );
              }
              const s = { container: this.modalContent };
              (this.media = new hl(s)), this.modalCreate(), (this.state = Sy);
            });
        },
        modalCreate() {
          n.show(this.modalID, {
            onShow: (e, t, i) => {
              (this.quickviewHead = e.querySelector(Ay)),
                (this.quickviewFormArea = e.querySelector(qy)),
                (this.toggleButton = e.querySelector(Cy)),
                this.toggleForm("loading"),
                document.addEventListener(
                  "theme:resize",
                  Ea(() => {
                    this.toggleForm("resize");
                  }, 500)
                ),
                this.clickEventToggleForm();
              const s = e.querySelector(My);
              Ti(e, { elementToFocus: s }),
                this.modal.addEventListener(
                  "theme:quickview:close",
                  this.modalClose
                ),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: this.modalScroll,
                  })
                ),
                new bh(this.modal);
            },
            onClose: (e, t, i) => {
              this.media.destroy();
              e.querySelectorAll(Py).forEach((e) => {
                e.dispatchEvent(new CustomEvent("pause"));
              }),
                xi(),
                t.focus(),
                this.modal.removeEventListener(
                  "theme:quickview:close",
                  this.modalClose
                ),
                this.scrollLockEnable
                  ? document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    )
                  : (this.scrollLockEnable = !0);
            },
          });
        },
        modalClose() {
          n.close(this.modalID);
        },
        handleErrors: (e) =>
          e.ok
            ? e
            : e.json().then(function (t) {
                throw new Z({
                  status: e.statusText,
                  headers: e.headers,
                  json: t,
                });
              }),
        toggleForm(e) {
          (this.windowH === window.innerHeight && "resize" === e) ||
            (this.toggleButton.classList.contains(Iy) ||
              this.toggleButton.classList.add(Iy),
            this.quickviewFormArea.classList.contains(Oy) ||
              this.quickviewFormArea.classList.add(Oy),
            "resize" === e &&
              (this.quickviewFormArea.classList.add(Oy),
              this.toggleButton.classList.add(Iy),
              (this.windowH = window.innerHeight)),
            setTimeout(() => {
              const t =
                  window.innerHeight -
                  this.quickviewHead.offsetHeight -
                  this.quickviewFormArea.offsetHeight,
                i = t < Fy;
              (t < By && t > Fy) || i
                ? (this.toggleButton.classList.remove(Iy),
                  this.toggleButton.classList.add(Dy))
                : this.toggleButton.classList.add(Iy),
                i
                  ? ("loading" === e &&
                      (this.quickviewFormArea.classList.add(Hy),
                      setTimeout(() => {
                        this.quickviewFormArea.classList.remove(Hy);
                      }, 50)),
                    this.quickviewFormArea.classList.remove(Oy),
                    this.toggleButton.classList.remove(Dy))
                  : this.quickviewFormArea.classList.add(Oy);
            }, 200));
        },
        clickEventToggleForm() {
          this.toggleButton &&
            this.toggleButton.addEventListener("click", () => {
              this.toggleButton.classList.toggle(Dy),
                this.quickviewFormArea.classList.toggle(Oy);
            });
        },
        init() {
          if (
            this.quickviewHolder &&
            ((this.modalTemplate = this.quickviewHolder.querySelector(_y)),
            (this.modal = document.querySelector(Ty)),
            (this.modalID = this.quickviewHolder.getAttribute(Ly)),
            (this.modalContent = null),
            (this.modalScroll = null),
            (this.scrollLockEnable = !0),
            (this.windowH = window.innerHeight),
            this.modalTemplate && !this.modal)
          ) {
            const e = this.modalTemplate.innerHTML,
              t = document.createElement("div");
            (t.innerHTML = e),
              (this.modalHtml = t.querySelector(Ty)),
              document.body.appendChild(this.modalHtml),
              (this.modal = document.querySelector(Ty));
          }
        },
      };
    }),
    ty.data("productGridItemQuickAddMenu", function () {
      return (function (...e) {
        return e.reduce(
          (e, t) => {
            const i = "function" == typeof t ? t() : t;
            return (
              i.init && e._initializers.push(i.init),
              delete i.init,
              Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
            );
          },
          {
            _initializers: [],
            init() {
              this._initializers.forEach((e) => e.call(this));
            },
          }
        );
      })(Wy(), {
        controller: null,
        init() {
          this.$watch("isOpen", (e) => {
            e ? this.listen() : this.unlisten();
          });
        },
        listen() {
          (this.controller = new AbortController()),
            this.$el.addEventListener(
              "mouseleave",
              () => {
                this.close();
              },
              { signal: this.controller.signal }
            ),
            document.addEventListener(
              "click",
              (e) => {
                this.$el.contains(e.target) ||
                  (!1 !== this.$el._x_isShown && this.close());
              },
              { signal: this.controller.signal }
            ),
            document.addEventListener(
              "focusin",
              (e) => {
                this.$el.contains(e.target) || this.close();
              },
              { signal: this.controller.signal }
            ),
            document.addEventListener(
              "keydown",
              (e) => {
                "Escape" === e.key && this.close();
              },
              { signal: this.controller.signal }
            );
        },
        unlisten() {
          this.controller.abort(), (this.controller = null);
        },
      });
    }),
    ty.data("toggle", Wy),
    ty.data("tabs", function (e = 0) {
      return {
        selectedIndex: null,
        init() {
          this.$nextTick(() => this.select(e));
        },
        get tablist() {
          return this.$el.querySelector(Ny);
        },
        get tabs() {
          return this.tablist?.querySelectorAll(Ry);
        },
        getTab(e) {
          return this.tabs?.[e];
        },
        isSelected(e) {
          return this.selectedIndex === e;
        },
        select(e, t = !0) {
          this.selectedIndex = e;
          const i = this.getTab(e);
          i &&
            t &&
            this.tablist.scrollTo({
              top: 0,
              left: i.offsetLeft - i.clientWidth,
              behavior: "smooth",
            });
        },
        bindTabs: { "x-id": "['tab', 'tab-panel']" },
        bindTablist: {
          ":role": "'tablist'",
          "@keydown.right.prevent.stop": "$focus.wrap().next()",
          "@keydown.home.prevent.stop": "$focus.first()",
          "@keydown.page-up.prevent.stop": "$focus.first()",
          "@keydown.left.prevent.stop": "$focus.wrap().prev()",
          "@keydown.end.prevent.stop": "$focus.last()",
          "@keydown.page-down.prevent.stop": "$focus.last()",
        },
        bindTabpanels: {},
        bindTab: (e) => ({
          ":id": `$id('tab', ${e + 1})`,
          ":role": "'tab'",
          "@click": `select(${e})`,
          "@mousedown.prevent": "",
          "@focus": `select(${e})`,
          ":tabindex": `isSelected(${e}) ? 0 : -1`,
          ":aria-selected": `isSelected(${e})`,
          ":aria-controls": `$id('tab-panel', ${e + 1})`,
        }),
        bindTabpanel: (e) => ({
          ":id": `$id('tab-panel', ${e + 1})`,
          ":role": "'tabpanel'",
          "x-show": `isSelected(${e})`,
          ":aria-labelledby": `$id('tab', ${e + 1})`,
        }),
      };
    }),
    ty.data("overflow", function (e = {}) {
      const t = { top: 0, right: 0, bottom: 0, left: 0, ...e.inset };
      return {
        get overflowContainer() {
          return this.$refs.overflowContainer;
        },
        isOverflowing: { top: !1, bottom: !1, left: !1, right: !1 },
        checkOverflow() {
          const e =
              this.overflowContainer.scrollHeight -
              this.overflowContainer.scrollTop -
              t.bottom,
            i =
              this.overflowContainer.scrollWidth -
              this.overflowContainer.scrollLeft -
              t.right;
          (this.isOverflowing.top =
            this.overflowContainer.scrollTop - t.top > 0),
            (this.isOverflowing.bottom =
              e > this.overflowContainer.clientHeight),
            (this.isOverflowing.left =
              this.overflowContainer.scrollLeft - t.left > 0),
            (this.isOverflowing.right = i > this.overflowContainer.clientWidth);
        },
        scrollTo(e) {
          this.overflowContainer.scrollTo(e);
        },
      };
    }),
    ty.magic("nudge", function (e) {
      return (e, { left: t, top: i, ...s }) => {
        e.scrollTo({
          ...(t && {
            left: Math.max(Math.min(e.scrollLeft + t, e.scrollWidth), 0),
          }),
          ...(i && {
            left: Math.max(Math.min(e.scrollTop + i, e.scrollHeight), 0),
          }),
          ...s,
        });
      };
    }),
    ty.directive(
      "hold",
      (e, { modifiers: t, expression: i }, { cleanup: s, evaluate: r }) => {
        let n = null,
          o = t[0] || "",
          a = Number.isInteger(o.split("ms")[0])
            ? Number(o.split("ms")[0])
            : 25;
        const l = () => {
            n = setInterval(() => {
              r(i);
            }, a);
          },
          c = () => {
            clearInterval(n);
          };
        e.addEventListener("mousedown", l),
          e.addEventListener("mouseup", c),
          e.addEventListener("mouseleave", c),
          e.addEventListener("touchstart", l),
          e.addEventListener("touchend", c),
          s(() => {
            e.removeEventListener("mousedown", l),
              e.removeEventListener("mouseup", c),
              e.removeEventListener("mouseleave", c),
              e.removeEventListener("touchstart", l),
              e.removeEventListener("touchend", c);
          });
      }
    ),
    ty.directive("target-referrer", (e, { expression: t }) => {
      t &&
        (-1 !== document.referrer.indexOf(t) ||
          window.Shopify.designMode ||
          e.parentNode.removeChild(e));
    }),
    ty.plugin(_p),
    ty.start(),
    (window.Alpine = ty);
})(
  themeVendor.AOS,
  themeVendor.FlickityFade,
  themeVendor.ScrollLock,
  themeVendor.Flickity,
  themeVendor.Sqrl,
  themeVendor.MicroModal,
  themeVendor.Rellax,
  themeVendor.themeCurrency,
  themeVendor.axios,
  themeVendor.FlickitySync,
  themeVendor.themeAddresses
);



document.addEventListener("DOMContentLoaded", function () {
    // Check if the current URL contains "account-login"
  
    if (window.location.pathname.includes("login")) {
        let referrerUrl = document.referrer; // Get previous page URL
        console.log("here");
        // Ensure the referrer is not empty
        if (referrerUrl) {
          let currentUrl = new URL(window.location.href);
            let searchParams = currentUrl.searchParams;

            // Update or add return_url parameter
            searchParams.set("return_url", referrerUrl);

            // Replace URL without reloading
            let newUrl = currentUrl.origin + currentUrl.pathname + "?" + searchParams.toString();
            window.history.replaceState(null, "", newUrl);
            let backUrlInput = document.querySelector('[name="return_url"]');
            if (backUrlInput) {
                backUrlInput.value = referrerUrl; // Update input field with referrer URL
            }
        }
    }
});



async function updateCart() {
 // const cart = await fetch("/cart.js").then((res) => res.json());

  //document.querySelector(".cart-count-bubble span").textContent = cart.item_count;
}
// function updateMiniCart() {
//       fetch('/cart.js')
//         .then(response => response.json())
//         .then(data => {
//           console.log("Cart updated:", data);
//           // Check if your theme has a built-in cart drawer update function
//           if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cartDrawer) {
//             window.Shopify.theme.cartDrawer.open(); // Opens and refreshes cart drawer
//           } else {
//             // If no built-in function, manually refresh the mini cart
//             //document.querySelector('.cart-notification').classList.add('active'); // Open drawer
            
//             //document.querySelector('.cart-count').textContent = data.item_count; // Update item count
//             refreshCartContents(); // Re-render mini cart
//           }
//         });
//     }

//     function refreshCartContents() {
//       fetch('/')
//         .then(response => response.text())
//         .then(html => {
//           let parser = new DOMParser();
//           let doc = parser.parseFromString(html, 'text/html');
//           console.log("html",doc);
//          // let newCartContent = doc.querySelector('#flo-container').innerHTML;
//          // document.querySelector('#flo-container').innerHTML = newCartContent; // Replace with new cart content
//          let  newCartContent = doc.querySelector('.navlink--cart').innerHTML;
//           document.querySelector('.navlink--cart').innerHTML = newCartContent; // Replace with new cart content
//           // let drawer_cart  = doc.querySelector('#drawer-cart').innerHTML;
//           // console.log("drawer cart",drawer_cart);
//           // document.querySelector('#drawer-cart').innerHTML = drawer_cart;
//           // handleFloCartBtn();
//         });
//     }
function updateMiniCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          refreshCartContents(data);
        });
    }

    function refreshCartContents(cart) {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          detail: { cart },
          bubbles: true
        })
      );
      document.dispatchEvent(
        new CustomEvent('theme:cart:reload', { bubbles: true })
      );
    }

document.addEventListener("DOMContentLoaded", function () {
  /*document.querySelectorAll(".variant_picker_plp").forEach((select) => {
      select.addEventListener("change", function () {
        let form = this.closest(".add-to-cart-form");
        form.setAttribute("data-id", this.value);
      });
    });*/

 /* document.querySelectorAll(".add-to-cart-form label").forEach((button) => {
    button.addEventListener("click", async (event) => {
      const form = event.target.closest(".add-to-cart-form");
      const productId = form.dataset.id;

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: productId, quantity: 1 }),
      });

      if (response.ok) {
        //alert("Added to cart!");
        updateCart(); // Update cart UI
        
        
          updateMiniCart(); // Refresh cart drawer
        
      } else {
        alert("Error adding to cart!");
      }
    });
  });*/
});
$(document).ready(function(){
  set_prod_name_height();
  $(document).on('click','.add-to-cart-form label',async function(){
    const form = $(this).parents(".add-to-cart-form");
    const productId = $(this).parent().find("input").val();
    form.attr("data-id",productId);
     const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: productId, quantity: 1 }),
      });

      if (response.ok) {
        //alert("Added to cart!");
        updateCart(); // Update cart UI
        
        
          updateMiniCart(); // Refresh cart drawer

          $('.header__inner').attr("data-header-cart-full","true");

          $('.plp_atc_wrap').addClass("active");
          $('product-grid-item .product__block__variants').slideUp(300);
          setTimeout(function(){
              $('.plp_atc_wrap').removeClass("active");
          },3000);
        
      } else {
        alert("Error adding to cart!");
      }
  });
  $(document).on('click','product-grid-item .color_product_ul li a',function(){
    image_content = $(this).parent().find(".color_content").html();
    $(this).parents("product-grid-item").find(".image_parent_wrap").html(image_content);
    $(this).parent().parent().find("li").removeClass("active");
    $(this).parent().addClass("active");
    href= $(this).attr("data-href");
    title= $(this).attr("data-title");
    cutline = $(this).attr("data-cutline");
    
    $(this).parents("product-grid-item").find(".product__grid__cutline").text(cutline);
    $(this).parents("product-grid-item").find(".product__grid__info > a").attr("href",href);
    $(this).parents("product-grid-item").find(".product__grid__title").text(title);
  });

  $(document).on('click','.open_plp_atc_wrap',function(){
    $(this).parents('product-grid-item').find('.product__block__variants').slideToggle();
  });
});

$(window).on('load', function () {
    $('radio-swatch > label').css('z-index','1');
  
});

function set_prod_name_height(){
	if($('.product__grid__info .product__grid__title__wrapper').length) {
		
			$('.product__grid__info .product__grid__title__wrapper').css("height", "");
        $('.collection-tabs').each(function(){
          max_h = 0;
        this_item = $(this);
			this_item.find('.product__grid__info .product__grid__title__wrapper').each(function () {
				if ($(this).innerHeight() > max_h) {
					max_h = $(this).innerHeight();
				}
			});
			this_item.find('.product__grid__info .product__grid__title__wrapper').css("height", max_h + "px");
        });
			
		
	}
  if($('.product__grid__info .color_product_ul ').length) {
		
			$('.product__grid__info .color_product_ul').css("height", "");
     $('.collection-tabs').each(function(){
			max_h = 0;
           this_item = $(this);
			this_item.find('.product__grid__info .color_product_ul').each(function () {
				if ($(this).innerHeight() > max_h) {
					max_h = $(this).innerHeight();
				}
			});
			this_item.find('.product__grid__info .color_product_ul').css("height", max_h + "px");
		});
	}
}
